function $parcel$interopDefault(a) {
    return a && a.__esModule ? a.default : a;
}
function $parcel$defineInteropFlag(a) {
    Object.defineProperty(a, '__esModule', {
        value: true,
        configurable: true
    });
}
function $parcel$export(e, n, v, s) {
    Object.defineProperty(e, n, {
        get: v,
        set: s,
        enumerable: true,
        configurable: true
    });
}
var $parcel$global = globalThis;
var parcelRequire = $parcel$global["parcelRequire94c2"];
var parcelRegister = parcelRequire.register;
parcelRegister("i1BaA", function(module, exports) {
    $parcel$defineInteropFlag(module.exports);
    $parcel$export(module.exports, "default", ()=>$b1da029eb75ad95c$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $bjfoJ;
    var $koVbs;
    var $c2JIK;
    var $y8WG5;
    var $e9YVH;
    var $gq0sA;
    var $jLOUq;
    var $4dRjY;
    var $4orJd;
    var $h7sEe;
    const $b1da029eb75ad95c$var$Actions = ()=>{
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        const [{ data: pageContextData }] = (0, (0, parcelRequire("gq0sA")).usePageContext)();
        const { projectContext: projectContext } = pageContextData || {};
        const { projectKey: projectKey } = projectContext || {};
        if (!projectKey) return;
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("bjfoJ")).default), {
            appearance: "primary",
            href: (0, (0, parcelRequire("c2JIK")).createReportUrl)(projectKey, '/custom/new')
        }, formatMessage((0, (0, parcelRequire("4orJd")).default).newReportButton));
    };
    const $b1da029eb75ad95c$var$ReportsHomePage = ()=>{
        const { data: features } = (0, (0, parcelRequire("y8WG5")).useFeatures)();
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("4dRjY")).MarkProductStart), null), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("jLOUq")).default), {
            pageId: "reports-home-page",
            appName: (0, (0, parcelRequire("e9YVH")).APP_NAMES).REPORTS_HOME_PAGE,
            pageTitle: (0, (0, parcelRequire("4orJd")).default).homePageTitle,
            actions: features?.hasReports ? (0, ($parcel$interopDefault($5uXOq))).createElement($b1da029eb75ad95c$var$Actions, null) : undefined
        }, ({ pageContext: pageContext })=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("h7sEe")).default), {
                pageContext: pageContext
            })));
    };
    var $b1da029eb75ad95c$export$2e2bcd8739ae039 = $b1da029eb75ad95c$var$ReportsHomePage;
});
parcelRegister("bjfoJ", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$f7588122d6645d5d$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $aPPLm;
    var $guTo4;
    const $f7588122d6645d5d$var$LinkButtonBase = ({ analyticsContext: analyticsContext, appearance: appearance, 'aria-label': ariaLabel, 'aria-labelledby': ariaLabelledBy, autoFocus: autoFocus, children: children, href: href, iconAfter: iconAfter, iconBefore: iconBefore, interactionName: interactionName, isDisabled: isDisabled, isSelected: isSelected, onClick: onClick, onClickCapture: onClickCapture, onKeyDownCapture: onKeyDownCapture, onKeyUpCapture: onKeyUpCapture, onMouseDownCapture: onMouseDownCapture, onMouseUpCapture: onMouseUpCapture, onPointerDownCapture: onPointerDownCapture, onPointerUpCapture: onPointerUpCapture, onTouchEndCapture: onTouchEndCapture, onTouchStartCapture: onTouchStartCapture, shouldFitContainer: shouldFitContainer, spacing: spacing, testId: testId, ...unsafeRest }, ref)=>{
        const { className: _className, css: _css, as: _as, style: _style, ...saferRest } = unsafeRest;
        const baseProps = (0, (0, parcelRequire("guTo4")).default)({
            analyticsContext: analyticsContext,
            appearance: appearance,
            ariaLabel: ariaLabel,
            ariaLabelledBy: ariaLabelledBy,
            autoFocus: autoFocus,
            buttonType: 'link',
            children: children,
            iconAfter: iconAfter,
            iconBefore: iconBefore,
            interactionName: interactionName,
            isDisabled: isDisabled,
            isSelected: isSelected,
            onClick: onClick,
            onClickCapture: onClickCapture,
            onKeyDownCapture: onKeyDownCapture,
            onKeyUpCapture: onKeyUpCapture,
            onMouseDownCapture: onMouseDownCapture,
            onMouseUpCapture: onMouseUpCapture,
            onPointerDownCapture: onPointerDownCapture,
            onPointerUpCapture: onPointerUpCapture,
            onTouchEndCapture: onTouchEndCapture,
            onTouchStartCapture: onTouchStartCapture,
            ref: ref,
            shouldFitContainer: shouldFitContainer,
            spacing: spacing,
            testId: testId
        });
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("aPPLm")).default), {
            ...saferRest,
            "aria-label": baseProps['aria-label'],
            "aria-labelledby": baseProps['aria-labelledby'],
            ref: baseProps.ref,
            xcss: baseProps.xcss,
            onClick: baseProps.onClick,
            onMouseDownCapture: baseProps.onMouseDownCapture,
            onMouseUpCapture: baseProps.onMouseUpCapture,
            onKeyDownCapture: baseProps.onKeyDownCapture,
            onKeyUpCapture: baseProps.onKeyUpCapture,
            onTouchStartCapture: baseProps.onTouchStartCapture,
            onTouchEndCapture: baseProps.onTouchEndCapture,
            onPointerDownCapture: baseProps.onPointerDownCapture,
            onPointerUpCapture: baseProps.onPointerUpCapture,
            onClickCapture: baseProps.onClickCapture,
            testId: testId,
            href: baseProps.isDisabled ? undefined : href,
            role: baseProps.isDisabled ? 'link' : undefined,
            "aria-disabled": baseProps.isDisabled === true ? true : undefined,
            analyticsContext: analyticsContext,
            interactionName: interactionName,
            componentName: "LinkButton"
        }, baseProps.children);
    };
    const $f7588122d6645d5d$var$WithRef = (0, $5uXOq.forwardRef)($f7588122d6645d5d$var$LinkButtonBase);
    const $f7588122d6645d5d$var$LinkButton = (0, $5uXOq.memo)($f7588122d6645d5d$var$WithRef);
    var $f7588122d6645d5d$export$2e2bcd8739ae039 = $f7588122d6645d5d$var$LinkButton;
});
parcelRegister("c2JIK", function(module, exports) {
    $parcel$export(module.exports, "createReportUrl", ()=>$ff6ef038ac5edc5a$export$58ea1e106226fd1e);
    $parcel$export(module.exports, "useLegacySpaClickHandler", ()=>$ff6ef038ac5edc5a$export$688261d7167cb6e9);
    var $5uXOq = parcelRequire("5uXOq");
    var $6BZYo;
    const $ff6ef038ac5edc5a$export$58ea1e106226fd1e = (projectKey, reportType)=>`${__SPA__ ? '/jira/servicedesk' : ''}/projects/${projectKey}/reports${reportType}`;
    const $ff6ef038ac5edc5a$export$688261d7167cb6e9 = ()=>{
        const pushStateNavigatorRef = (0, $5uXOq.useRef)(null);
        (0, $5uXOq.useEffect)(()=>{
            (0, (0, parcelRequire("6BZYo")).loadBridge)({
                name: 'servicedesk/internal-api/core/util/push-state-navigator/push-state-navigator',
                shouldLogError: false
            }).then((result)=>{
                pushStateNavigatorRef.current = result;
            }).catch(()=>{});
        });
        return (0, $5uXOq.useCallback)((e)=>{
            const href = typeof e.currentTarget.href === 'string' ? e.currentTarget.href : undefined;
            const openInNewTab = e.metaKey === true || e.ctrlKey === true || e.button != null && e.button === 1;
            if (href == null || href === '' || e.defaultPrevented || openInNewTab) return;
            if (pushStateNavigatorRef.current) {
                const willNavigate = pushStateNavigatorRef.current.navigate(href);
                if (willNavigate) e.preventDefault();
            }
        }, []);
    };
});
parcelRegister("y8WG5", function(module, exports) {
    $parcel$export(module.exports, "useFeatures", ()=>$6f07339a74e499dd$export$4a39035bacc4ed76);
    $parcel$export(module.exports, "useReportFeatures", ()=>$6f07339a74e499dd$export$4adaea9828b7ff13);
    $parcel$export(module.exports, "useSettingFeatures", ()=>$6f07339a74e499dd$export$56022a3b83c8ed6a);
    $parcel$export(module.exports, "useTMPSettingFeatures", ()=>$6f07339a74e499dd$export$e8540ab76a479132);
    var $5uXOq = parcelRequire("5uXOq");
    var $aQGK8;
    var $1J3t1;
    var $jIwth;
    var $2tT7R;
    var $kFjc6;
    const $6f07339a74e499dd$export$4a39035bacc4ed76 = (customContext)=>{
        const { data: data, ...rest } = (0, (0, parcelRequire("1J3t1")).useJiraServiceManagementProjectNavigation)(customContext);
        const extractedData = (0, $5uXOq.useMemo)(()=>data && (0, (0, parcelRequire("kFjc6")).extractData)(data), [
            data
        ]);
        return {
            data: extractedData,
            ...rest
        };
    };
    const $6f07339a74e499dd$export$4adaea9828b7ff13 = (customContext)=>{
        const { data: data, ...rest } = (0, (0, parcelRequire("aQGK8")).useJiraServiceManagementReportsNavigation)(customContext);
        const extractedData = (0, $5uXOq.useMemo)(()=>data && (0, (0, parcelRequire("kFjc6")).extractReportData)(data), [
            data
        ]);
        return {
            data: extractedData,
            ...rest
        };
    };
    const $6f07339a74e499dd$export$56022a3b83c8ed6a = (customContext)=>{
        const { data: data, ...rest } = (0, (0, parcelRequire("1J3t1")).useJiraServiceManagementProjectNavigation)(customContext);
        const hasActiveSoftwareAccess = (0, (0, parcelRequire("jIwth")).useHasActiveSoftwareAccess)();
        const environment = (0, (0, parcelRequire("2tT7R")).useEnvironment)();
        const extractedData = (0, $5uXOq.useMemo)(()=>data && (0, (0, parcelRequire("kFjc6")).extractSettingData)(data, {
                hasActiveSoftwareAccess: hasActiveSoftwareAccess,
                environment: environment
            }), [
            data,
            environment,
            hasActiveSoftwareAccess
        ]);
        return {
            data: extractedData,
            ...rest
        };
    };
    const $6f07339a74e499dd$export$e8540ab76a479132 = ()=>{
        const { data: data, ...rest } = (0, (0, parcelRequire("1J3t1")).useJiraServiceManagementProjectNavigation)();
        const extractedData = (0, $5uXOq.useMemo)(()=>data && (0, (0, parcelRequire("kFjc6")).extractTMPSettingData)(data), [
            data
        ]);
        return {
            data: extractedData,
            ...rest
        };
    };
});
parcelRegister("aQGK8", function(module, exports) {
    $parcel$export(module.exports, "useJiraServiceManagementReportsNavigation", ()=>$8d8e651293539c9e$export$6d172fb6aa6b6b5b);
    var $gS5PF;
    var $324W5;
    const $8d8e651293539c9e$export$6d172fb6aa6b6b5b = (customContext)=>(0, (0, parcelRequire("324W5")).useResourceWithCustomRouterContext)((0, (0, parcelRequire("gS5PF")).staticSidebarJsmReportsResource), customContext);
});
parcelRegister("kFjc6", function(module, exports) {
    $parcel$export(module.exports, "extractData", ()=>$d21447ab73114105$export$9df5fa0a366163d2);
    $parcel$export(module.exports, "extractReportData", ()=>$d21447ab73114105$export$86f3b0e5fff6482e);
    $parcel$export(module.exports, "extractSettingData", ()=>$d21447ab73114105$export$a1d86e289d0f43b7);
    $parcel$export(module.exports, "extractTMPSettingData", ()=>$d21447ab73114105$export$d334c13580163a89);
    var $4R6GH;
    const $d21447ab73114105$export$9df5fa0a366163d2 = (navData)=>{
        const { project: project, permissionInfo: permissionInfo, isAgent: isAgent, hasCustomerChannels: hasCustomerChannels, knowledgeBaseInfo: knowledgeBaseInfo, raiseRequestInfo: raiseRequestInfo, opsGenieInfo: opsGenieInfo, projectSummaryInfo: projectSummaryInfo, boardInfo: boardInfo, calendarInfo: calendarInfo, hasNotificationLogs: hasNotificationLogs = true, hasHelpCenterSettings: hasHelpCenterSettings = false } = navData;
        const { isAdmin: isAdmin, projectPermissionsQueried: projectPermissionsQueried } = permissionInfo;
        const { isOnCallEnabled: isOnCallEnabled, isAlertEnabled: isAlertEnabled, opsGenieBaseUrl: opsGenieBaseUrl } = opsGenieInfo;
        const isProjectOrJiraAdmin = isAdmin || projectPermissionsQueried.ADMINISTER_PROJECTS === true;
        const { portalUrl: portalUrl } = raiseRequestInfo;
        return {
            hasQueues: isAgent,
            hasCustomers: isAgent,
            hasCustomerChannels: hasCustomerChannels,
            hasReports: isAgent,
            hasPIN: !isAgent,
            hasShortcutsAdd: isProjectOrJiraAdmin,
            hasSettings: isProjectOrJiraAdmin,
            knowledge: {
                enabled: knowledgeBaseInfo.enabled,
                type: knowledgeBaseInfo.enabled ? knowledgeBaseInfo.knowledgeBaseType : null
            },
            raiseRequest: {
                enabled: raiseRequestInfo.enabled,
                url: raiseRequestInfo.enabled ? portalUrl : ''
            },
            opsgenieAlert: {
                enabled: isAlertEnabled,
                url: isAlertEnabled ? `${opsGenieBaseUrl}/alert/list` : ''
            },
            opsgenieOnCall: {
                enabled: isOnCallEnabled,
                url: isOnCallEnabled ? `${opsGenieBaseUrl}/schedule/whoIsOnCall` : ''
            },
            hasProjectSummary: (0, (0, parcelRequire("4R6GH")).fg)('jsm-project-summary-beta') ? !!projectSummaryInfo?.enabled : false,
            jsmBoard: {
                enabled: boardInfo.enabled,
                url: `/jira/servicedesk/projects/${project.key}/boards/${boardInfo.board.id}`
            },
            jsmCalendar: {
                enabled: calendarInfo?.enabled ?? false,
                url: `/jira/servicedesk/projects/${project.key}/boards/${boardInfo.board.id}/calendar`
            },
            hasNotificationLogs: (0, (0, parcelRequire("4R6GH")).fg)('jcs_master_flag') ? hasNotificationLogs : true,
            hasHelpCenterSettings: (0, (0, parcelRequire("4R6GH")).fg)('jcs_master_flag') ? isProjectOrJiraAdmin && hasHelpCenterSettings : false
        };
    };
    const $d21447ab73114105$export$86f3b0e5fff6482e = (data)=>({
            hasWorkload: true,
            hasSatisfaction: data.hasSatisfactionReport,
            hasRequestsDeflected: data.hasRequestsDeflectedReport,
            hasRequestsResolved: data.hasRequestsResolvedReport,
            hasNewReport: data.hasNewReport,
            hasManageReport: false
        });
    const $d21447ab73114105$export$a1d86e289d0f43b7 = (navData, { hasActiveSoftwareAccess: hasActiveSoftwareAccess, environment: environment })=>{
        const { permissionInfo: permissionInfo, settingsInfo: settingsInfo } = navData;
        const { hasChangeManagement: hasChangeManagement = false, hasAddonInstaller: hasAddonInstaller = false, hasIncidentManagement: hasIncidentManagement = false, hasExternalLinks: hasExternalLinks = false, hasProjectAutomation: hasProjectAutomation = false, hasWidgetAddon: hasWidgetAddon = false, hasChat: hasChat = true, hasServices: hasServices = false, hasVersions: hasVersions = true, hasComponents: hasComponents = true, hasCustomerSupportManagement: hasCustomerSupportManagement = false, hasProductsAndEntitlements: hasProductsAndEntitlements = false, hasDeveloperEscalation: hasDeveloperEscalation = false, hasVirtualAgent: hasVirtualAgent = true, hasLanguageSupport: hasLanguageSupport = true, hasRequestTypes: hasRequestTypes = true, hasPortalSettings: hasPortalSettings = true, hasCustomerNotifications: hasCustomerNotifications = true, hasCustomerPermissions: hasCustomerPermissions = true, hasForms: hasForms = true, hasKnowledgeBase: hasKnowledgeBase = true } = settingsInfo;
        const { isAdmin: isAdmin, projectPermissionsQueried: projectPermissionsQueried } = permissionInfo;
        const isProjectAdmin = projectPermissionsQueried.ADMINISTER_PROJECTS === true;
        const isProjectOrJiraAdmin = isAdmin || isProjectAdmin;
        const hasIssueLayoutPermissions = permissionInfo.projectPermissionsQueried.EDIT_ISSUE_LAYOUT === true;
        return {
            hasDetails: isProjectOrJiraAdmin,
            hasPeople: isProjectOrJiraAdmin,
            hasSummary: true,
            hasIssueLayout: isProjectOrJiraAdmin || hasIssueLayoutPermissions,
            hasIssueTypes: isProjectOrJiraAdmin,
            hasJsdChangeManagement: hasChangeManagement,
            hasRequestTypes: (0, (0, parcelRequire("4R6GH")).fg)('jcs_master_flag') ? hasRequestTypes : true,
            hasCustomerPermissions: (0, (0, parcelRequire("4R6GH")).fg)('jcs_master_flag') ? hasCustomerPermissions : true,
            hasPortalSettings: (0, (0, parcelRequire("4R6GH")).fg)('jcs_master_flag') ? hasPortalSettings : true,
            hasCustomerNotifications: (0, (0, parcelRequire("4R6GH")).fg)('jcs_master_flag') ? hasCustomerNotifications : true,
            hasAddonInstaller: hasAddonInstaller,
            hasWidgetAddon: hasWidgetAddon && environment === 'prod',
            hasWidgetAddonDev: hasWidgetAddon && environment !== 'prod',
            hasChat: hasChat,
            hasKnowledgeBase: (0, (0, parcelRequire("4R6GH")).fg)('jcs_master_flag') ? hasKnowledgeBase : true,
            hasSla: true,
            hasLegacyJSMAutomation: true,
            hasJsdAppDiscovery: true,
            hasJsdIncidentManagement: hasIncidentManagement,
            hasWorkflows: true,
            hasVersions: hasVersions,
            hasComponents: hasComponents,
            hasPermissions: true,
            hasIssueSecurity: true,
            hasNotifications: true,
            hasIssueCollectors: true,
            hasProjectAutomation: hasProjectAutomation,
            hasDevtools: hasActiveSoftwareAccess && isProjectAdmin,
            hasExternalLinks: hasExternalLinks,
            hasServices: hasServices,
            hasCustomerSupportManagement: hasCustomerSupportManagement,
            hasProductsAndEntitlements: hasProductsAndEntitlements,
            hasDeveloperEscalation: hasDeveloperEscalation,
            hasVirtualAgent: (0, (0, parcelRequire("4R6GH")).fg)('jcs_master_flag') ? hasVirtualAgent : true,
            hasLanguageSupport: (0, (0, parcelRequire("4R6GH")).fg)('jcs_master_flag') ? hasLanguageSupport : true,
            hasForms: (0, (0, parcelRequire("4R6GH")).fg)('jcs_master_flag') ? hasForms : true,
            hasFields: isProjectOrJiraAdmin
        };
    };
    const $d21447ab73114105$export$d334c13580163a89 = (navData)=>{
        let hasFields = false;
        if ((0, (0, parcelRequire("4R6GH")).fg)('project_fields_page_for_tmp_-_mvp')) {
            const { permissionInfo: permissionInfo, hasExplicitFieldAssociationsEnabled: hasExplicitFieldAssociationsEnabled = false } = navData;
            const { isAdmin: isAdmin, projectPermissionsQueried: projectPermissionsQueried } = permissionInfo;
            const isProjectAdmin = projectPermissionsQueried.ADMINISTER_PROJECTS === true;
            const isProjectOrJiraAdmin = isAdmin || isProjectAdmin;
            hasFields = isProjectOrJiraAdmin && hasExplicitFieldAssociationsEnabled;
        }
        return {
            hasExternalLinks: navData?.settingsInfo?.hasExternalLinks,
            hasChat: navData?.settingsInfo?.hasChat,
            hasFields: hasFields
        };
    };
});
parcelRegister("gq0sA", function(module, exports) {
    $parcel$export(module.exports, "usePageContext", ()=>$2299d7a4f1092420$export$9c25024bdfe755f7);
    var $5uXOq = parcelRequire("5uXOq");
    var $324W5;
    var $dxCvy;
    var $9OXo1;
    var $dFOAR;
    const $2299d7a4f1092420$var$getProjectContextResource = ()=>(0, (0, parcelRequire("dxCvy")).projectContextResourceWithCache);
    const $2299d7a4f1092420$export$9c25024bdfe755f7 = (customContext)=>{
        const tenantContext = (0, (0, parcelRequire("9OXo1")).useTenantContext)();
        const { data: projectContext, loading: projectContextLoading, error: projectContextError } = (0, (0, parcelRequire("324W5")).useResourceWithCustomRouterContext)($2299d7a4f1092420$var$getProjectContextResource(), customContext);
        const [{ data: serviceDeskContext, loading: serviceDeskLoading, error: serviceDeskError }] = (0, (0, parcelRequire("dFOAR")).useServiceDeskContext)(projectContext?.projectKey || undefined, customContext);
        const pageContextData = (0, $5uXOq.useMemo)(()=>({
                data: projectContext && serviceDeskContext ? {
                    serviceDeskContext: {
                        portalId: serviceDeskContext.portalId,
                        portalUrl: serviceDeskContext.portalUrl,
                        canSeeNewIssueView: serviceDeskContext.canSeeNewIssueView,
                        userRole: serviceDeskContext.userRole,
                        serviceDeskId: serviceDeskContext.serviceDeskId
                    },
                    projectContext: {
                        projectId: projectContext.projectId,
                        projectKey: projectContext.projectKey,
                        projectName: projectContext.projectName,
                        projectType: projectContext.projectType,
                        isAdmin: projectContext.isProjectAdmin || tenantContext.isAdmin,
                        isProjectSimplified: projectContext.simplified
                    },
                    tenantContext: {
                        baseUrl: tenantContext.baseUrl,
                        locale: tenantContext.locale,
                        userFullname: tenantContext.userFullname,
                        cloudId: tenantContext.cloudId,
                        fabricPfDirUrl: tenantContext.fabricPfDirUrl,
                        atlassianAccountId: tenantContext.atlassianAccountId,
                        isJiraAdmin: tenantContext.isAdmin,
                        isSiteAdmin: tenantContext.isSiteAdmin,
                        activationId: tenantContext.activationId
                    }
                } : null,
                loading: projectContextLoading || serviceDeskLoading,
                error: serviceDeskError || projectContextError || null
            }), [
            tenantContext,
            projectContext,
            serviceDeskContext,
            projectContextLoading,
            serviceDeskLoading,
            serviceDeskError,
            projectContextError
        ]);
        return [
            pageContextData
        ];
    };
});
parcelRegister("dFOAR", function(module, exports) {
    $parcel$export(module.exports, "useServiceDeskContext", ()=>$6c09349e97fba749$export$712ead87353ac687);
    var $5uXOq = parcelRequire("5uXOq");
    var $324W5;
    var $cAofY;
    const $6c09349e97fba749$var$getServiceDeskContextResource = ()=>(0, (0, parcelRequire("cAofY")).serviceDeskContextResource);
    const $6c09349e97fba749$export$712ead87353ac687 = (projectKey, customContext)=>{
        const { data: data, loading: loading, error: error, refresh: refreshCache } = (0, (0, parcelRequire("324W5")).useResourceWithCustomRouterContext)($6c09349e97fba749$var$getServiceDeskContextResource(), customContext);
        (0, $5uXOq.useEffect)(()=>{
            if (!false) refreshCache();
        }, [
            projectKey,
            refreshCache
        ]);
        return [
            {
                data: data,
                loading: loading,
                error: error
            }
        ];
    };
});
parcelRegister("jLOUq", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$bcf67f44913f9c86$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $6Ll2T;
    var $99gde;
    var $jD5no;
    var $81ps3;
    var $koVbs;
    var $3HwlS;
    var $9noxX;
    var $aLLc7;
    var $cf7yQ;
    var $e33py;
    var $8pMQX;
    var $gq0sA;
    var $4S0uJ;
    var $cz40O;
    var $fP2yI;
    var $doZTA;
    var $1BIUA;
    var $cHb7s;
    var $gMO5K;
    const $bcf67f44913f9c86$var$ReportsAppBase = ({ appName: appName, pageId: pageId, pageTitle: pageTitle, children: children, AppBase: AppBase, ErrorView: ErrorView, PageStyle: PageStyle, actions: actions, dontShowHeader: dontShowHeader = false })=>{
        const [{ match: match }] = (0, (0, parcelRequire("doZTA")).useRouter)();
        const [{ data: pageContextData, error: error }] = (0, (0, parcelRequire("gq0sA")).usePageContext)();
        const { tenantContext: tenantContext, projectContext: projectContext, serviceDeskContext: serviceDeskContext } = pageContextData || {};
        const { projectKey: projectKey, projectName: projectName } = projectContext || {};
        const { baseUrl: baseUrl } = tenantContext || {};
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        const pageContextProps = (0, $5uXOq.useMemo)(()=>({
                ...tenantContext,
                ...projectContext,
                ...serviceDeskContext
            }), [
            projectContext,
            serviceDeskContext,
            tenantContext
        ]);
        const breadcrumbs = [
            {
                href: '/jira/projects',
                text: formatMessage((0, (0, parcelRequire("gMO5K")).default).projectsBreadcrumb)
            },
            {
                href: (0, (0, parcelRequire("81ps3")).createProjectUrl)(projectKey || ''),
                text: projectName || ''
            },
            {
                href: `${baseUrl}/jira/servicedesk/projects/${projectKey}/reports`,
                text: formatMessage((0, (0, parcelRequire("gMO5K")).default).reportsBreadcrumb)
            }
        ];
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("cz40O")).SpaPageWrapper), {
            pageId: pageId,
            baseUrl: baseUrl,
            currentUrl: match.url,
            projectContext: projectContext,
            isLoading: !pageContextData && !error,
            error: error
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("e33py")).ServiceDeskDocumentTitle), {
            projectName: projectName,
            section: "reports"
        }), (0, ($parcel$interopDefault($5uXOq))).createElement(AppBase, {
            id: pageId
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("9noxX")).ServiceDeskAnalyticsContext), null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("aLLc7")).ServiceDeskErrorBoundary), {
            appName: appName,
            ErrorView: ErrorView
        }, !dontShowHeader && ((0, (0, parcelRequire("3HwlS")).getWillShowNav4)() ? (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("fP2yI")).Header), {
            title: pageTitle ? formatMessage(pageTitle) : '',
            breadcrumbs: breadcrumbs,
            actions: actions
        })) : (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("6Ll2T")).default), {
            xcss: $bcf67f44913f9c86$var$HeaderContainer
        }, (0, ($parcel$interopDefault($5uXOq))).createElement(PageStyle, null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("cHb7s")).default), {
            breadcrumbs: (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("1BIUA")).default), {
                baseUrl: baseUrl,
                projectKey: projectKey,
                projectName: projectName
            }),
            title: pageTitle,
            actions: actions
        })))), (0, ($parcel$interopDefault($5uXOq))).createElement(PageStyle, null, children({
            pageContext: pageContextProps
        })))))), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("cf7yQ")).JsdGettingStartedPanelShouldRender), null));
    };
    const $bcf67f44913f9c86$var$HeaderContainer = (0, (0, parcelRequire("99gde")).xcss)({
        paddingBottom: 'space.200'
    });
    $bcf67f44913f9c86$var$ReportsAppBase.defaultProps = {
        AppBase: (0, (0, parcelRequire("jD5no")).default),
        ErrorView: (0, (0, parcelRequire("8pMQX")).GenericError),
        PageStyle: (0, (0, parcelRequire("4S0uJ")).PageStyle)
    };
    var $bcf67f44913f9c86$export$2e2bcd8739ae039 = $bcf67f44913f9c86$var$ReportsAppBase;
});
parcelRegister("aLLc7", function(module, exports) {
    $parcel$export(module.exports, "ServiceDeskErrorBoundary", ()=>$8803d19bf51a79cd$export$d999c9325a45f4cf);
    var $5uXOq = parcelRequire("5uXOq");
    var $jcw0u;
    var $e9YVH;
    const $8803d19bf51a79cd$var$triggerAnalyticsEvent = (_appName)=>(_eventNameSuffix, _eventData)=>Promise.resolve(undefined);
    const $8803d19bf51a79cd$var$toErrorOrUndefined = (error)=>{
        if (error instanceof Error) return error;
        if (typeof error === 'string') return new Error(error);
        return undefined;
    };
    class $8803d19bf51a79cd$export$d999c9325a45f4cf extends (0, $5uXOq.Component) {
        static getDerivedStateFromError() {
            return {
                hasError: true
            };
        }
        constructor(props){
            super(props);
            this.state = {
                hasError: false
            };
            this.triggerEvent = $8803d19bf51a79cd$var$triggerAnalyticsEvent(`${props.appName}`);
        }
        componentDidCatch(error) {
            const { onErrorHandler: onErrorHandler, ErrorView: ErrorView, appName: appName } = this.props;
            const data = error instanceof Error ? {
                message: error.message,
                stack: error.stack
            } : {
                message: error
            };
            this.triggerEvent('error-boundary.error-caught', data);
            (0, (0, parcelRequire("jcw0u")).default)({
                meta: {
                    id: 'unhandled',
                    packageName: (0, (0, parcelRequire("e9YVH")).toPackageName)(appName) || 'jiraServicedeskCommon'
                },
                event: this.triggerEvent,
                error: $8803d19bf51a79cd$var$toErrorOrUndefined(error),
                sendToPrivacyUnsafeSplunk: true
            });
            if (ErrorView) return;
            if (onErrorHandler) onErrorHandler(error);
            else throw error;
        }
        render() {
            const { hasError: hasError } = this.state;
            const { ErrorView: ErrorView, children: children } = this.props;
            if (hasError && ErrorView) return (0, ($parcel$interopDefault($5uXOq))).createElement(ErrorView, null);
            return children;
        }
    }
});
parcelRegister("cf7yQ", function(module, exports) {
    $parcel$export(module.exports, "JsdGettingStartedPanelShouldRender", ()=>$8aa55ef5824c4e4d$export$46976e0f90edfcfe);
    $parcel$export(module.exports, "JsdGettingStartedPanel", ()=>$8aa55ef5824c4e4d$export$6f9913539cfb4ab6);
    $parcel$export(module.exports, "JsdGettingStartedPanelOpenButton", ()=>$8aa55ef5824c4e4d$export$4cb23b2c31a1b2ad);
    $parcel$export(module.exports, "JsdGettingStartedPanelReopenSpotlight", ()=>$8aa55ef5824c4e4d$export$c7732c55900cf0b9);
    var $5uXOq = parcelRequire("5uXOq");
    var $lfTZh;
    var $1jUsD;
    const $8aa55ef5824c4e4d$var$AsyncGettingStartedPanelShouldRender = (0, (0, parcelRequire("1jUsD")).lazyAfterPaint)(()=>(parcelRequire("3kACf")).then(({ JsdGettingStartedPanelShouldRender: JsdGettingStartedPanelShouldRender })=>JsdGettingStartedPanelShouldRender), {
        moduleId: "./src/packages/servicedesk/getting-started-panel/src/ui/should-render/async.tsx"
    });
    const $8aa55ef5824c4e4d$var$AsyncGettingStartedPanel = (0, (0, parcelRequire("1jUsD")).lazyAfterPaint)(()=>(parcelRequire("CFRIm")).then(({ JsdGettingStartedPanel: JsdGettingStartedPanel })=>JsdGettingStartedPanel), {
        moduleId: "./src/packages/servicedesk/getting-started-panel/src/ui/panel/async.tsx"
    });
    const $8aa55ef5824c4e4d$var$AsyncGettingStartedPanelOpenButton = (0, (0, parcelRequire("1jUsD")).lazyAfterPaint)(()=>(parcelRequire("hnw8Z")).then(({ JsdGettingStartedPanelOpenButton: JsdGettingStartedPanelOpenButton })=>JsdGettingStartedPanelOpenButton), {
        moduleId: "./src/packages/servicedesk/getting-started-panel/src/ui/open-button/async.tsx"
    });
    const $8aa55ef5824c4e4d$var$AsyncGettingStartedPanelReopenSpotlight = (0, (0, parcelRequire("1jUsD")).lazyAfterPaint)(()=>(parcelRequire("7opQ6")).then(({ JsdGettingStartedPanelReopenSpotlight: JsdGettingStartedPanelReopenSpotlight })=>JsdGettingStartedPanelReopenSpotlight), {
        moduleId: "./src/packages/servicedesk/getting-started-panel/src/ui/reopen-spotlight/async.tsx"
    });
    const $8aa55ef5824c4e4d$export$46976e0f90edfcfe = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("lfTZh")).default), {
            name: "jsm-getting-started-panel-async-should-render",
            fallback: null
        }, (0, ($parcel$interopDefault($5uXOq))).createElement($8aa55ef5824c4e4d$var$AsyncGettingStartedPanelShouldRender, null));
    $8aa55ef5824c4e4d$export$46976e0f90edfcfe.displayName = 'AsyncJsdGettingStartedPanelShouldRender';
    const $8aa55ef5824c4e4d$export$6f9913539cfb4ab6 = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("lfTZh")).default), {
            name: "jsm-getting-started-panel-async-panel",
            fallback: null
        }, (0, ($parcel$interopDefault($5uXOq))).createElement($8aa55ef5824c4e4d$var$AsyncGettingStartedPanel, null));
    $8aa55ef5824c4e4d$export$6f9913539cfb4ab6.displayName = 'AsyncJsdGettingStartedPanel';
    const $8aa55ef5824c4e4d$export$4cb23b2c31a1b2ad = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("lfTZh")).default), {
            name: "jsm-getting-started-panel-async-open-button",
            fallback: null
        }, (0, ($parcel$interopDefault($5uXOq))).createElement($8aa55ef5824c4e4d$var$AsyncGettingStartedPanelOpenButton, null));
    $8aa55ef5824c4e4d$export$4cb23b2c31a1b2ad.displayName = 'AsyncJsdGettingStartedPanelOpenButton';
    const $8aa55ef5824c4e4d$export$c7732c55900cf0b9 = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("lfTZh")).default), {
            name: "jsm-getting-started-panel-async-reopen-spotlight",
            fallback: null
        }, (0, ($parcel$interopDefault($5uXOq))).createElement($8aa55ef5824c4e4d$var$AsyncGettingStartedPanelReopenSpotlight, null));
    $8aa55ef5824c4e4d$export$c7732c55900cf0b9.displayName = 'AsyncJsdGettingStartedPanelReopenSpotlight';
});
parcelRegister("3kACf", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("eNmuD"),
        $6fhBS("chQyv")
    ]).then(()=>parcelRequire('hZyYK'));
});
parcelRegister("CFRIm", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("eNmuD"),
        $6fhBS("cM9em"),
        $6fhBS("fr9NE"),
        $6fhBS("3Xgpx")
    ]).then(()=>parcelRequire('2NciN'));
});
parcelRegister("hnw8Z", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("eNmuD"),
        $6fhBS("cM9em"),
        $6fhBS("fr9NE"),
        $6fhBS("hlGg7")
    ]).then(()=>parcelRequire('4F6ZA'));
});
parcelRegister("7opQ6", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("eNmuD"),
        $6fhBS("cM9em"),
        $6fhBS("fr9NE"),
        $6fhBS("eXDqW")
    ]).then(()=>parcelRequire('6Wput'));
});
parcelRegister("e33py", function(module, exports) {
    $parcel$export(module.exports, "PageTitle", ()=>$ae40b537a934bf9c$export$155581e8dc02007a);
    $parcel$export(module.exports, "ServiceDeskDocumentTitle", ()=>$ae40b537a934bf9c$export$c7841d2c1c13065e);
    var $5uXOq = parcelRequire("5uXOq");
    var $9sGI6;
    var $ew1Lk;
    var $koVbs;
    var $2BHCj;
    const $ae40b537a934bf9c$export$155581e8dc02007a = (props)=>{
        const { DocumentTitle: DocumentTitle, section: section, projectName: projectName, subsection: subsection } = props;
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        const title = subsection ? `${projectName} - ${formatMessage((0, (0, parcelRequire("2BHCj")).default)[section])} - ${subsection} - ${formatMessage((0, (0, parcelRequire("2BHCj")).default).serviceProject)}` : `${projectName} - ${formatMessage((0, (0, parcelRequire("2BHCj")).default)[section])} - ${formatMessage((0, (0, parcelRequire("2BHCj")).default).serviceProject)}`;
        return (0, ($parcel$interopDefault($5uXOq))).createElement(DocumentTitle, {
            title: title
        });
    };
    const $ae40b537a934bf9c$export$c7841d2c1c13065e = (0, (0, parcelRequire("9sGI6")).default)($ae40b537a934bf9c$export$155581e8dc02007a, {
        DocumentTitle: (0, (0, parcelRequire("ew1Lk")).DocumentTitle)
    });
    var $ae40b537a934bf9c$export$2e2bcd8739ae039 = $ae40b537a934bf9c$export$c7841d2c1c13065e;
});
parcelRegister("ew1Lk", function(module, exports) {
    $parcel$export(module.exports, "DocumentTitle", ()=>$41b549fa18234081$export$dd5ad0b65cf665da);
    var $5uXOq = parcelRequire("5uXOq");
    var $6nkVm;
    class $41b549fa18234081$export$dd5ad0b65cf665da extends (0, $5uXOq.Component) {
        static{
            this.defaultProps = {
                TitleSubscriber: (0, (0, parcelRequire("6nkVm")).DocumentTitleSubscriber)
            };
        }
        shouldComponentUpdate(nextProps) {
            return nextProps.title !== this.props.title;
        }
        render() {
            const { title: title, TitleSubscriber: TitleSubscriber } = this.props;
            return (0, ($parcel$interopDefault($5uXOq))).createElement(TitleSubscriber, null, ({ contextArray: contextArray }, { setTitle: setTitle, addDocumentTitle: addDocumentTitle, removeDocumentTitle: removeDocumentTitle })=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("6nkVm")).DocumentTitleHelper), {
                    title: title,
                    setTitle: setTitle,
                    addDocumentTitle: addDocumentTitle,
                    contextArray: contextArray,
                    removeDocumentTitle: removeDocumentTitle,
                    TitleSubscriber: TitleSubscriber
                }));
        }
    }
});
parcelRegister("2BHCj", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$7d7eb5ce3479323e$export$2e2bcd8739ae039);
    var $7VHMR;
    var $7d7eb5ce3479323e$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        atlassianAnalytics: {
            "id": "servicedesk-spa-commons.common.utils.document-title.atlassian-analytics",
            "defaultMessage": "Atlassian Analytics"
        },
        serviceProject: {
            "id": "servicedesk-spa-commons.common.utils.document-title.service-project",
            "defaultMessage": "Service project"
        },
        knowledge: {
            "id": "servicedesk-spa-commons.common.utils.document-title.knowledge",
            "defaultMessage": "Knowledge base"
        },
        itsmFeatures: {
            "id": "servicedesk-spa-commons.common.utils.document-title.itsm-features",
            "defaultMessage": "Features"
        },
        queues: {
            "id": "servicedesk-spa-commons.common.utils.document-title.queues",
            "defaultMessage": "Queues"
        },
        customers: {
            "id": "servicedesk-spa-commons.common.utils.document-title.customers",
            "defaultMessage": "Customers"
        },
        organizations: {
            "id": "servicedesk-spa-commons.common.utils.document-title.organizations",
            "defaultMessage": "Organizations"
        },
        customerServiceEscalations: {
            "id": "servicedesk-spa-commons.common.utils.document-title.customer-service-escalations",
            "defaultMessage": "Developer escalations"
        },
        reports: {
            "id": "servicedesk-spa-commons.common.utils.document-title.reports",
            "defaultMessage": "Reports"
        },
        services: {
            "id": "servicedesk-spa-commons.common.utils.document-title.services",
            "defaultMessage": "Services"
        },
        oncall: {
            "id": "servicedesk-spa-commons.common.utils.document-title.oncall",
            "defaultMessage": "On-call"
        },
        email: {
            "id": "servicedesk-spa-commons.common.utils.document-title.email",
            "defaultMessage": "Email request"
        },
        sla: {
            "id": "servicedesk-spa-commons.common.utils.document-title.sla",
            "defaultMessage": "Service level agreements"
        },
        csat: {
            "id": "servicedesk-spa-commons.common.utils.document-title.csat",
            "defaultMessage": "Customer satisfaction"
        },
        details: {
            "id": "servicedesk-spa-commons.common.utils.document-title.details",
            "defaultMessage": "Details"
        },
        portal: {
            "id": "servicedesk-spa-commons.common.utils.document-title.portal",
            "defaultMessage": "Customer portal"
        },
        externalLinks: {
            "id": "servicedesk-spa-commons.common.utils.document-title.external-links",
            "defaultMessage": "External resources"
        },
        portalSettings: {
            "id": "servicedesk-spa-commons.common.utils.document-title.portal-settings",
            "defaultMessage": "Portal settings"
        },
        automation: {
            "id": "servicedesk-spa-commons.common.utils.document-title.automation",
            "defaultMessage": "Automation"
        },
        advanced: {
            "id": "servicedesk-spa-commons.common.utils.document-title.advanced",
            "defaultMessage": "Advanced"
        },
        languageSupport: {
            "id": "servicedesk-spa-commons.common.utils.document-title.language-support",
            "defaultMessage": "Language support"
        },
        languageTranslations: {
            "id": "servicedesk-spa-commons.common.utils.document-title.language-translations",
            "defaultMessage": "Language translations"
        },
        notificationEmail: {
            "id": "servicedesk-spa-commons.common.utils.document-title.notification-email",
            "defaultMessage": "Notification email"
        },
        notifications: {
            "id": "servicedesk-spa-commons.common.utils.document-title.notifications",
            "defaultMessage": "Notifications"
        },
        internalNotifications: {
            "id": "servicedesk-spa-commons.common.utils.document-title.internal-notifications",
            "defaultMessage": "Internal notifications"
        },
        customerNotifications: {
            "id": "servicedesk-spa-commons.common.utils.document-title.customer-notifications",
            "defaultMessage": "Customer notifications"
        },
        widget: {
            "id": "servicedesk-spa-commons.common.utils.document-title.widget",
            "defaultMessage": "Widget"
        },
        customerPermissions: {
            "id": "servicedesk-spa-commons.common.utils.document-title.customer-permissions",
            "defaultMessage": "Customer permissions"
        },
        people: {
            "id": "servicedesk-spa-commons.common.utils.document-title.people",
            "defaultMessage": "Internal access"
        },
        issueType: {
            "id": "servicedesk-spa-commons.common.utils.document-title.issue-type",
            "defaultMessage": "Request types"
        },
        connectAppControls: {
            "id": "servicedesk-spa-commons.common.utils.document-title.connect-app-controls",
            "defaultMessage": "Apps"
        },
        features: {
            "id": "servicedesk-spa-commons.common.utils.document-title.features",
            "defaultMessage": "Features"
        },
        calendar: {
            "id": "servicedesk-spa-commons.common.utils.document-title.calendar",
            "defaultMessage": "Calendar"
        },
        projectSummary: {
            "id": "servicedesk-spa-commons.common.utils.document-title.project-summary",
            "defaultMessage": "Summary"
        },
        changeCalendar: {
            "id": "servicedesk-spa-commons.common.utils.document-title.change-calendar",
            "defaultMessage": "Change calendar"
        },
        changeManagementSettings: {
            "id": "servicedesk-spa-commons.common.utils.document-title.change-management-settings",
            "defaultMessage": "Change management"
        },
        incidentManagementSettings: {
            "id": "servicedesk-spa-commons.common.utils.document-title.incident-management-settings",
            "defaultMessage": "Incident management"
        },
        virtualAgentConversations: {
            "id": "servicedesk-spa-commons.common.utils.document-title.virtual-agent-conversations",
            "defaultMessage": "Conversations"
        },
        virtualAgentIntents: {
            "id": "servicedesk-spa-commons.common.utils.document-title.virtual-agent-intents",
            "defaultMessage": "Intents"
        },
        virtualAgentStandardFlows: {
            "id": "servicedesk-spa-commons.common.utils.document-title.virtual-agent-standard-flows",
            "defaultMessage": "Standard flows"
        },
        virtualAgentSettings: {
            "id": "servicedesk-spa-commons.common.utils.document-title.virtual-agent-settings",
            "defaultMessage": "Settings"
        },
        virtualAgentLanding: {
            "id": "servicedesk-spa-commons.common.utils.document-title.virtual-agent-landing",
            "defaultMessage": "Virtual agent"
        },
        chat: {
            "id": "servicedesk-spa-commons.common.utils.document-title.chat",
            "defaultMessage": "Chat"
        },
        proformaForms: {
            "id": "servicedesk-spa-commons.common.utils.document-title.proforma-forms",
            "defaultMessage": "Forms"
        },
        playbooks: {
            "id": "servicedesk-spa-commons.common.utils.document-title.playbooks-non-final",
            "defaultMessage": "Playbooks"
        },
        dataClassifications: {
            "id": "servicedesk-spa-commons.common.utils.document-title.data-classifications",
            "defaultMessage": "Data classification"
        },
        fieldsNonFinal: {
            "id": "servicedesk-spa-commons.common.utils.document-title.fields-non-final",
            "defaultMessage": "Fields"
        },
        workflowScheme: {
            "id": "servicedesk-spa-commons.common.utils.document-title.workflow-scheme",
            "defaultMessage": "Workflows"
        },
        journeysNonFinal: {
            "id": "servicedesk-spa-commons.common.utils.document-title.journeys-non-final",
            "defaultMessage": "Journeys"
        },
        journeyConfigNonFinal: {
            "id": "servicedesk-spa-commons.common.utils.document-title.journey-config-non-final",
            "defaultMessage": "Journey configuration"
        },
        helpCenterForms: {
            "id": "servicedesk-spa-commons.common.utils.document-title.helpcenter-forms",
            "defaultMessage": "Forms"
        },
        virtualAgentAiAnswers: {
            "id": "servicedesk-spa-commons.common.utils.document-title.ai-answers",
            "defaultMessage": "Atlassian Intelligence answers"
        }
    });
});
parcelRegister("8pMQX", function(module, exports) {
    $parcel$export(module.exports, "ProjectNotFound", ()=>$951f6bd200bf8b89$export$849d319c342682a2);
    $parcel$export(module.exports, "GenericError", ()=>$951f6bd200bf8b89$export$7d465be8efa67280);
    var $5uXOq = parcelRequire("5uXOq");
    var $2oKQq;
    var $6Ll2T;
    var $99gde;
    var $hIKcp;
    var $gLj7z;
    var $4R6GH;
    var $ew1Lk;
    var $bTyOW;
    var $fC09Q;
    var $iVgQf;
    var $koVbs;
    var $hDzhb;
    var $4AdE6;
    const $951f6bd200bf8b89$export$849d319c342682a2 = ()=>{
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        const projectsPath = '/jira/projects';
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("ew1Lk")).DocumentTitle), {
            title: formatMessage((0, (0, parcelRequire("4AdE6")).default).notFoundDocumentTitleJsm)
        }), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("2oKQq")).default), {
            renderImage: (0, (0, parcelRequire("iVgQf")).getAkEmptyStateRenderImageFn)((0, (0, parcelRequire("fC09Q")).default)),
            maxImageWidth: 120,
            header: formatMessage((0, (0, parcelRequire("4AdE6")).default).notFoundTitle),
            description: formatMessage((0, (0, parcelRequire("4AdE6")).default).notFoundDescription),
            primaryAction: (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("hDzhb")).default), {
                to: projectsPath
            }, formatMessage((0, (0, parcelRequire("4AdE6")).default).notFoundAction))
        }));
    };
    const $951f6bd200bf8b89$export$7d465be8efa67280 = ()=>{
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        const traceId = (0, $5uXOq.useMemo)(()=>{
            const traceContext = (0, (0, parcelRequire("hIKcp")).getActiveTrace)();
            return traceContext?.traceId;
        }, []);
        let description = formatMessage((0, (0, parcelRequire("4AdE6")).default).genericErrorDescription);
        if (traceId && (0, (0, parcelRequire("4R6GH")).fg)('jfp-trace-id-in-error-boundaries')) {
            const error = new Error('An error occurred while loading this page');
            description = (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, (0, ($parcel$interopDefault($5uXOq))).createElement("div", null, description), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("6Ll2T")).default), {
                xcss: $951f6bd200bf8b89$var$styles
            }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("gLj7z")).ErrorHashAndTraceId), {
                error: error,
                traceId: traceId
            })));
        }
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("ew1Lk")).DocumentTitle), {
            title: formatMessage((0, (0, parcelRequire("4AdE6")).default).genericDocumentTitleJsm)
        }), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("2oKQq")).default), {
            renderImage: (0, (0, parcelRequire("iVgQf")).getAkEmptyStateRenderImageFn)((0, (0, parcelRequire("bTyOW")).default)),
            maxImageWidth: 120,
            header: formatMessage((0, (0, parcelRequire("4AdE6")).default).genericErrorTitle),
            description: description
        }));
    };
    const $951f6bd200bf8b89$var$styles = (0, (0, parcelRequire("99gde")).xcss)({
        marginTop: 'space.100'
    });
});
parcelRegister("gLj7z", function(module, exports) {
    $parcel$export(module.exports, "ErrorHashAndTraceId", ()=>$fe273132a82b30fc$export$61354a7dde2c2d3c);
    var $5uXOq = parcelRequire("5uXOq");
    var $5oFIy;
    var $kobfu;
    var $ftF7i;
    const $fe273132a82b30fc$export$61354a7dde2c2d3c = ({ error: error, traceId: traceId })=>{
        const errorHash = (0, (0, parcelRequire("kobfu")).getErrorHash)(error);
        const source = `Hash ${errorHash}\nTrace ${traceId}`;
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5oFIy")).FireOperationalAnalytics), {
            action: "rendered",
            actionSubject: "errorHashAndTraceId",
            attributes: {
                errorHash: errorHash,
                traceId: traceId
            }
        }), (0, ($parcel$interopDefault($5uXOq))).createElement("div", {
            role: "note"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("ftF7i")).CodeBlockWithCopyButton), {
            source: source,
            copyCodeActionSubjectId: "copyErrorHashAndTraceId"
        })));
    };
});
parcelRegister("ftF7i", function(module, exports) {
    $parcel$export(module.exports, "CodeBlockWithCopyButton", ()=>$92e21bbf80c400af$export$ced1fc74d907d387);
    var $5uXOq = parcelRequire("5uXOq");
    var $gdvFP;
    var $6Ll2T;
    var $99gde;
    var $lOZGq;
    const $92e21bbf80c400af$export$ced1fc74d907d387 = ({ source: source, copyCodeActionSubjectId: copyCodeActionSubjectId })=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("6Ll2T")).default), {
            xcss: $92e21bbf80c400af$var$wrapperStyles,
            role: "region"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("lOZGq")).ActionContainer), null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("lOZGq")).CopyAction), {
            source: source,
            actionSubjectId: copyCodeActionSubjectId
        })), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("6Ll2T")).default), null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("gdvFP")).default), {
            text: source,
            showLineNumbers: false,
            shouldWrapLongLines: false
        })));
    const $92e21bbf80c400af$var$wrapperStyles = (0, (0, parcelRequire("99gde")).xcss)({
        width: '100%',
        position: 'relative'
    });
});
parcelRegister("gdvFP", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$e1e3ab6f5cd16b56$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $f8Sb3;
    var $3cdTK;
    var $1VQAj;
    var $3wq9L;
    var $kOLPm;
    const $e1e3ab6f5cd16b56$var$CodeBlock = (0, $5uXOq.memo)(function CodeBlock({ showLineNumbers: showLineNumbers = true, firstLineNumber: firstLineNumber = 1, language: providedLanguage = 'text', highlight: highlight = '', highlightedStartText: highlightedStartText = 'Highlight start', highlightedEndText: highlightedEndText = 'Highlight end', testId: testId, text: text, codeBidiWarnings: codeBidiWarnings = true, codeBidiWarningLabel: codeBidiWarningLabel, codeBidiWarningTooltipEnabled: codeBidiWarningTooltipEnabled = true, shouldWrapLongLines: shouldWrapLongLines = false }) {
        const numLines = (text || '').split('\n').length + (firstLineNumber > 0 ? firstLineNumber : 1) - 1;
        const theme = (0, $5uXOq.useMemo)(()=>(0, (0, parcelRequire("1VQAj")).getCodeBlockTheme)(numLines), [
            numLines
        ]);
        const getStyles = (0, $5uXOq.useMemo)(()=>(0, (0, parcelRequire("1VQAj")).getCodeBlockStyles)(theme), [
            theme
        ]);
        const styles = (0, $5uXOq.useMemo)(()=>(0, (0, parcelRequire("f8Sb3")).css)(getStyles(highlightedStartText, highlightedEndText, showLineNumbers, shouldWrapLongLines)), [
            highlightedStartText,
            highlightedEndText,
            showLineNumbers,
            shouldWrapLongLines,
            getStyles
        ]);
        const { getHighlightStyles: getHighlightStyles, highlightedLines: highlightedLines } = (0, (0, parcelRequire("3cdTK")).useHighlightLines)({
            highlight: highlight,
            testId: testId
        });
        const getLineProps = (0, $5uXOq.useCallback)((line)=>getHighlightStyles(line, highlightedLines), [
            getHighlightStyles,
            highlightedLines
        ]);
        const language = (0, $5uXOq.useMemo)(()=>(0, (0, parcelRequire("3wq9L")).normalizeLanguage)(providedLanguage), [
            providedLanguage
        ]);
        const languageToUse = text ? language : 'text';
        return (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("kOLPm")).default), {
            "data-code-lang": language,
            "data-ds--code--code-block": "",
            testId: testId,
            language: languageToUse,
            css: styles,
            showLineNumbers: showLineNumbers,
            firstLineNumber: firstLineNumber,
            lineProps: getLineProps,
            shouldCreateParentElementForLines: highlight.length > 0 || !!testId,
            shouldWrapLongLines: shouldWrapLongLines,
            codeBidiWarnings: codeBidiWarnings,
            codeBidiWarningLabel: codeBidiWarningLabel,
            codeBidiWarningTooltipEnabled: codeBidiWarningTooltipEnabled,
            text: text
        });
    });
    $e1e3ab6f5cd16b56$var$CodeBlock.displayName = 'CodeBlock';
    var $e1e3ab6f5cd16b56$export$2e2bcd8739ae039 = $e1e3ab6f5cd16b56$var$CodeBlock;
});
parcelRegister("3cdTK", function(module, exports) {
    $parcel$export(module.exports, "useHighlightLines", ()=>$9354ecb135d9efb8$export$84415a200bdf33ed);
    var $5uXOq = parcelRequire("5uXOq");
    const $9354ecb135d9efb8$var$DEFAULT_LINE_EL_ATTR_OBJ = {
        'data-ds--code--row': ''
    };
    const $9354ecb135d9efb8$var$getLineStyleObject = (lineNumber, testId)=>{
        return testId ? {
            'data-testid': `${testId}-line-${lineNumber}`,
            ...$9354ecb135d9efb8$var$DEFAULT_LINE_EL_ATTR_OBJ
        } : $9354ecb135d9efb8$var$DEFAULT_LINE_EL_ATTR_OBJ;
    };
    const $9354ecb135d9efb8$export$84415a200bdf33ed = ({ highlight: highlight = '', testId: testId })=>{
        const highlightedLines = (0, $5uXOq.useMemo)(()=>{
            if (!highlight) return [];
            return highlight.split(',').map((num)=>{
                if (num.indexOf('-') > 0) {
                    const [from, to] = num.split('-').map(Number).sort((a, b)=>a - b);
                    return Array(to + 1).fill(undefined).map((_, index)=>index).slice(from, to + 1);
                }
                return Number(num);
            }).reduce((acc, val)=>acc.concat(val), []) || [];
        }, [
            highlight
        ]);
        const getHighlightStyles = (0, $5uXOq.useCallback)((lineNumber, highlightedLines)=>{
            if (!highlight || highlightedLines.length === 0) return $9354ecb135d9efb8$var$getLineStyleObject(lineNumber, testId);
            if (highlightedLines.includes(lineNumber)) {
                const highlightedDataAttrObj = {
                    'data-ds--code--row--highlight': ''
                };
                return {
                    ...highlightedDataAttrObj,
                    ...$9354ecb135d9efb8$var$getLineStyleObject(lineNumber, testId)
                };
            }
            return $9354ecb135d9efb8$var$getLineStyleObject(lineNumber, testId);
        }, [
            highlight,
            testId
        ]);
        return {
            getHighlightStyles: getHighlightStyles,
            highlightedLines: highlightedLines
        };
    };
});
parcelRegister("1VQAj", function(module, exports) {
    $parcel$export(module.exports, "getCodeBlockStyles", ()=>$1f3f8b295e4f1970$export$b571c24d82780698);
    $parcel$export(module.exports, "getCodeStyles", ()=>$1f3f8b295e4f1970$export$d5fcf1b7ff23707b);
    $parcel$export(module.exports, "getCodeBlockTheme", ()=>$1f3f8b295e4f1970$export$57a2d4b573afd64a);
    var $9jPr7;
    var $dW8Ue;
    const $1f3f8b295e4f1970$export$cb7aec0206b595d2 = (numLines)=>{
        if (!numLines) return '1ch';
        return `${numLines.toFixed(0).length}ch`;
    };
    const $1f3f8b295e4f1970$var$lineNumberStyle = (theme)=>({
            minWidth: `calc(${theme.lineNumberWidth} + ${0, (0, parcelRequire("9jPr7")).LINE_NUMBER_GUTTER}px) !important`,
            fontStyle: 'normal !important',
            color: `${theme.lineNumberColor} !important`,
            flexShrink: 0,
            boxSizing: 'border-box',
            paddingRight: `${0, (0, parcelRequire("9jPr7")).SPACING}px !important`,
            paddingLeft: (0, (0, parcelRequire("9jPr7")).SPACING),
            marginRight: (0, (0, parcelRequire("9jPr7")).SPACING),
            textAlign: 'right',
            userSelect: 'none',
            display: 'block',
            '&::after': {
                content: `attr(data-ds--line-number)`
            }
        });
    const $1f3f8b295e4f1970$var$syntaxKeywordColors = (theme)=>({
            '.token': {
                '&:not([class=token],[data-ds--code--row--highlight],[data-ds--code--row])': {
                    all: 'unset'
                },
                '&.key,&.keyword': {
                    color: theme.keywordColor,
                    fontWeight: 'bolder'
                },
                '&.attr-name': {
                    color: theme.attributeColor
                },
                '&.selector': {
                    color: theme.selectorTagColor
                },
                '&.comment,&.block-comment': {
                    color: theme.commentColor,
                    fontFamily: theme.fontFamilyItalic,
                    fontStyle: 'italic'
                },
                '&.function-name': {
                    color: theme.sectionColor
                },
                '&.doctype': {
                    color: theme.docTagColor
                },
                '&.substr': {
                    color: theme.substringColor
                },
                '&.namespace': {
                    color: theme.nameColor
                },
                '&.builtin': {
                    color: theme.builtInColor
                },
                '&.entity': {
                    color: theme.literalColor
                },
                '&.bullet': {
                    color: theme.bulletColor
                },
                '&.code': {
                    color: theme.codeColor
                },
                '&.regex': {
                    color: theme.regexpColor
                },
                '&.symbol': {
                    color: theme.symbolColor
                },
                '&.variable': {
                    color: theme.variableColor
                },
                '&.url': {
                    color: theme.linkColor
                },
                '&.selector-attr': {
                    color: theme.selectorAttributeColor
                },
                '&.selector-pseudo': {
                    color: theme.selectorPseudoColor
                },
                '&.type': {
                    color: theme.typeColor
                },
                '&.quote': {
                    color: theme.quoteColor
                },
                '&.tag': {
                    color: theme.templateTagColor
                },
                '&.string': {
                    color: theme.stringColor
                },
                '&.class-name': {
                    color: theme.sectionColor
                },
                '&.title': {
                    color: theme.titleColor
                },
                '&.section': {
                    color: theme.sectionColor
                },
                '&.meta-keyword': {
                    color: theme.metaKeywordColor
                },
                '&.meta': {
                    color: theme.metaColor
                },
                '&.italic': {
                    fontStyle: 'italic'
                },
                '&.bold': {
                    fontWeight: 'bolder'
                },
                '&.function': {
                    color: theme.functionColor
                },
                '&.number': {
                    color: theme.numberColor
                },
                '&.attr-value': {
                    color: theme.attributeColor
                },
                '&.prolog': {
                    color: theme.prologColor
                },
                '&.cdata': {
                    color: theme.cdataColor
                },
                '&.punctuation': {
                    color: theme.punctuationColor
                },
                '&.property': {
                    color: theme.propertyColor
                },
                '&.constant': {
                    color: theme.constantColor
                },
                '&.deleted': {
                    color: theme.deletedColor
                },
                '&.boolean': {
                    color: theme.booleanColor
                },
                '&.char': {
                    color: theme.charColor
                },
                '&.inserted': {
                    color: theme.insertedColor
                },
                '&.operator': {
                    color: theme.operatorColor
                },
                '&.atrule': {
                    color: theme.atruleColor
                },
                '&.important': {
                    color: theme.importantColor,
                    fontWeight: 'bold'
                }
            }
        });
    const $1f3f8b295e4f1970$export$ee58a26b5d612ac1 = (theme)=>({
            fontSize: (0, (0, parcelRequire("9jPr7")).CODE_FONT_SIZE),
            fontFamily: theme.fontFamily,
            fontWeight: "var(--ds-font-weight-regular, 400)",
            backgroundColor: `var(${0, (0, parcelRequire("9jPr7")).VAR_CODE_BG_COLOR},${theme.backgroundColor})`,
            color: theme.textColor,
            borderStyle: 'none',
            borderRadius: "var(--ds-border-radius, 3px)"
        });
    const $1f3f8b295e4f1970$export$b571c24d82780698 = (theme)=>(highlightedStartText, highlightedEndText, showLineNumbers, shouldWrapLongLines)=>({
                'code[class*="language-"], pre[class*="language-"], code': {
                    all: 'unset',
                    padding: showLineNumbers ? `${0, (0, parcelRequire("9jPr7")).SPACING}px 0` : (0, (0, parcelRequire("9jPr7")).SPACING),
                    tabSize: 4
                },
                display: 'flex',
                lineHeight: (0, (0, parcelRequire("9jPr7")).CODE_LINE_HEIGHT),
                overflowX: 'auto',
                whiteSpace: 'pre',
                direction: 'ltr',
                ...$1f3f8b295e4f1970$export$ee58a26b5d612ac1(theme),
                ...$1f3f8b295e4f1970$var$syntaxKeywordColors(theme),
                '& .linenumber, .ds-sh-line-number': $1f3f8b295e4f1970$var$lineNumberStyle(theme),
                '& .linenumber': {
                    display: 'inline-block !important',
                    float: 'left'
                },
                '& [data-ds--code--row]': {
                    display: showLineNumbers ? 'flex' : 'block',
                    paddingRight: `${0, (0, parcelRequire("9jPr7")).SPACING}px !important`,
                    marginRight: `-${0, (0, parcelRequire("9jPr7")).SPACING}px`
                },
                '& [data-ds--code--row--highlight]': {
                    background: `${theme.highlightedLineBgColor}`,
                    '&::before, &::after': {
                        clipPath: 'inset(100%)',
                        clip: 'rect(1px, 1px, 1px, 1px)',
                        height: '1px',
                        overflow: 'hidden',
                        position: 'absolute',
                        whiteSpace: 'nowrap',
                        width: '1px'
                    },
                    '&::before': {
                        content: `" [${highlightedStartText}] "`
                    },
                    '&::after': {
                        content: `" [${highlightedEndText}] "`
                    }
                },
                '& [data-ds--code--row--highlight] .linenumber': {
                    borderLeft: `${0, (0, parcelRequire("9jPr7")).HIGHLIGHT_BORDER_WIDTH} solid ${theme.highlightedLineBorderColor}`,
                    paddingLeft: `${(0, (0, parcelRequire("9jPr7")).SPACING) / 2}px !important`,
                    position: 'relative'
                },
                '& [data-ds--code--row--highlight] .linenumber::before': {
                    content: '""',
                    position: 'absolute',
                    width: (0, (0, parcelRequire("9jPr7")).HIGHLIGHT_BORDER_WIDTH),
                    top: '-1px',
                    left: `-${0, (0, parcelRequire("9jPr7")).HIGHLIGHT_BORDER_WIDTH}`,
                    borderTop: `1px solid ${theme.highlightedLineBorderColor}`
                },
                '[data-ds--code--row--highlight] + [data-ds--code--row]:not([data-ds--code--row--highlight]), [data-ds--code--row]:not([data-ds--code--row--highlight]) + [data-ds--code--row--highlight]': {
                    borderTop: '1px dashed transparent'
                },
                '[data-ds--code--row--highlight]:last-child': {
                    borderBottom: '1px dashed transparent'
                },
                '& code:first-of-type': {
                    paddingRight: `0px !important`,
                    backgroundImage: showLineNumbers ? `linear-gradient(to right, var(${0, (0, parcelRequire("9jPr7")).VAR_CODE_LINE_NUMBER_BG_COLOR},${theme.lineNumberBgColor}), var(${0, (0, parcelRequire("9jPr7")).VAR_CODE_LINE_NUMBER_BG_COLOR},${theme.lineNumberBgColor})
    calc(${theme.lineNumberWidth} + ${0, (0, parcelRequire("9jPr7")).LINE_NUMBER_GUTTER}px), transparent calc(${theme.lineNumberWidth} + ${0, (0, parcelRequire("9jPr7")).LINE_NUMBER_GUTTER}px), transparent)` : undefined
                },
                '& code:last-of-type': {
                    paddingRight: `${0, (0, parcelRequire("9jPr7")).SPACING}px !important`,
                    flexBasis: 'auto',
                    flexGrow: 1,
                    flexShrink: shouldWrapLongLines ? 1 : 0,
                    wordBreak: 'break-word'
                },
                'code > span:only-child:empty:before, code > span:only-child > span:only-child:empty:before': {
                    content: '" "'
                }
            });
    const $1f3f8b295e4f1970$export$d5fcf1b7ff23707b = ()=>{
        const theme = (0, (0, parcelRequire("dW8Ue")).getBaseTheme)();
        const baseStyles = $1f3f8b295e4f1970$export$ee58a26b5d612ac1(theme);
        return {
            ...baseStyles,
            display: 'inline',
            padding: '2px 0.5ch',
            boxDecorationBreak: 'clone',
            fontSize: '0.875em',
            overflow: 'auto',
            overflowWrap: 'break-word',
            whiteSpace: 'pre-wrap'
        };
    };
    const $1f3f8b295e4f1970$export$57a2d4b573afd64a = (maxLines)=>{
        return {
            ...(0, (0, parcelRequire("dW8Ue")).getBaseTheme)(),
            ...(0, (0, parcelRequire("dW8Ue")).getColorPalette)(),
            lineNumberWidth: maxLines ? $1f3f8b295e4f1970$export$cb7aec0206b595d2(maxLines) : undefined
        };
    };
});
parcelRegister("9jPr7", function(module, exports) {
    $parcel$export(module.exports, "CODE_FONT_SIZE", ()=>$16851b1001a2abd2$export$431ac46d758d98c8);
    $parcel$export(module.exports, "CODE_LINE_HEIGHT", ()=>$16851b1001a2abd2$export$8e3c04032121c606);
    $parcel$export(module.exports, "HIGHLIGHT_BORDER_WIDTH", ()=>$16851b1001a2abd2$export$c8b5dc30e9f2b86e);
    $parcel$export(module.exports, "SPACING", ()=>$16851b1001a2abd2$export$82ea42e772d49e5b);
    $parcel$export(module.exports, "LINE_NUMBER_GUTTER", ()=>$16851b1001a2abd2$export$eeeea0ff98e06fff);
    $parcel$export(module.exports, "VAR_CODE_LINE_NUMBER_BG_COLOR", ()=>$16851b1001a2abd2$export$254015fe817dcb9e);
    $parcel$export(module.exports, "VAR_CODE_BG_COLOR", ()=>$16851b1001a2abd2$export$1758fda69688282e);
    var $bUQGL;
    const $16851b1001a2abd2$export$431ac46d758d98c8 = 12;
    const $16851b1001a2abd2$export$8e3c04032121c606 = '20px';
    const $16851b1001a2abd2$export$c8b5dc30e9f2b86e = '4px';
    const $16851b1001a2abd2$export$82ea42e772d49e5b = (0, (0, parcelRequire("bUQGL")).gridSize)();
    const $16851b1001a2abd2$export$eeeea0ff98e06fff = $16851b1001a2abd2$export$82ea42e772d49e5b * 2;
    const $16851b1001a2abd2$export$254015fe817dcb9e = '--ds--code--line-number-bg-color';
    const $16851b1001a2abd2$export$1758fda69688282e = '--ds--code--bg-color';
    const $16851b1001a2abd2$export$2cd00c745c539a1 = `data-ds--code--code-block`;
});
parcelRegister("dW8Ue", function(module, exports) {
    $parcel$export(module.exports, "getBaseTheme", ()=>$c352b5d6d7e52441$export$4464aa303b3e4fda);
    $parcel$export(module.exports, "getColorPalette", ()=>$c352b5d6d7e52441$export$fe2a6478976e8b17);
    var $8QpSo;
    var $5w2JH;
    const $c352b5d6d7e52441$var$T800 = '#067384';
    const $c352b5d6d7e52441$var$Y1100 = '#7A5D1A';
    const $c352b5d6d7e52441$export$4464aa303b3e4fda = ()=>({
            fontFamily: "var(--ds-font-family-code, ui-monospace, Menlo, \"Segoe UI Mono\", \"Ubuntu Mono\", monospace)",
            fontFamilyItalic: `SFMono-MediumItalic, ${(0, (0, parcelRequire("5w2JH")).default)('font.family.code')}`,
            backgroundColor: `var(--ds-background-neutral, ${$72ba03e317f3d228$export$9fdfb749e33cdf97})`,
            textColor: `var(--ds-text, ${$72ba03e317f3d228$export$7d61b15e0da132af})`,
            lineNumberColor: `var(--ds-text-subtlest, ${$72ba03e317f3d228$export$eece5f492e429f08})`,
            lineNumberBgColor: `var(--ds-background-neutral, ${$72ba03e317f3d228$export$3e51e8f1440314ba})`
        });
    const $c352b5d6d7e52441$export$fe2a6478976e8b17 = (0, (0, parcelRequire("8QpSo")).default)(()=>{
        return {
            highlightedLineBgColor: `var(--ds-background-neutral, ${$72ba03e317f3d228$export$3e51e8f1440314ba})`,
            highlightedLineBorderColor: `var(--ds-border-focused, ${$72ba03e317f3d228$export$215b7063051591f1})`,
            substringColor: `var(--ds-text-subtlest, ${$72ba03e317f3d228$export$eece5f492e429f08})`,
            keywordColor: `var(--ds-text-accent-blue, ${$72ba03e317f3d228$export$b3de0ae08da2ce64})`,
            attributeColor: `var(--ds-text-accent-teal, ${$c352b5d6d7e52441$var$T800})`,
            selectorTagColor: `var(--ds-text-accent-blue, ${$72ba03e317f3d228$export$b3de0ae08da2ce64})`,
            docTagColor: `var(--ds-text-accent-yellow, ${$c352b5d6d7e52441$var$Y1100})`,
            nameColor: `var(--ds-text-accent-blue, ${$72ba03e317f3d228$export$b3de0ae08da2ce64})`,
            builtInColor: `var(--ds-text-accent-blue, ${$72ba03e317f3d228$export$b3de0ae08da2ce64})`,
            literalColor: `var(--ds-text-accent-blue, ${$72ba03e317f3d228$export$b3de0ae08da2ce64})`,
            bulletColor: `var(--ds-text-accent-blue, ${$72ba03e317f3d228$export$b3de0ae08da2ce64})`,
            codeColor: `var(--ds-text-accent-blue, ${$72ba03e317f3d228$export$b3de0ae08da2ce64})`,
            regexpColor: `var(--ds-text-accent-teal, ${$c352b5d6d7e52441$var$T800})`,
            symbolColor: `var(--ds-text-accent-teal, ${$c352b5d6d7e52441$var$T800})`,
            variableColor: `var(--ds-text-accent-teal, ${$c352b5d6d7e52441$var$T800})`,
            templateVariableColor: `var(--ds-text-accent-teal, ${$c352b5d6d7e52441$var$T800})`,
            linkColor: `var(--ds-text-accent-purple, ${$72ba03e317f3d228$export$b48405b95304b5a1})`,
            selectorAttributeColor: `var(--ds-text-accent-teal, ${$c352b5d6d7e52441$var$T800})`,
            selectorPseudoColor: `var(--ds-text-accent-teal, ${$c352b5d6d7e52441$var$T800})`,
            typeColor: `var(--ds-text-accent-teal, ${$c352b5d6d7e52441$var$T800})`,
            stringColor: `var(--ds-text-accent-green, ${$72ba03e317f3d228$export$6fa04827ac68a4fb})`,
            selectorIdColor: `var(--ds-text-accent-teal, ${$c352b5d6d7e52441$var$T800})`,
            selectorClassColor: `var(--ds-text-accent-teal, ${$c352b5d6d7e52441$var$T800})`,
            quoteColor: `var(--ds-text-accent-teal, ${$c352b5d6d7e52441$var$T800})`,
            templateTagColor: `var(--ds-text-accent-teal, ${$c352b5d6d7e52441$var$T800})`,
            titleColor: `var(--ds-text-accent-purple, ${$72ba03e317f3d228$export$b48405b95304b5a1})`,
            sectionColor: `var(--ds-text-accent-purple, ${$72ba03e317f3d228$export$b48405b95304b5a1})`,
            commentColor: `var(--ds-text-subtlest, ${$72ba03e317f3d228$export$eece5f492e429f08})`,
            metaKeywordColor: `var(--ds-text-accent-green, ${$72ba03e317f3d228$export$6fa04827ac68a4fb})`,
            metaColor: `var(--ds-text-subtlest, ${$72ba03e317f3d228$export$eece5f492e429f08})`,
            functionColor: `var(--ds-text, ${$72ba03e317f3d228$export$7d61b15e0da132af})`,
            numberColor: `var(--ds-text-accent-blue, ${$72ba03e317f3d228$export$b3de0ae08da2ce64})`,
            prologColor: `var(--ds-text-accent-blue, ${$72ba03e317f3d228$export$b3de0ae08da2ce64})`,
            cdataColor: `var(--ds-text-subtlest, ${$72ba03e317f3d228$export$eece5f492e429f08})`,
            punctuationColor: `var(--ds-text, ${$72ba03e317f3d228$export$7d61b15e0da132af})`,
            propertyColor: `var(--ds-text-accent-purple, ${$72ba03e317f3d228$export$b48405b95304b5a1})`,
            constantColor: `var(--ds-text-accent-teal, ${$c352b5d6d7e52441$var$T800})`,
            booleanColor: `var(--ds-text-accent-blue, ${$72ba03e317f3d228$export$b3de0ae08da2ce64})`,
            charColor: `var(--ds-text, ${$72ba03e317f3d228$export$7d61b15e0da132af})`,
            insertedColor: `var(--ds-text-accent-green, ${$72ba03e317f3d228$export$6fa04827ac68a4fb})`,
            deletedColor: `var(--ds-text-accent-red, ${$72ba03e317f3d228$export$2837b5a1a71d5c02})`,
            operatorColor: `var(--ds-text, ${$72ba03e317f3d228$export$7d61b15e0da132af})`,
            atruleColor: `var(--ds-text-accent-green, ${$72ba03e317f3d228$export$6fa04827ac68a4fb})`,
            importantColor: `var(--ds-text-accent-yellow, ${$c352b5d6d7e52441$var$Y1100})`
        };
    });
    const $c352b5d6d7e52441$var$getTheme = ()=>({
            ...$c352b5d6d7e52441$export$4464aa303b3e4fda(),
            ...$c352b5d6d7e52441$export$fe2a6478976e8b17()
        });
    var $c352b5d6d7e52441$export$2e2bcd8739ae039 = $c352b5d6d7e52441$var$getTheme;
});
var $72ba03e317f3d228$exports = {};
$parcel$export($72ba03e317f3d228$exports, "R50", ()=>$72ba03e317f3d228$export$4b84fd0e2c617bd);
$parcel$export($72ba03e317f3d228$exports, "R75", ()=>$72ba03e317f3d228$export$b34b069eff244586);
$parcel$export($72ba03e317f3d228$exports, "R100", ()=>$72ba03e317f3d228$export$be802dd0d8b57f35);
$parcel$export($72ba03e317f3d228$exports, "R200", ()=>$72ba03e317f3d228$export$60847d42f9da92a6);
$parcel$export($72ba03e317f3d228$exports, "R300", ()=>$72ba03e317f3d228$export$4a7404f376229999);
$parcel$export($72ba03e317f3d228$exports, "R400", ()=>$72ba03e317f3d228$export$2010d0fb4295b346);
$parcel$export($72ba03e317f3d228$exports, "R500", ()=>$72ba03e317f3d228$export$2837b5a1a71d5c02);
$parcel$export($72ba03e317f3d228$exports, "Y50", ()=>$72ba03e317f3d228$export$8d9596b529bbb9cf);
$parcel$export($72ba03e317f3d228$exports, "Y75", ()=>$72ba03e317f3d228$export$41060a744ab0b7ae);
$parcel$export($72ba03e317f3d228$exports, "Y100", ()=>$72ba03e317f3d228$export$1cc05bbbf340e559);
$parcel$export($72ba03e317f3d228$exports, "Y200", ()=>$72ba03e317f3d228$export$5aae31392d72caaa);
$parcel$export($72ba03e317f3d228$exports, "Y300", ()=>$72ba03e317f3d228$export$c6930421db9fa514);
$parcel$export($72ba03e317f3d228$exports, "Y400", ()=>$72ba03e317f3d228$export$59619663aa6500fb);
$parcel$export($72ba03e317f3d228$exports, "Y500", ()=>$72ba03e317f3d228$export$874739ea9e379ab6);
$parcel$export($72ba03e317f3d228$exports, "G50", ()=>$72ba03e317f3d228$export$8a6341c32b6a3ee6);
$parcel$export($72ba03e317f3d228$exports, "G75", ()=>$72ba03e317f3d228$export$69a3bf21b9686c2b);
$parcel$export($72ba03e317f3d228$exports, "G100", ()=>$72ba03e317f3d228$export$afbce1382ec95f73);
$parcel$export($72ba03e317f3d228$exports, "G200", ()=>$72ba03e317f3d228$export$747d86715d4175de);
$parcel$export($72ba03e317f3d228$exports, "G300", ()=>$72ba03e317f3d228$export$940e1f69e873f202);
$parcel$export($72ba03e317f3d228$exports, "G400", ()=>$72ba03e317f3d228$export$a49394138f7b8e85);
$parcel$export($72ba03e317f3d228$exports, "G500", ()=>$72ba03e317f3d228$export$6fa04827ac68a4fb);
$parcel$export($72ba03e317f3d228$exports, "B50", ()=>$72ba03e317f3d228$export$226de0355ed012f8);
$parcel$export($72ba03e317f3d228$exports, "B75", ()=>$72ba03e317f3d228$export$8c13c2ee36917869);
$parcel$export($72ba03e317f3d228$exports, "B100", ()=>$72ba03e317f3d228$export$ecfc1dff386a3e7a);
$parcel$export($72ba03e317f3d228$exports, "B200", ()=>$72ba03e317f3d228$export$215b7063051591f1);
$parcel$export($72ba03e317f3d228$exports, "B300", ()=>$72ba03e317f3d228$export$e62e8919cca44969);
$parcel$export($72ba03e317f3d228$exports, "B400", ()=>$72ba03e317f3d228$export$b3de0ae08da2ce64);
$parcel$export($72ba03e317f3d228$exports, "B500", ()=>$72ba03e317f3d228$export$a6ee3d71bc067634);
$parcel$export($72ba03e317f3d228$exports, "B600", ()=>$72ba03e317f3d228$export$67f15409e87642a1);
$parcel$export($72ba03e317f3d228$exports, "B700", ()=>$72ba03e317f3d228$export$f0539dbc42dbb067);
$parcel$export($72ba03e317f3d228$exports, "P50", ()=>$72ba03e317f3d228$export$363e4475840015bb);
$parcel$export($72ba03e317f3d228$exports, "P75", ()=>$72ba03e317f3d228$export$4b0a4417ed59760f);
$parcel$export($72ba03e317f3d228$exports, "P100", ()=>$72ba03e317f3d228$export$6011520a64d9a187);
$parcel$export($72ba03e317f3d228$exports, "P200", ()=>$72ba03e317f3d228$export$a7175d4e9206bc80);
$parcel$export($72ba03e317f3d228$exports, "P300", ()=>$72ba03e317f3d228$export$b48405b95304b5a1);
$parcel$export($72ba03e317f3d228$exports, "P400", ()=>$72ba03e317f3d228$export$c71e4279dd54a18d);
$parcel$export($72ba03e317f3d228$exports, "P500", ()=>$72ba03e317f3d228$export$147899de772240ec);
$parcel$export($72ba03e317f3d228$exports, "T50", ()=>$72ba03e317f3d228$export$2cf711fe14c66f06);
$parcel$export($72ba03e317f3d228$exports, "T75", ()=>$72ba03e317f3d228$export$7a8f4d33f6f9772c);
$parcel$export($72ba03e317f3d228$exports, "T100", ()=>$72ba03e317f3d228$export$776c9c497ef08533);
$parcel$export($72ba03e317f3d228$exports, "T200", ()=>$72ba03e317f3d228$export$69cb3ca10c1e330e);
$parcel$export($72ba03e317f3d228$exports, "T300", ()=>$72ba03e317f3d228$export$9dc1ef0f3f48059b);
$parcel$export($72ba03e317f3d228$exports, "T400", ()=>$72ba03e317f3d228$export$7c835c78b6fcdef8);
$parcel$export($72ba03e317f3d228$exports, "T500", ()=>$72ba03e317f3d228$export$6036577f95c3877e);
$parcel$export($72ba03e317f3d228$exports, "N0", ()=>$72ba03e317f3d228$export$29a4f05edc054374);
$parcel$export($72ba03e317f3d228$exports, "N10", ()=>$72ba03e317f3d228$export$e655ef011c4aa1a2);
$parcel$export($72ba03e317f3d228$exports, "N20", ()=>$72ba03e317f3d228$export$9fdfb749e33cdf97);
$parcel$export($72ba03e317f3d228$exports, "N30", ()=>$72ba03e317f3d228$export$3e51e8f1440314ba);
$parcel$export($72ba03e317f3d228$exports, "N40", ()=>$72ba03e317f3d228$export$1ce2d1575d444ceb);
$parcel$export($72ba03e317f3d228$exports, "N50", ()=>$72ba03e317f3d228$export$8754fc7e6d8b3000);
$parcel$export($72ba03e317f3d228$exports, "N60", ()=>$72ba03e317f3d228$export$c2e91cbeada39b8b);
$parcel$export($72ba03e317f3d228$exports, "N70", ()=>$72ba03e317f3d228$export$5f71e19f3a7ad9de);
$parcel$export($72ba03e317f3d228$exports, "N80", ()=>$72ba03e317f3d228$export$eaa8c8a70ac22806);
$parcel$export($72ba03e317f3d228$exports, "N90", ()=>$72ba03e317f3d228$export$7c87d337fb91a97d);
$parcel$export($72ba03e317f3d228$exports, "N100", ()=>$72ba03e317f3d228$export$d6447c357493214f);
$parcel$export($72ba03e317f3d228$exports, "N200", ()=>$72ba03e317f3d228$export$f563ee71e9ee74cd);
$parcel$export($72ba03e317f3d228$exports, "N300", ()=>$72ba03e317f3d228$export$e2ef2124cf4024b1);
$parcel$export($72ba03e317f3d228$exports, "N400", ()=>$72ba03e317f3d228$export$eece5f492e429f08);
$parcel$export($72ba03e317f3d228$exports, "N500", ()=>$72ba03e317f3d228$export$c39c0fe0f26207ae);
$parcel$export($72ba03e317f3d228$exports, "N600", ()=>$72ba03e317f3d228$export$7090862dc3038a9f);
$parcel$export($72ba03e317f3d228$exports, "N700", ()=>$72ba03e317f3d228$export$ad0bacf983b7ddaa);
$parcel$export($72ba03e317f3d228$exports, "N800", ()=>$72ba03e317f3d228$export$7d61b15e0da132af);
$parcel$export($72ba03e317f3d228$exports, "N900", ()=>$72ba03e317f3d228$export$fbda843f0a27fe96);
$parcel$export($72ba03e317f3d228$exports, "N10A", ()=>$72ba03e317f3d228$export$791e57b27ca738ef);
$parcel$export($72ba03e317f3d228$exports, "N20A", ()=>$72ba03e317f3d228$export$8d43898f60b96a82);
$parcel$export($72ba03e317f3d228$exports, "N30A", ()=>$72ba03e317f3d228$export$920c0d5c49070351);
$parcel$export($72ba03e317f3d228$exports, "N40A", ()=>$72ba03e317f3d228$export$46987b49aab6d1a8);
$parcel$export($72ba03e317f3d228$exports, "N50A", ()=>$72ba03e317f3d228$export$7d3359664e8bb0e5);
$parcel$export($72ba03e317f3d228$exports, "N60A", ()=>$72ba03e317f3d228$export$d2d3bedfb276cac0);
$parcel$export($72ba03e317f3d228$exports, "N70A", ()=>$72ba03e317f3d228$export$6e5e7499ff054f6d);
$parcel$export($72ba03e317f3d228$exports, "N80A", ()=>$72ba03e317f3d228$export$59264b346c877fa7);
$parcel$export($72ba03e317f3d228$exports, "N90A", ()=>$72ba03e317f3d228$export$d092757d7c64925c);
$parcel$export($72ba03e317f3d228$exports, "N100A", ()=>$72ba03e317f3d228$export$486ab785e4bac3c6);
$parcel$export($72ba03e317f3d228$exports, "N200A", ()=>$72ba03e317f3d228$export$fba592bbc6419fea);
$parcel$export($72ba03e317f3d228$exports, "N300A", ()=>$72ba03e317f3d228$export$13609db0e6812ab8);
$parcel$export($72ba03e317f3d228$exports, "N400A", ()=>$72ba03e317f3d228$export$fbae4efaa892d883);
$parcel$export($72ba03e317f3d228$exports, "N500A", ()=>$72ba03e317f3d228$export$f13946d26f440ce6);
$parcel$export($72ba03e317f3d228$exports, "N600A", ()=>$72ba03e317f3d228$export$19f58225ac52a306);
$parcel$export($72ba03e317f3d228$exports, "N700A", ()=>$72ba03e317f3d228$export$6384f09da70e7b62);
$parcel$export($72ba03e317f3d228$exports, "N800A", ()=>$72ba03e317f3d228$export$d0dccc730683edc2);
$parcel$export($72ba03e317f3d228$exports, "DN900", ()=>$72ba03e317f3d228$export$2f6319cf7d736c2a);
$parcel$export($72ba03e317f3d228$exports, "DN800", ()=>$72ba03e317f3d228$export$95126bc8884d6634);
$parcel$export($72ba03e317f3d228$exports, "DN700", ()=>$72ba03e317f3d228$export$8338d8c35d44ff1);
$parcel$export($72ba03e317f3d228$exports, "DN600", ()=>$72ba03e317f3d228$export$5368d76ae4fbbda7);
$parcel$export($72ba03e317f3d228$exports, "DN500", ()=>$72ba03e317f3d228$export$9f0a771d16ec8d36);
$parcel$export($72ba03e317f3d228$exports, "DN400", ()=>$72ba03e317f3d228$export$abcf8c38338b4aa5);
$parcel$export($72ba03e317f3d228$exports, "DN300", ()=>$72ba03e317f3d228$export$97e81faa16a182c7);
$parcel$export($72ba03e317f3d228$exports, "DN200", ()=>$72ba03e317f3d228$export$bfe21c59123ecf33);
$parcel$export($72ba03e317f3d228$exports, "DN100", ()=>$72ba03e317f3d228$export$ee82aa2ea6a1558);
$parcel$export($72ba03e317f3d228$exports, "DN90", ()=>$72ba03e317f3d228$export$682927c6ed76be02);
$parcel$export($72ba03e317f3d228$exports, "DN80", ()=>$72ba03e317f3d228$export$91fd9994c5be9757);
$parcel$export($72ba03e317f3d228$exports, "DN70", ()=>$72ba03e317f3d228$export$d281fbfe3cff2df6);
$parcel$export($72ba03e317f3d228$exports, "DN60", ()=>$72ba03e317f3d228$export$3902c91d8b98a753);
$parcel$export($72ba03e317f3d228$exports, "DN50", ()=>$72ba03e317f3d228$export$8e8133c1ba5845b5);
$parcel$export($72ba03e317f3d228$exports, "DN40", ()=>$72ba03e317f3d228$export$33ff357f6620b39);
$parcel$export($72ba03e317f3d228$exports, "DN30", ()=>$72ba03e317f3d228$export$633847cf062b69e0);
$parcel$export($72ba03e317f3d228$exports, "DN20", ()=>$72ba03e317f3d228$export$9776a6e503bdbf76);
$parcel$export($72ba03e317f3d228$exports, "DN10", ()=>$72ba03e317f3d228$export$6c813d5160dff5db);
$parcel$export($72ba03e317f3d228$exports, "DN0", ()=>$72ba03e317f3d228$export$3d4f271a500072a);
$parcel$export($72ba03e317f3d228$exports, "DN800A", ()=>$72ba03e317f3d228$export$fe151285c22759ec);
$parcel$export($72ba03e317f3d228$exports, "DN700A", ()=>$72ba03e317f3d228$export$a101c6190d0da34);
$parcel$export($72ba03e317f3d228$exports, "DN600A", ()=>$72ba03e317f3d228$export$4b16f52932fda51);
$parcel$export($72ba03e317f3d228$exports, "DN500A", ()=>$72ba03e317f3d228$export$a74bcd7b9845b0d8);
$parcel$export($72ba03e317f3d228$exports, "DN400A", ()=>$72ba03e317f3d228$export$9209c179316d1751);
$parcel$export($72ba03e317f3d228$exports, "DN300A", ()=>$72ba03e317f3d228$export$88f55133f636c8dd);
$parcel$export($72ba03e317f3d228$exports, "DN200A", ()=>$72ba03e317f3d228$export$51126f85d1009512);
$parcel$export($72ba03e317f3d228$exports, "DN100A", ()=>$72ba03e317f3d228$export$a069b547bd23af78);
$parcel$export($72ba03e317f3d228$exports, "DN90A", ()=>$72ba03e317f3d228$export$40cce05af3b2600a);
$parcel$export($72ba03e317f3d228$exports, "DN80A", ()=>$72ba03e317f3d228$export$b78942185925a0d);
$parcel$export($72ba03e317f3d228$exports, "DN70A", ()=>$72ba03e317f3d228$export$e058fb44b8eaafca);
$parcel$export($72ba03e317f3d228$exports, "DN60A", ()=>$72ba03e317f3d228$export$92b0b8de26920c18);
$parcel$export($72ba03e317f3d228$exports, "DN50A", ()=>$72ba03e317f3d228$export$67564f7459d3fc9e);
$parcel$export($72ba03e317f3d228$exports, "DN40A", ()=>$72ba03e317f3d228$export$77868e1ca884ffa3);
$parcel$export($72ba03e317f3d228$exports, "DN30A", ()=>$72ba03e317f3d228$export$2afd71d7d3ea2cd5);
$parcel$export($72ba03e317f3d228$exports, "DN20A", ()=>$72ba03e317f3d228$export$f2a0acaab9972c70);
$parcel$export($72ba03e317f3d228$exports, "DN10A", ()=>$72ba03e317f3d228$export$9ab70e67d6475361);
$parcel$export($72ba03e317f3d228$exports, "T30", ()=>$72ba03e317f3d228$export$d2adc5dedf09fced);
$parcel$export($72ba03e317f3d228$exports, "L50", ()=>$72ba03e317f3d228$export$f51762073d2bb381);
$parcel$export($72ba03e317f3d228$exports, "L75", ()=>$72ba03e317f3d228$export$95e26d54def96891);
const $72ba03e317f3d228$export$4b84fd0e2c617bd = '#FFEBE6';
const $72ba03e317f3d228$export$b34b069eff244586 = '#FFBDAD';
const $72ba03e317f3d228$export$be802dd0d8b57f35 = '#FF8F73';
const $72ba03e317f3d228$export$60847d42f9da92a6 = '#FF7452';
const $72ba03e317f3d228$export$4a7404f376229999 = '#FF5630';
const $72ba03e317f3d228$export$2010d0fb4295b346 = '#DE350B';
const $72ba03e317f3d228$export$2837b5a1a71d5c02 = '#BF2600';
const $72ba03e317f3d228$export$8d9596b529bbb9cf = '#FFFAE6';
const $72ba03e317f3d228$export$41060a744ab0b7ae = '#FFF0B3';
const $72ba03e317f3d228$export$1cc05bbbf340e559 = '#FFE380';
const $72ba03e317f3d228$export$5aae31392d72caaa = '#FFC400';
const $72ba03e317f3d228$export$c6930421db9fa514 = '#FFAB00';
const $72ba03e317f3d228$export$59619663aa6500fb = '#FF991F';
const $72ba03e317f3d228$export$874739ea9e379ab6 = '#FF8B00';
const $72ba03e317f3d228$export$8a6341c32b6a3ee6 = '#E3FCEF';
const $72ba03e317f3d228$export$69a3bf21b9686c2b = '#ABF5D1';
const $72ba03e317f3d228$export$afbce1382ec95f73 = '#79F2C0';
const $72ba03e317f3d228$export$747d86715d4175de = '#57D9A3';
const $72ba03e317f3d228$export$940e1f69e873f202 = '#36B37E';
const $72ba03e317f3d228$export$a49394138f7b8e85 = '#00875A';
const $72ba03e317f3d228$export$6fa04827ac68a4fb = '#006644';
const $72ba03e317f3d228$export$226de0355ed012f8 = '#DEEBFF';
const $72ba03e317f3d228$export$8c13c2ee36917869 = '#B3D4FF';
const $72ba03e317f3d228$export$ecfc1dff386a3e7a = '#4C9AFF';
const $72ba03e317f3d228$export$215b7063051591f1 = '#2684FF';
const $72ba03e317f3d228$export$e62e8919cca44969 = '#0065FF';
const $72ba03e317f3d228$export$b3de0ae08da2ce64 = '#0052CC';
const $72ba03e317f3d228$export$a6ee3d71bc067634 = '#0747A6';
const $72ba03e317f3d228$export$67f15409e87642a1 = '#669DF1';
const $72ba03e317f3d228$export$f0539dbc42dbb067 = '#8FB8F6';
const $72ba03e317f3d228$export$363e4475840015bb = '#EAE6FF';
const $72ba03e317f3d228$export$4b0a4417ed59760f = '#C0B6F2';
const $72ba03e317f3d228$export$6011520a64d9a187 = '#998DD9';
const $72ba03e317f3d228$export$a7175d4e9206bc80 = '#8777D9';
const $72ba03e317f3d228$export$b48405b95304b5a1 = '#6554C0';
const $72ba03e317f3d228$export$c71e4279dd54a18d = '#5243AA';
const $72ba03e317f3d228$export$147899de772240ec = '#403294';
const $72ba03e317f3d228$export$2cf711fe14c66f06 = '#E6FCFF';
const $72ba03e317f3d228$export$7a8f4d33f6f9772c = '#B3F5FF';
const $72ba03e317f3d228$export$776c9c497ef08533 = '#79E2F2';
const $72ba03e317f3d228$export$69cb3ca10c1e330e = '#00C7E6';
const $72ba03e317f3d228$export$9dc1ef0f3f48059b = '#00B8D9';
const $72ba03e317f3d228$export$7c835c78b6fcdef8 = '#00A3BF';
const $72ba03e317f3d228$export$6036577f95c3877e = '#008DA6';
const $72ba03e317f3d228$export$29a4f05edc054374 = '#FFFFFF';
const $72ba03e317f3d228$export$e655ef011c4aa1a2 = '#FAFBFC';
const $72ba03e317f3d228$export$9fdfb749e33cdf97 = '#F4F5F7';
const $72ba03e317f3d228$export$3e51e8f1440314ba = '#EBECF0';
const $72ba03e317f3d228$export$1ce2d1575d444ceb = '#DFE1E6';
const $72ba03e317f3d228$export$8754fc7e6d8b3000 = '#C1C7D0';
const $72ba03e317f3d228$export$c2e91cbeada39b8b = '#B3BAC5';
const $72ba03e317f3d228$export$5f71e19f3a7ad9de = '#A5ADBA';
const $72ba03e317f3d228$export$eaa8c8a70ac22806 = '#97A0AF';
const $72ba03e317f3d228$export$7c87d337fb91a97d = '#8993A4';
const $72ba03e317f3d228$export$d6447c357493214f = '#7A869A';
const $72ba03e317f3d228$export$f563ee71e9ee74cd = '#6B778C';
const $72ba03e317f3d228$export$e2ef2124cf4024b1 = '#5E6C84';
const $72ba03e317f3d228$export$eece5f492e429f08 = '#505F79';
const $72ba03e317f3d228$export$c39c0fe0f26207ae = '#42526E';
const $72ba03e317f3d228$export$7090862dc3038a9f = '#344563';
const $72ba03e317f3d228$export$ad0bacf983b7ddaa = '#253858';
const $72ba03e317f3d228$export$7d61b15e0da132af = '#172B4D';
const $72ba03e317f3d228$export$fbda843f0a27fe96 = '#091E42';
const $72ba03e317f3d228$export$791e57b27ca738ef = 'rgba(9, 30, 66, 0.02)';
const $72ba03e317f3d228$export$8d43898f60b96a82 = 'rgba(9, 30, 66, 0.04)';
const $72ba03e317f3d228$export$920c0d5c49070351 = 'rgba(9, 30, 66, 0.08)';
const $72ba03e317f3d228$export$46987b49aab6d1a8 = 'rgba(9, 30, 66, 0.13)';
const $72ba03e317f3d228$export$7d3359664e8bb0e5 = 'rgba(9, 30, 66, 0.25)';
const $72ba03e317f3d228$export$d2d3bedfb276cac0 = 'rgba(9, 30, 66, 0.31)';
const $72ba03e317f3d228$export$6e5e7499ff054f6d = 'rgba(9, 30, 66, 0.36)';
const $72ba03e317f3d228$export$59264b346c877fa7 = 'rgba(9, 30, 66, 0.42)';
const $72ba03e317f3d228$export$d092757d7c64925c = 'rgba(9, 30, 66, 0.48)';
const $72ba03e317f3d228$export$486ab785e4bac3c6 = 'rgba(9, 30, 66, 0.54)';
const $72ba03e317f3d228$export$fba592bbc6419fea = 'rgba(9, 30, 66, 0.60)';
const $72ba03e317f3d228$export$13609db0e6812ab8 = 'rgba(9, 30, 66, 0.66)';
const $72ba03e317f3d228$export$fbae4efaa892d883 = 'rgba(9, 30, 66, 0.71)';
const $72ba03e317f3d228$export$f13946d26f440ce6 = 'rgba(9, 30, 66, 0.77)';
const $72ba03e317f3d228$export$19f58225ac52a306 = 'rgba(9, 30, 66, 0.82)';
const $72ba03e317f3d228$export$6384f09da70e7b62 = 'rgba(9, 30, 66, 0.89)';
const $72ba03e317f3d228$export$d0dccc730683edc2 = 'rgba(9, 30, 66, 0.95)';
const $72ba03e317f3d228$export$2f6319cf7d736c2a = '#E6EDFA';
const $72ba03e317f3d228$export$95126bc8884d6634 = '#DCE5F5';
const $72ba03e317f3d228$export$8338d8c35d44ff1 = '#CED9EB';
const $72ba03e317f3d228$export$5368d76ae4fbbda7 = '#B8C7E0';
const $72ba03e317f3d228$export$9f0a771d16ec8d36 = '#ABBBD6';
const $72ba03e317f3d228$export$abcf8c38338b4aa5 = '#9FB0CC';
const $72ba03e317f3d228$export$97e81faa16a182c7 = '#8C9CB8';
const $72ba03e317f3d228$export$bfe21c59123ecf33 = '#7988A3';
const $72ba03e317f3d228$export$ee82aa2ea6a1558 = '#67758F';
const $72ba03e317f3d228$export$682927c6ed76be02 = '#56637A';
const $72ba03e317f3d228$export$91fd9994c5be9757 = '#455166';
const $72ba03e317f3d228$export$d281fbfe3cff2df6 = '#3B475C';
const $72ba03e317f3d228$export$3902c91d8b98a753 = '#313D52';
const $72ba03e317f3d228$export$8e8133c1ba5845b5 = '#283447';
const $72ba03e317f3d228$export$33ff357f6620b39 = '#202B3D';
const $72ba03e317f3d228$export$633847cf062b69e0 = '#1B2638';
const $72ba03e317f3d228$export$9776a6e503bdbf76 = '#121A29';
const $72ba03e317f3d228$export$6c813d5160dff5db = '#0E1624';
const $72ba03e317f3d228$export$3d4f271a500072a = '#0D1424';
const $72ba03e317f3d228$export$fe151285c22759ec = 'rgba(13, 20, 36, 0.06)';
const $72ba03e317f3d228$export$a101c6190d0da34 = 'rgba(13, 20, 36, 0.14)';
const $72ba03e317f3d228$export$4b16f52932fda51 = 'rgba(13, 20, 36, 0.18)';
const $72ba03e317f3d228$export$a74bcd7b9845b0d8 = 'rgba(13, 20, 36, 0.29)';
const $72ba03e317f3d228$export$9209c179316d1751 = 'rgba(13, 20, 36, 0.36)';
const $72ba03e317f3d228$export$88f55133f636c8dd = 'rgba(13, 20, 36, 0.40)';
const $72ba03e317f3d228$export$51126f85d1009512 = 'rgba(13, 20, 36, 0.47)';
const $72ba03e317f3d228$export$a069b547bd23af78 = 'rgba(13, 20, 36, 0.53)';
const $72ba03e317f3d228$export$40cce05af3b2600a = 'rgba(13, 20, 36, 0.63)';
const $72ba03e317f3d228$export$b78942185925a0d = 'rgba(13, 20, 36, 0.73)';
const $72ba03e317f3d228$export$e058fb44b8eaafca = 'rgba(13, 20, 36, 0.78)';
const $72ba03e317f3d228$export$92b0b8de26920c18 = 'rgba(13, 20, 36, 0.81)';
const $72ba03e317f3d228$export$67564f7459d3fc9e = 'rgba(13, 20, 36, 0.85)';
const $72ba03e317f3d228$export$77868e1ca884ffa3 = 'rgba(13, 20, 36, 0.89)';
const $72ba03e317f3d228$export$2afd71d7d3ea2cd5 = 'rgba(13, 20, 36, 0.92)';
const $72ba03e317f3d228$export$f2a0acaab9972c70 = 'rgba(13, 20, 36, 0.95)';
const $72ba03e317f3d228$export$9ab70e67d6475361 = 'rgba(13, 20, 36, 0.97)';
const $72ba03e317f3d228$export$d2adc5dedf09fced = '#292A2E';
const $72ba03e317f3d228$export$f51762073d2bb381 = '#94C748';
const $72ba03e317f3d228$export$95e26d54def96891 = '#B3DF72';
parcelRegister("3wq9L", function(module, exports) {
    $parcel$export(module.exports, "normalizeLanguage", ()=>$41e362fed9e5618b$export$f38728011c178796);
    var $8QpSo;
    var $5lUaL;
    const $41e362fed9e5618b$export$f38728011c178796 = (0, (0, parcelRequire("8QpSo")).default)((language)=>{
        if (!language) return '';
        const match = (0, (0, parcelRequire("5lUaL")).SUPPORTED_LANGUAGES).find((val)=>{
            return val.name === language || val.alias.includes(language);
        });
        return match ? match.value : 'text';
    });
});
parcelRegister("5lUaL", function(module, exports) {
    $parcel$export(module.exports, "SUPPORTED_LANGUAGES", ()=>$91fe7c840a716685$export$7c77c3a9bb93870d);
    const $91fe7c840a716685$export$7c77c3a9bb93870d = [
        {
            name: 'PHP',
            alias: [
                'php',
                'php3',
                'php4',
                'php5'
            ],
            value: 'php'
        },
        {
            name: 'Java',
            alias: [
                'java'
            ],
            value: 'java'
        },
        {
            name: 'CSharp',
            alias: [
                'csharp',
                'c#'
            ],
            value: 'cs'
        },
        {
            name: 'Python',
            alias: [
                'python',
                'py'
            ],
            value: 'python'
        },
        {
            name: 'JavaScript',
            alias: [
                'javascript',
                'js'
            ],
            value: 'javascript'
        },
        {
            name: 'Html',
            alias: [
                'html'
            ],
            value: 'xml'
        },
        {
            name: 'C++',
            alias: [
                'c++',
                'cpp',
                'clike'
            ],
            value: 'cpp'
        },
        {
            name: 'Ruby',
            alias: [
                'ruby',
                'rb',
                'duby'
            ],
            value: 'ruby'
        },
        {
            name: 'Objective-C',
            alias: [
                'objective-c',
                'objectivec',
                'obj-c',
                'objc'
            ],
            value: 'objectivec'
        },
        {
            name: 'C',
            alias: [
                'c'
            ],
            value: 'cpp'
        },
        {
            name: 'Swift',
            alias: [
                'swift'
            ],
            value: 'swift'
        },
        {
            name: 'TeX',
            alias: [
                'tex',
                'latex'
            ],
            value: 'tex'
        },
        {
            name: 'Shell',
            alias: [
                'shell',
                'bash',
                'sh',
                'ksh',
                'zsh'
            ],
            value: 'shell'
        },
        {
            name: 'Scala',
            alias: [
                'scala'
            ],
            value: 'scala'
        },
        {
            name: 'Go',
            alias: [
                'go'
            ],
            value: 'go'
        },
        {
            name: 'ActionScript',
            alias: [
                'actionscript',
                'actionscript3',
                'as'
            ],
            value: 'actionscript'
        },
        {
            name: 'ColdFusion',
            alias: [
                'coldfusion'
            ],
            value: 'xml'
        },
        {
            name: 'JavaFX',
            alias: [
                'javafx',
                'jfx'
            ],
            value: 'java'
        },
        {
            name: 'VbNet',
            alias: [
                'vbnet',
                'vb.net',
                'vfp',
                'clipper',
                'xbase'
            ],
            value: 'vbnet'
        },
        {
            name: 'JSON',
            alias: [
                'json'
            ],
            value: 'json'
        },
        {
            name: 'MATLAB',
            alias: [
                'matlab'
            ],
            value: 'matlab'
        },
        {
            name: 'Groovy',
            alias: [
                'groovy'
            ],
            value: 'groovy'
        },
        {
            name: 'SQL',
            alias: [
                'sql',
                'postgresql',
                'postgres',
                'plpgsql',
                'psql',
                'postgresql-console',
                'postgres-console',
                'tsql',
                't-sql',
                'mysql',
                'sqlite'
            ],
            value: 'sql'
        },
        {
            name: 'R',
            alias: [
                'r'
            ],
            value: 'r'
        },
        {
            name: 'Perl',
            alias: [
                'perl',
                'pl'
            ],
            value: 'perl'
        },
        {
            name: 'Lua',
            alias: [
                'lua'
            ],
            value: 'lua'
        },
        {
            name: 'Pascal',
            alias: [
                'pas',
                'pascal',
                'objectpascal',
                'delphi'
            ],
            value: 'pascal'
        },
        {
            name: 'XML',
            alias: [
                'xml'
            ],
            value: 'xml'
        },
        {
            name: 'TypeScript',
            alias: [
                'typescript',
                'ts'
            ],
            value: 'typescript'
        },
        {
            name: 'CoffeeScript',
            alias: [
                'coffeescript',
                'coffee-script',
                'coffee'
            ],
            value: 'coffeescript'
        },
        {
            name: 'Haskell',
            alias: [
                'haskell',
                'hs'
            ],
            value: 'haskell'
        },
        {
            name: 'Puppet',
            alias: [
                'puppet'
            ],
            value: 'puppet'
        },
        {
            name: 'Arduino',
            alias: [
                'arduino'
            ],
            value: 'arduino'
        },
        {
            name: 'Fortran',
            alias: [
                'fortran'
            ],
            value: 'fortran'
        },
        {
            name: 'Erlang',
            alias: [
                'erlang',
                'erl'
            ],
            value: 'erlang'
        },
        {
            name: 'PowerShell',
            alias: [
                'powershell',
                'posh',
                'ps1',
                'psm1'
            ],
            value: 'powershell'
        },
        {
            name: 'Haxe',
            alias: [
                'haxe',
                'hx',
                'hxsl'
            ],
            value: 'haxe'
        },
        {
            name: 'Elixir',
            alias: [
                'elixir',
                'ex',
                'exs'
            ],
            value: 'elixir'
        },
        {
            name: 'Verilog',
            alias: [
                'verilog',
                'v'
            ],
            value: 'verilog'
        },
        {
            name: 'Rust',
            alias: [
                'rust'
            ],
            value: 'rust'
        },
        {
            name: 'VHDL',
            alias: [
                'vhdl'
            ],
            value: 'vhdl'
        },
        {
            name: 'Sass',
            alias: [
                'sass'
            ],
            value: 'less'
        },
        {
            name: 'OCaml',
            alias: [
                'ocaml'
            ],
            value: 'ocaml'
        },
        {
            name: 'Dart',
            alias: [
                'dart'
            ],
            value: 'dart'
        },
        {
            name: 'CSS',
            alias: [
                'css'
            ],
            value: 'css'
        },
        {
            name: 'reStructuredText',
            alias: [
                'restructuredtext',
                'rst',
                'rest'
            ],
            value: 'rest'
        },
        {
            name: 'Kotlin',
            alias: [
                'kotlin'
            ],
            value: 'kotlin'
        },
        {
            name: 'D',
            alias: [
                'd'
            ],
            value: 'd'
        },
        {
            name: 'Octave',
            alias: [
                'octave'
            ],
            value: 'matlab'
        },
        {
            name: 'QML',
            alias: [
                'qbs',
                'qml'
            ],
            value: 'qml'
        },
        {
            name: 'Prolog',
            alias: [
                'prolog'
            ],
            value: 'prolog'
        },
        {
            name: 'FoxPro',
            alias: [
                'foxpro',
                'purebasic'
            ],
            value: 'purebasic'
        },
        {
            name: 'Scheme',
            alias: [
                'scheme',
                'scm'
            ],
            value: 'scheme'
        },
        {
            name: 'CUDA',
            alias: [
                'cuda',
                'cu'
            ],
            value: 'cpp'
        },
        {
            name: 'Julia',
            alias: [
                'julia',
                'jl'
            ],
            value: 'julia'
        },
        {
            name: 'Racket',
            alias: [
                'racket',
                'rkt'
            ],
            value: 'lisp'
        },
        {
            name: 'Ada',
            alias: [
                'ada',
                'ada95',
                'ada2005'
            ],
            value: 'ada'
        },
        {
            name: 'Tcl',
            alias: [
                'tcl'
            ],
            value: 'tcl'
        },
        {
            name: 'Mathematica',
            alias: [
                'mathematica',
                'mma',
                'nb'
            ],
            value: 'mathematica'
        },
        {
            name: 'Autoit',
            alias: [
                'autoit'
            ],
            value: 'autoit'
        },
        {
            name: 'StandardML',
            alias: [
                'standardmL',
                'sml',
                'standardml'
            ],
            value: 'sml'
        },
        {
            name: 'Objective-J',
            alias: [
                'objective-j',
                'objectivej',
                'obj-j',
                'objj'
            ],
            value: 'objectivec'
        },
        {
            name: 'Smalltalk',
            alias: [
                'smalltalk',
                'squeak',
                'st'
            ],
            value: 'smalltalk'
        },
        {
            name: 'Vala',
            alias: [
                'vala',
                'vapi'
            ],
            value: 'vala'
        },
        {
            name: 'ABAP',
            alias: [
                'abap'
            ],
            value: 'sql'
        },
        {
            name: 'LiveScript',
            alias: [
                'livescript',
                'live-script'
            ],
            value: 'livescript'
        },
        {
            name: 'XQuery',
            alias: [
                'xquery',
                'xqy',
                'xq',
                'xql',
                'xqm'
            ],
            value: 'xquery'
        },
        {
            name: 'PlainText',
            alias: [
                'text',
                'plaintext'
            ],
            value: 'text'
        },
        {
            name: 'Yaml',
            alias: [
                'yaml',
                'yml'
            ],
            value: 'yaml'
        },
        {
            name: 'GraphQL',
            alias: [
                'graphql'
            ],
            value: 'graphql'
        },
        {
            name: 'AppleScript',
            alias: [
                'applescript'
            ],
            value: 'applescript'
        },
        {
            name: 'Clojure',
            alias: [
                'clojure'
            ],
            value: 'clojure'
        },
        {
            name: 'Diff',
            alias: [
                'diff'
            ],
            value: 'diff'
        },
        {
            name: 'VisualBasic',
            alias: [
                'visualbasic'
            ],
            value: 'visual-basic'
        },
        {
            name: 'JSX',
            alias: [
                'jsx'
            ],
            value: 'jsx'
        },
        {
            name: 'TSX',
            alias: [
                'tsx'
            ],
            value: 'tsx'
        },
        {
            name: 'SplunkSPL',
            alias: [
                'splunk-spl'
            ],
            value: 'splunk-spl'
        },
        {
            name: 'Dockerfile',
            alias: [
                'docker',
                'dockerfile'
            ],
            value: 'dockerfile'
        },
        {
            name: 'HCL',
            alias: [
                'hcl',
                'terraform'
            ],
            value: 'hcl'
        },
        {
            name: 'NGINX',
            alias: [
                'nginx'
            ],
            value: 'nginx'
        },
        {
            name: 'Protocol Buffers',
            alias: [
                'protobuf',
                'proto'
            ],
            value: 'protobuf'
        }
    ];
});
parcelRegister("kOLPm", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$a42fbdf1f5ea3ed9$export$2e2bcd8739ae039);
    var $aVBRo;
    var $a42fbdf1f5ea3ed9$export$2e2bcd8739ae039 = (0, (0, parcelRequire("aVBRo")).default);
});
parcelRegister("aVBRo", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$5f9ccff03a95a648$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $bTRwa;
    const $5f9ccff03a95a648$var$generator = (options)=>{
        const { loader: loader } = options;
        class AsyncHighlighter extends (0, ($parcel$interopDefault($5uXOq))).PureComponent {
            static{
                this.astGenerator = null;
            }
            static{
                this.highlightInstance = (0, (0, parcelRequire("bTRwa")).default);
            }
            static preload() {
                return AsyncHighlighter.loadAstGenerator();
            }
            static loadAstGenerator() {
                AsyncHighlighter.astGeneratorPromise = loader().then((astGenerator)=>{
                    AsyncHighlighter.astGenerator = astGenerator;
                    return astGenerator;
                });
                return AsyncHighlighter.astGeneratorPromise;
            }
            componentDidMount() {
                if (!AsyncHighlighter.astGeneratorPromise) AsyncHighlighter.loadAstGenerator();
                if (!AsyncHighlighter.astGenerator && AsyncHighlighter.astGeneratorPromise) AsyncHighlighter.astGeneratorPromise.then(()=>{
                    this.forceUpdate();
                });
            }
            render() {
                return (0, ($parcel$interopDefault($5uXOq))).createElement(AsyncHighlighter.highlightInstance, {
                    ...this.props,
                    astGenerator: AsyncHighlighter.astGenerator
                });
            }
        }
        return AsyncHighlighter;
    };
    const $5f9ccff03a95a648$var$asyncGenerator = $5f9ccff03a95a648$var$generator({
        loader: ()=>(parcelRequire("kN6qz")).then((module)=>{
                return module.default || module;
            })
    });
    var $5f9ccff03a95a648$export$2e2bcd8739ae039 = $5f9ccff03a95a648$var$asyncGenerator;
});
parcelRegister("bTRwa", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$714e39a7d165750f$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $bQkeD;
    var $bAA7E;
    const $714e39a7d165750f$var$Highlight = (0, $5uXOq.memo)(function Highlight({ language: language = 'text', testId: testId, text: text = '', codeTagProps: codeTagProps = {
        className: `language-${language}`
    }, showLineNumbers: showLineNumbers = false, firstLineNumber: firstLineNumber = 1, shouldCreateParentElementForLines: shouldCreateParentElementForLines = false, shouldWrapLongLines: shouldWrapLongLines = false, lineProps: lineProps = {}, codeBidiWarnings: codeBidiWarnings, codeBidiWarningLabel: codeBidiWarningLabel, codeBidiWarningTooltipEnabled: codeBidiWarningTooltipEnabled, astGenerator: astGenerator = null, ...rest }) {
        const code = text;
        const generatorClassName = 'prismjs';
        const containerProps = {
            ...rest,
            'data-testid': testId,
            className: rest.className ? `${generatorClassName} ${rest.className}` : generatorClassName
        };
        if (shouldWrapLongLines) codeTagProps.style = {
            whiteSpace: 'pre-wrap',
            wordBreak: 'break-word'
        };
        else codeTagProps.style = {
            whiteSpace: 'pre'
        };
        const codeBidiWarningConfig = {
            codeBidiWarnings: codeBidiWarnings,
            codeBidiWarningLabel: codeBidiWarningLabel,
            codeBidiWarningTooltipEnabled: codeBidiWarningTooltipEnabled
        };
        const rows = (0, (0, parcelRequire("bQkeD")).default)({
            astGenerator: astGenerator,
            code: code,
            language: language,
            shouldCreateParentElementForLines: shouldCreateParentElementForLines || !!shouldWrapLongLines,
            lineProps: lineProps,
            showLineNumbers: showLineNumbers,
            firstLineNumber: firstLineNumber
        });
        return (0, (0, parcelRequire("bAA7E")).default)({
            containerProps: containerProps,
            codeTagProps: codeTagProps,
            rows: rows,
            codeBidiWarningConfig: codeBidiWarningConfig
        });
    });
    var $714e39a7d165750f$export$2e2bcd8739ae039 = $714e39a7d165750f$var$Highlight;
});
parcelRegister("bQkeD", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$300f970a4217b631$export$2e2bcd8739ae039);
    var $h1mgC;
    var $7cd5I;
    var $756jv;
    var $g0987;
    const $300f970a4217b631$var$newLineRegex = /\n/g;
    function $300f970a4217b631$var$getNewLines(str) {
        return str.match($300f970a4217b631$var$newLineRegex);
    }
    function $300f970a4217b631$export$2e2bcd8739ae039({ astGenerator: astGenerator, code: code, language: language, shouldCreateParentElementForLines: shouldCreateParentElementForLines, lineProps: lineProps, showLineNumbers: showLineNumbers, firstLineNumber: firstLineNumber = 1 }) {
        const codeTree = (0, (0, parcelRequire("g0987")).default)(language, code, astGenerator);
        const startingLineNumber = firstLineNumber > 0 ? firstLineNumber : 1;
        const createLine = (0, (0, parcelRequire("h1mgC")).default)(lineProps, shouldCreateParentElementForLines, showLineNumbers);
        const newTree = [];
        let lastLineBreakIndex = -1;
        let index = 0;
        const tree = (0, (0, parcelRequire("756jv")).default)(codeTree);
        while(index < tree.length){
            const testNode = tree[index];
            if (testNode.type === 'text') {
                index++;
                continue;
            }
            const node = testNode;
            const firstChildNode = node.children[0];
            if (firstChildNode.type === 'text') {
                const { value: value } = firstChildNode;
                const newLines = $300f970a4217b631$var$getNewLines(value);
                if (newLines) {
                    const splitValue = value.split('\n');
                    splitValue.forEach((text, i)=>{
                        const lineNumber = newTree.length + startingLineNumber;
                        const newChild = {
                            type: 'text',
                            value: `${text}\n`
                        };
                        if (i === 0) {
                            const children = tree.slice(lastLineBreakIndex + 1, index).concat((0, (0, parcelRequire("7cd5I")).default)({
                                children: [
                                    newChild
                                ],
                                className: node.properties.className,
                                lineNumber: lineNumber
                            }));
                            const line = createLine(children, lineNumber);
                            newTree.push(line);
                        } else if (i === splitValue.length - 1) {
                            const nextNode = tree[index + 1];
                            const stringChild = nextNode && nextNode.children && nextNode.children[0];
                            const lastLineInPreviousSpan = {
                                type: 'text',
                                value: `${text}`
                            };
                            if (stringChild) {
                                const newElem = (0, (0, parcelRequire("7cd5I")).default)({
                                    children: [
                                        lastLineInPreviousSpan
                                    ],
                                    className: node.properties.className,
                                    lineNumber: lineNumber
                                });
                                tree.splice(index + 1, 0, newElem);
                            } else {
                                const children = [
                                    lastLineInPreviousSpan
                                ];
                                const line = createLine(children, lineNumber, node.properties.className);
                                newTree.push(line);
                            }
                        } else {
                            const children = [
                                newChild
                            ];
                            const line = createLine(children, lineNumber, node.properties.className);
                            newTree.push(line);
                        }
                    });
                    lastLineBreakIndex = index;
                }
            }
            index++;
        }
        if (lastLineBreakIndex !== tree.length - 1) {
            const children = tree.slice(lastLineBreakIndex + 1, tree.length);
            if (children && children.length) {
                const lineNumber = newTree.length + startingLineNumber;
                const line = createLine(children, lineNumber);
                newTree.push(line);
            }
        }
        if (shouldCreateParentElementForLines) return newTree;
        return newTree.flat(1);
    }
});
parcelRegister("h1mgC", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$e802874db56687b3$export$2e2bcd8739ae039);
    var $7cd5I;
    var $9T5KR;
    function $e802874db56687b3$var$createLineGenerator(lineProps, shouldCreateParentElementForLines, showLineNumbers) {
        return (children, lineNumber, className = [])=>{
            if (shouldCreateParentElementForLines || className.length > 0) return (0, (0, parcelRequire("7cd5I")).default)({
                children: children,
                lineNumber: lineNumber,
                showLineNumbers: showLineNumbers,
                lineProps: lineProps,
                className: className
            });
            else {
                if (showLineNumbers && lineNumber) children.unshift((0, (0, parcelRequire("9T5KR")).default)(lineNumber));
                return children;
            }
        };
    }
    var $e802874db56687b3$export$2e2bcd8739ae039 = $e802874db56687b3$var$createLineGenerator;
});
parcelRegister("7cd5I", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$fb90ce175080ebd7$export$2e2bcd8739ae039);
    var $9T5KR;
    function $fb90ce175080ebd7$export$2e2bcd8739ae039({ children: children, lineNumber: lineNumber, showLineNumbers: showLineNumbers, lineProps: lineProps = {}, className: className = [] }) {
        const propsPassedInFromCodeBlock = typeof lineProps === 'function' ? lineProps(lineNumber) : lineProps;
        const properties = {
            ...propsPassedInFromCodeBlock,
            className: className
        };
        let currentChildren = children;
        if (lineNumber && showLineNumbers) {
            if (currentChildren.length === 1) currentChildren = [
                (0, (0, parcelRequire("9T5KR")).default)(lineNumber),
                ...currentChildren
            ];
            else currentChildren = [
                (0, (0, parcelRequire("9T5KR")).default)(lineNumber),
                {
                    type: 'element',
                    tagName: 'span',
                    properties: {
                        className: []
                    },
                    children: currentChildren
                }
            ];
        }
        return {
            type: 'element',
            tagName: 'span',
            properties: properties,
            children: currentChildren
        };
    }
});
parcelRegister("9T5KR", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$16511336cb833d65$export$2e2bcd8739ae039);
    function $16511336cb833d65$export$2e2bcd8739ae039(lineNumber) {
        return {
            type: 'element',
            tagName: 'span',
            properties: {
                key: `line-number--${lineNumber}`,
                className: [
                    'comment',
                    'linenumber',
                    'ds-line-number'
                ],
                'data-ds--line-number': lineNumber
            },
            children: []
        };
    }
});
parcelRegister("756jv", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$3722626977573637$export$2e2bcd8739ae039);
    var $7cd5I;
    function $3722626977573637$export$2e2bcd8739ae039(tree, offset = 0, className = []) {
        let newTree = [];
        for(let i = 0; i < tree.length; i++){
            const node = tree[i];
            if (node.type === 'text') newTree.push((0, (0, parcelRequire("7cd5I")).default)({
                children: [
                    node
                ],
                lineNumber: offset,
                className: className
            }));
            else if (node.children) {
                const classNames = className.concat(node.properties.className || []);
                $3722626977573637$export$2e2bcd8739ae039(node.children, offset + 1, classNames).forEach((i)=>newTree.push(i));
            }
        }
        return newTree;
    }
});
parcelRegister("g0987", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$043f48aa29101879$export$2e2bcd8739ae039);
    function $043f48aa29101879$export$2e2bcd8739ae039(language, code, astGenerator) {
        if (language === 'text' || !astGenerator) return [
            {
                type: 'text',
                value: code
            }
        ];
        try {
            return astGenerator.highlight(code, language);
        } catch (e) {
            return [
                {
                    type: 'text',
                    value: code
                }
            ];
        }
    }
});
parcelRegister("bAA7E", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$ffbb5a6617decb03$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $laCYD;
    function $ffbb5a6617decb03$export$2e2bcd8739ae039({ containerProps: containerProps, codeTagProps: codeTagProps, rows: rows, codeBidiWarningConfig: codeBidiWarningConfig }) {
        const renderedRows = rows.map((node, i)=>(0, (0, parcelRequire("laCYD")).default)({
                node: node,
                codeBidiWarningConfig: codeBidiWarningConfig,
                key: `code-segment${i}`
            }));
        return (0, ($parcel$interopDefault($5uXOq))).createElement("span", containerProps, (0, ($parcel$interopDefault($5uXOq))).createElement("code", codeTagProps, renderedRows));
    }
});
parcelRegister("laCYD", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$b56eeb7e6ac46855$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $47G8n;
    var $dE7lx;
    var $4CTxJ;
    function $b56eeb7e6ac46855$var$createClassNameString(classNames) {
        return classNames ? classNames.join(' ') : '';
    }
    function $b56eeb7e6ac46855$export$2e2bcd8739ae039({ node: node, codeBidiWarningConfig: codeBidiWarningConfig, key: key }) {
        if (node.type === 'text') {
            const { value: value } = node;
            const textValue = `${value}`;
            if (codeBidiWarningConfig.codeBidiWarnings) {
                const decorated = (0, (0, parcelRequire("dE7lx")).default)(textValue, ({ bidiCharacter: bidiCharacter, index: index })=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("47G8n")).default), {
                        bidiCharacter: bidiCharacter,
                        key: index,
                        label: codeBidiWarningConfig.codeBidiWarningLabel,
                        tooltipEnabled: codeBidiWarningConfig.codeBidiWarningTooltipEnabled
                    }));
                return decorated;
            }
            return textValue;
        } else {
            const { properties: properties, tagName: tagName } = node;
            const childrenCreator = (0, (0, parcelRequire("4CTxJ")).default)(codeBidiWarningConfig);
            const props = {
                ...properties,
                className: $b56eeb7e6ac46855$var$createClassNameString(properties.className)
            };
            const children = childrenCreator(node.children);
            return (0, ($parcel$interopDefault($5uXOq))).createElement(tagName, {
                key: key,
                ...props
            }, children);
        }
    }
});
parcelRegister("47G8n", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$6c8606b73bc0e8d9$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $loZC0;
    var $barbM;
    function $6c8606b73bc0e8d9$export$2e2bcd8739ae039({ testId: testId, bidiCharacter: bidiCharacter, skipChildren: skipChildren, tooltipEnabled: tooltipEnabled, label: label = 'Bidirectional characters change the order that text is rendered. This could be used to obscure malicious code.' }) {
        if (tooltipEnabled) return ((0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("loZC0")).default), {
            content: label,
            tag: $6c8606b73bc0e8d9$var$CustomizedTagWithRef
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("barbM")).Decorator), {
            testId: testId,
            bidiCharacter: bidiCharacter
        }, skipChildren ? null : bidiCharacter)));
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("barbM")).Decorator), {
            testId: testId,
            bidiCharacter: bidiCharacter
        }, skipChildren ? null : bidiCharacter);
    }
    const $6c8606b73bc0e8d9$var$CustomizedTagWithRef = (0, ($parcel$interopDefault($5uXOq))).forwardRef((props, ref)=>{
        const { children: children, ...rest } = props;
        return (0, ($parcel$interopDefault($5uXOq))).createElement("span", {
            ...rest,
            ref: ref
        }, children);
    });
});
parcelRegister("barbM", function(module, exports) {
    $parcel$export(module.exports, "Decorator", ()=>$c9e1f2aa239b72a9$export$a592b67c93d52467);
    var $5uXOq = parcelRequire("5uXOq");
    var $f8Sb3;
    var $AHUyh;
    const $c9e1f2aa239b72a9$var$decoration = (0, (0, parcelRequire("f8Sb3")).css)({
        position: 'relative',
        ':before': {
            display: 'inline-flex',
            padding: `${"var(--ds-space-0, 0px)"} ${"var(--ds-space-050, 4px)"}`,
            alignItems: 'center',
            justifyContent: 'center',
            flexDirection: 'row',
            background: `var(--ds-background-warning, ${(0, $72ba03e317f3d228$export$41060a744ab0b7ae)})`,
            color: "var(--ds-text-warning, #7F5F01)",
            content: '"<"attr(data-bidi-character-code)">"',
            fontSize: '14px',
            fontStyle: 'normal',
            lineHeight: '18px',
            pointerEvents: 'auto'
        },
        ':hover:before': {
            background: `var(--ds-background-warning-hovered, ${(0, $72ba03e317f3d228$export$41060a744ab0b7ae)})`,
            color: "var(--ds-text-warning, #533F04)"
        }
    });
    function $c9e1f2aa239b72a9$export$a592b67c93d52467({ bidiCharacter: bidiCharacter, children: children, testId: testId }) {
        const bidiCharacterCode = $c9e1f2aa239b72a9$var$getBidiCharacterCode(bidiCharacter);
        return (0, (0, parcelRequire("f8Sb3")).jsx)((0, $5uXOq.Fragment), null, (0, (0, parcelRequire("f8Sb3")).jsx)("span", {
            css: $c9e1f2aa239b72a9$var$decoration,
            "data-testid": testId,
            "data-bidi-character-code": bidiCharacterCode,
            "aria-hidden": "true"
        }, children), (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("AHUyh")).default), {
            testId: testId && `${testId}--visually-hidden`
        }, (0, (0, parcelRequire("f8Sb3")).jsx)("mark", null, bidiCharacterCode)));
    }
    function $c9e1f2aa239b72a9$var$getBidiCharacterCode(bidiCharacter) {
        const bidiCharacterCode = bidiCharacter.codePointAt(0)?.toString(16);
        return `U+${bidiCharacterCode}`;
    }
});
parcelRegister("dE7lx", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$511185a3065642e8$export$2e2bcd8739ae039);
    const $511185a3065642e8$export$ecb256e6a1f5ee7e = /[\u202A-\u202E\u2066-\u2069]/g;
    function $511185a3065642e8$export$2e2bcd8739ae039(originalText, decorate) {
        const matches = [
            ...originalText.matchAll($511185a3065642e8$export$ecb256e6a1f5ee7e)
        ];
        if (matches.length === 0) return originalText;
        let children = [];
        let mappedTo = 0;
        for (const match of matches){
            if (mappedTo !== match.index) children.push(originalText.substring(mappedTo, match.index));
            children.push(decorate({
                bidiCharacter: match[0],
                index: match.index
            }));
            mappedTo = match.index + match[0].length;
        }
        if (mappedTo !== originalText.length) children.push(originalText.substring(mappedTo, originalText.length));
        return children;
    }
});
parcelRegister("4CTxJ", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$cfcf1fd1989f08a6$export$2e2bcd8739ae039);
    var $laCYD;
    function $cfcf1fd1989f08a6$export$2e2bcd8739ae039(codeBidiWarningConfig) {
        let childrenCount = 0;
        return (children)=>{
            childrenCount += 1;
            return children.map((child, i)=>(0, (0, parcelRequire("laCYD")).default)({
                    node: child,
                    codeBidiWarningConfig: codeBidiWarningConfig,
                    key: `code-segment-${childrenCount}-${i}`
                }));
        };
    }
});
parcelRegister("kN6qz", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("as9qs").then(()=>parcelRequire('5zvIl'));
});
parcelRegister("lOZGq", function(module, exports) {
    $parcel$export(module.exports, "CopyAction", ()=>$b3c0013295f8779c$export$958df07cbf9735fc);
    $parcel$export(module.exports, "ActionContainer", ()=>$b3c0013295f8779c$export$37ab3bdebc286ca);
    var $5uXOq = parcelRequire("5uXOq");
    var $1UU68;
    var $iozM6;
    var $6Ll2T;
    var $99gde;
    var $8zOmE;
    var $fEogx;
    const $b3c0013295f8779c$export$2ce9877c9c1aa16 = {
        PROMPT: 'Copy',
        SUCCESS: 'Copied!',
        FAILURE: 'Copy to clipboard failed'
    };
    const $b3c0013295f8779c$export$958df07cbf9735fc = ({ source: source, actionSubjectId: actionSubjectId })=>{
        const [tooltipMessage, setTooltipMessage] = (0, $5uXOq.useState)($b3c0013295f8779c$export$2ce9877c9c1aa16.PROMPT);
        const handleSuccess = (0, $5uXOq.useCallback)(()=>{
            setTooltipMessage($b3c0013295f8779c$export$2ce9877c9c1aa16.SUCCESS);
        }, [
            setTooltipMessage
        ]);
        const handleError = (0, $5uXOq.useCallback)(()=>{
            setTooltipMessage($b3c0013295f8779c$export$2ce9877c9c1aa16.FAILURE);
        }, [
            setTooltipMessage
        ]);
        const writeToClipboard = (0, $5uXOq.useCallback)((_, analyticsEvent)=>{
            actionSubjectId && (0, (0, parcelRequire("8zOmE")).fireUIAnalytics)(analyticsEvent, 'clicked button', actionSubjectId);
            navigator.clipboard.writeText(source).then(handleSuccess, handleError);
        }, [
            source,
            handleSuccess,
            handleError,
            actionSubjectId
        ]);
        const resetMessage = (0, $5uXOq.useCallback)(()=>{
            setTooltipMessage($b3c0013295f8779c$export$2ce9877c9c1aa16.PROMPT);
        }, [
            setTooltipMessage
        ]);
        function shouldRender() {
            if (typeof document !== 'undefined') return Boolean(navigator?.clipboard?.writeText);
        }
        return shouldRender() ? (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("fEogx")).Action), {
            icon: (0, ($parcel$interopDefault((0, parcelRequire("iozM6"))))),
            label: tooltipMessage,
            onClick: writeToClipboard,
            onMouseOver: resetMessage,
            onFocus: resetMessage,
            "aria-live": "assertive",
            "aria-atomic": "true",
            name: "Copy"
        }) : null;
    };
    const $b3c0013295f8779c$var$stopPropagation = (event)=>event.stopPropagation();
    const $b3c0013295f8779c$export$37ab3bdebc286ca = ({ children: children })=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("6Ll2T")).default), {
            xcss: $b3c0013295f8779c$var$absolutePositionWrapperStyles,
            onMouseDown: $b3c0013295f8779c$var$stopPropagation
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("1UU68")).default), {
            label: "actions"
        }, children));
    const $b3c0013295f8779c$var$absolutePositionWrapperStyles = (0, (0, parcelRequire("99gde")).xcss)({
        position: 'absolute',
        top: 'space.0',
        right: 'space.0',
        padding: 'space.050',
        zIndex: 'flag'
    });
});
parcelRegister("iozM6", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $d646380862d200fa$var$_react = $d646380862d200fa$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $d646380862d200fa$var$_copy = $d646380862d200fa$var$_interopRequireDefault((parcelRequire("4BWWV")));
    var $d646380862d200fa$var$_copy2 = $d646380862d200fa$var$_interopRequireDefault((parcelRequire("gu5qi")));
    function $d646380862d200fa$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $d646380862d200fa$var$CopyIcon = (props)=>$d646380862d200fa$var$_react.default.createElement($d646380862d200fa$var$_copy.default, Object.assign({
            LEGACY_fallbackIcon: $d646380862d200fa$var$_copy2.default
        }, props));
    $d646380862d200fa$var$CopyIcon.Name = 'CopyIconMigration';
    var $d646380862d200fa$var$_default = module.exports.default = $d646380862d200fa$var$CopyIcon;
});
parcelRegister("4BWWV", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $35b85845832ae75f$var$_react = $35b85845832ae75f$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $35b85845832ae75f$var$_UNSAFE_baseNew = $35b85845832ae75f$var$_interopRequireDefault((parcelRequire("dTInF")));
    function $35b85845832ae75f$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $35b85845832ae75f$var$CopyIcon = (props)=>$35b85845832ae75f$var$_react.default.createElement($35b85845832ae75f$var$_UNSAFE_baseNew.default, Object.assign({
            dangerouslySetGlyph: `<path stroke="currentcolor" stroke-width="1.5" d="M1.75 3c0-.69.56-1.25 1.25-1.25h8c.69 0 1.25.56 1.25 1.25v8c0 .69-.56 1.25-1.25 1.25H3c-.69 0-1.25-.56-1.25-1.25z"/><path stroke="currentcolor" stroke-width="1.5" d="M6 15.25h6.75a2.5 2.5 0 0 0 2.5-2.5V6"/>`
        }, props));
    $35b85845832ae75f$var$CopyIcon.displayName = 'CopyIcon';
    var $35b85845832ae75f$var$_default = module.exports.default = $35b85845832ae75f$var$CopyIcon;
});
parcelRegister("gu5qi", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $c003a79a3c70e52e$var$_react = $c003a79a3c70e52e$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $7p1ve;
    var $c003a79a3c70e52e$var$_copy = $c003a79a3c70e52e$var$_interopRequireDefault((parcelRequire("4BWWV")));
    function $c003a79a3c70e52e$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $c003a79a3c70e52e$var$CopyIcon = (props)=>$c003a79a3c70e52e$var$_react.default.createElement((0, parcelRequire("7p1ve")).IconFacade, Object.assign({
            dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill="currentcolor"><path d="M10 19h8V8h-8zM8 7.992C8 6.892 8.902 6 10.009 6h7.982C19.101 6 20 6.893 20 7.992v11.016c0 1.1-.902 1.992-2.009 1.992H10.01A2 2 0 0 1 8 19.008z"/><path d="M5 16V4.992C5 3.892 5.902 3 7.009 3H15v13zm2 0h8V5H7z"/></g></svg>`
        }, props, {
            newIcon: $c003a79a3c70e52e$var$_copy.default
        }));
    $c003a79a3c70e52e$var$CopyIcon.displayName = 'CopyIcon';
    var $c003a79a3c70e52e$var$_default = module.exports.default = $c003a79a3c70e52e$var$CopyIcon;
});
parcelRegister("fEogx", function(module, exports) {
    $parcel$export(module.exports, "Action", ()=>$e6da05ade6347218$export$e19cd5f9376f8cee);
    var $5uXOq = parcelRequire("5uXOq");
    var $9jNMw;
    var $loZC0;
    const $e6da05ade6347218$export$e19cd5f9376f8cee = ({ icon: icon, label: label, tooltipLabel: tooltipLabel, isLoading: isLoading, ...buttonProps })=>{
        const updateTooltip = (0, $5uXOq.useRef)();
        (0, $5uXOq.useLayoutEffect)(()=>{
            updateTooltip.current?.();
        }, [
            tooltipLabel,
            label
        ]);
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("loZC0")).default), {
            content: ({ update: update })=>{
                updateTooltip.current = update;
                return tooltipLabel || label;
            },
            position: "top"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("9jNMw")).default), {
            isLoading: isLoading,
            appearance: "subtle",
            icon: icon,
            label: label,
            spacing: "compact",
            ...buttonProps
        }));
    };
});
parcelRegister("bTyOW", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$5073396748f92b4e$export$2e2bcd8739ae039);
    $parcel$export(module.exports, "viewBox", ()=>$5073396748f92b4e$export$a179c88182cb9d56);
    $parcel$export(module.exports, "srcLight", ()=>($parcel$interopDefault((parcelRequire("5I4tL")))));
    $parcel$export(module.exports, "srcDark", ()=>($parcel$interopDefault((parcelRequire("h8kvT")))));
    var $dCLgq;
    var $h8kvT = parcelRequire("h8kvT");
    var $5I4tL = parcelRequire("5I4tL");
    const $5073396748f92b4e$var$Illustration = (0, (0, parcelRequire("dCLgq")).createIllustration)({
        srcLight: ($parcel$interopDefault($5I4tL)),
        srcDark: ($parcel$interopDefault($h8kvT))
    });
    var $5073396748f92b4e$export$2e2bcd8739ae039 = $5073396748f92b4e$var$Illustration;
    const $5073396748f92b4e$export$a179c88182cb9d56 = [
        0,
        0,
        164,
        218
    ];
});
parcelRegister("h8kvT", function(module, exports) {
    module.exports = new URL("error-darkmode.9dba78cd.svg", import.meta.url).toString();
});
parcelRegister("5I4tL", function(module, exports) {
    module.exports = new URL("error.b7de7f77.svg", import.meta.url).toString();
});
parcelRegister("fC09Q", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$bb376757c4acc5ab$export$2e2bcd8739ae039);
    var $dCLgq;
    var $3pGSh = parcelRequire("3pGSh");
    const $bb376757c4acc5ab$var$Illustration = (0, (0, parcelRequire("dCLgq")).createIllustration)({
        srcLight: ($parcel$interopDefault($3pGSh)),
        srcDark: ($parcel$interopDefault($3pGSh))
    });
    var $bb376757c4acc5ab$export$2e2bcd8739ae039 = $bb376757c4acc5ab$var$Illustration;
    const $bb376757c4acc5ab$export$a179c88182cb9d56 = [
        0,
        0,
        167,
        226
    ];
});
parcelRegister("3pGSh", function(module, exports) {
    module.exports = new URL("search-error.a6df7c97.svg", import.meta.url).toString();
});
parcelRegister("4AdE6", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$135a9e70a6f11b3e$export$2e2bcd8739ae039);
    var $7VHMR;
    var $135a9e70a6f11b3e$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        notFoundDocumentTitleJsm: {
            "id": "servicedesk-spa-commons.common.utils.errors.not-found-document-title-jsm",
            "defaultMessage": "Project not found - Service project"
        },
        notFoundTitle: {
            "id": "servicedesk-spa-commons.common.utils.errors.not-found-title",
            "defaultMessage": "This project isn't available"
        },
        notFoundDescription: {
            "id": "servicedesk-spa-commons.common.utils.errors.not-found-description",
            "defaultMessage": "It may have been deleted or your permissions may have changed"
        },
        notFoundAction: {
            "id": "servicedesk-spa-commons.common.utils.errors.not-found-action",
            "defaultMessage": "View a list of all projects"
        },
        genericDocumentTitleJsm: {
            "id": "servicedesk-spa-commons.common.utils.errors.generic-document-title-jsm",
            "defaultMessage": "Error - Service project"
        },
        genericErrorTitle: {
            "id": "servicedesk-spa-commons.common.utils.errors.generic-error-title",
            "defaultMessage": "An error occurred"
        },
        genericErrorDescription: {
            "id": "servicedesk-spa-commons.common.utils.errors.generic-error-description",
            "defaultMessage": "An error occurred while loading this page"
        }
    });
});
parcelRegister("4S0uJ", function(module, exports) {
    $parcel$export(module.exports, "PageStyle", ()=>$7307247c9fc02c84$export$c59987a647e9a55);
    var $5uXOq = parcelRequire("5uXOq");
    var $bwpsq;
    var $dUzNt;
    const $7307247c9fc02c84$export$c59987a647e9a55 = ({ Page: Page, children: children })=>(0, ($parcel$interopDefault($5uXOq))).createElement($7307247c9fc02c84$var$JSDSpaPageWrapper, null, (0, ($parcel$interopDefault($5uXOq))).createElement(Page, null, children));
    $7307247c9fc02c84$export$c59987a647e9a55.defaultProps = {
        Page: (0, (0, parcelRequire("dUzNt")).default)
    };
    var $7307247c9fc02c84$export$2e2bcd8739ae039 = $7307247c9fc02c84$export$c59987a647e9a55;
    const $7307247c9fc02c84$var$JSDSpaPageWrapper = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_18s8zdiv",
                __cmplp.className
            ])
        });
    });
});
parcelRegister("dUzNt", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$1ee69114caaf0a79$export$2e2bcd8739ae039);
    var $ip1ks;
    var $esRRj;
    var $PhrmH;
    var $1ee69114caaf0a79$export$2e2bcd8739ae039 = (0, (0, parcelRequire("ip1ks")).default);
});
parcelRegister("ip1ks", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$c50f4f87827a8a74$export$2e2bcd8739ae039);
    var $f8Sb3;
    var $2xIx0;
    function $c50f4f87827a8a74$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
        return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
    }
    const $c50f4f87827a8a74$var$bannerStyles = {
        name: "4oew4k",
        styles: "width:100%;position:fixed"
    };
    const $c50f4f87827a8a74$var$bannerContainerStyles = {
        name: "1x3pv69",
        styles: "width:100%;position:relative;z-index:3;flex:1 0 auto;transition:height 0.25s ease-in-out"
    };
    const $c50f4f87827a8a74$var$pageContentStyles = {
        name: "15n167b",
        styles: "min-width:0;position:relative;z-index:1;flex:1 1 auto"
    };
    const $c50f4f87827a8a74$var$wrapperStyles = {
        name: "m5v4sl",
        styles: "display:flex;width:100%;min-height:100%;flex-direction:column"
    };
    const $c50f4f87827a8a74$var$mainContainerStyles = {
        name: "1cete8c",
        styles: "display:flex;flex:1 1 auto"
    };
    const $c50f4f87827a8a74$var$navigationStyles = {
        name: "wrqbg1",
        styles: "position:relative;z-index:2"
    };
    const $c50f4f87827a8a74$var$Page = ({ isBannerOpen: isBannerOpen = false, bannerHeight: bannerHeight = (0, (0, parcelRequire("2xIx0")).defaultBannerHeight), banner: banner, navigation: navigation, children: children, testId: testId })=>{
        return (0, (0, parcelRequire("f8Sb3")).jsx)("div", {
            css: $c50f4f87827a8a74$var$wrapperStyles,
            "data-testid": testId
        }, banner ? (0, (0, parcelRequire("f8Sb3")).jsx)("div", {
            css: $c50f4f87827a8a74$var$bannerContainerStyles,
            style: {
                height: isBannerOpen ? `${bannerHeight}px` : '0'
            },
            "aria-hidden": !isBannerOpen,
            "data-testid": testId ? `${testId}--banner-container` : undefined
        }, (0, (0, parcelRequire("f8Sb3")).jsx)("div", {
            css: $c50f4f87827a8a74$var$bannerStyles
        }, banner)) : null, (0, (0, parcelRequire("f8Sb3")).jsx)("div", {
            css: $c50f4f87827a8a74$var$mainContainerStyles
        }, (0, (0, parcelRequire("f8Sb3")).jsx)("div", {
            css: $c50f4f87827a8a74$var$navigationStyles
        }, navigation), (0, (0, parcelRequire("f8Sb3")).jsx)("div", {
            css: $c50f4f87827a8a74$var$pageContentStyles
        }, children)));
    };
    var $c50f4f87827a8a74$export$2e2bcd8739ae039 = $c50f4f87827a8a74$var$Page;
});
parcelRegister("2xIx0", function(module, exports) {
    $parcel$export(module.exports, "defaultGridColumns", ()=>$03960cd5eff6a11d$export$74797698e12f8baa);
    $parcel$export(module.exports, "defaultGridColumnWidth", ()=>$03960cd5eff6a11d$export$b8241a1616ab1b96);
    $parcel$export(module.exports, "spacingMapping", ()=>$03960cd5eff6a11d$export$2a89a65a43bab52d);
    $parcel$export(module.exports, "defaultSpacing", ()=>$03960cd5eff6a11d$export$8ec7372efd74b753);
    $parcel$export(module.exports, "defaultBannerHeight", ()=>$03960cd5eff6a11d$export$d77f83c3d17a7b8a);
    $parcel$export(module.exports, "defaultMedium", ()=>$03960cd5eff6a11d$export$f8725d21f81f3e01);
    $parcel$export(module.exports, "defaultLayout", ()=>$03960cd5eff6a11d$export$2303d2bd9eeff99a);
    $parcel$export(module.exports, "varColumnsNum", ()=>$03960cd5eff6a11d$export$9ddc3632bbfb8966);
    $parcel$export(module.exports, "varColumnSpan", ()=>$03960cd5eff6a11d$export$8b7e31f391e6e681);
    $parcel$export(module.exports, "varGridSpacing", ()=>$03960cd5eff6a11d$export$936829b4511db3e4);
    const $03960cd5eff6a11d$export$3aaf3a78c909ea56 = 8;
    const $03960cd5eff6a11d$export$74797698e12f8baa = 12;
    const $03960cd5eff6a11d$export$b8241a1616ab1b96 = $03960cd5eff6a11d$export$3aaf3a78c909ea56 * 10;
    const $03960cd5eff6a11d$export$2a89a65a43bab52d = {
        comfortable: $03960cd5eff6a11d$export$3aaf3a78c909ea56 * 5,
        cosy: $03960cd5eff6a11d$export$3aaf3a78c909ea56 * 2,
        compact: $03960cd5eff6a11d$export$3aaf3a78c909ea56 * 0.5
    };
    const $03960cd5eff6a11d$export$8ec7372efd74b753 = 'cosy';
    const $03960cd5eff6a11d$export$d77f83c3d17a7b8a = 52;
    const $03960cd5eff6a11d$export$f8725d21f81f3e01 = 0;
    const $03960cd5eff6a11d$export$2303d2bd9eeff99a = 'fixed';
    const $03960cd5eff6a11d$export$9ddc3632bbfb8966 = '--ds-columns-num';
    const $03960cd5eff6a11d$export$8b7e31f391e6e681 = '--ds-column-span';
    const $03960cd5eff6a11d$export$936829b4511db3e4 = '--ds-grid-spacing';
});
parcelRegister("esRRj", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$a731a05bdccc64ea$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $2xIx0;
    var $2cP5D;
    var $PhrmH;
    var $6MCgd;
    const $a731a05bdccc64ea$var$GridWrapper = ({ spacing: spacingProp, columns: columnsProp, layout: layout, testId: testId, children: children, theme: theme })=>{
        const { isRoot: isRoot } = (0, $5uXOq.useContext)((0, (0, parcelRequire("6MCgd")).GridContext));
        const { medium: medium } = (0, $5uXOq.useContext)((0, (0, parcelRequire("PhrmH")).GridColumnContext));
        const defaultColumns = medium > 0 ? medium : (0, (0, parcelRequire("2xIx0")).defaultGridColumns);
        const spacing = spacingProp ?? theme?.spacing ?? (0, (0, parcelRequire("2xIx0")).defaultSpacing);
        const columns = columnsProp ?? theme?.columns ?? defaultColumns;
        const isNested = theme?.isNestedGrid ?? !isRoot;
        const contextValue = (0, $5uXOq.useMemo)(()=>({
                isRoot: false,
                isNested: isNested,
                spacing: spacing,
                columns: columns
            }), [
            spacing,
            columns,
            isNested
        ]);
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("6MCgd")).GridContext).Provider, {
            value: contextValue
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("2cP5D")).Grid), {
            layout: layout,
            testId: testId
        }, children));
    };
    var $a731a05bdccc64ea$export$2e2bcd8739ae039 = $a731a05bdccc64ea$var$GridWrapper;
});
parcelRegister("2cP5D", function(module, exports) {
    $parcel$export(module.exports, "Grid", ()=>$674dfadcfd40015c$export$ef2184bd89960b14);
    var $5uXOq = parcelRequire("5uXOq");
    var $f8Sb3;
    var $2xIx0;
    var $6MCgd;
    function $674dfadcfd40015c$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
        return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
    }
    const $674dfadcfd40015c$var$gridStyles = (0, (0, parcelRequire("f8Sb3")).css)({
        display: 'flex',
        margin: '0 auto',
        padding: `0 calc(var(${(0, (0, parcelRequire("2xIx0")).varGridSpacing)}) / 2)`,
        position: 'relative',
        alignItems: 'flex-start',
        flexWrap: 'wrap'
    });
    const $674dfadcfd40015c$var$gridLayoutStyles = {
        fixed: (0, (0, parcelRequire("f8Sb3")).css)({
            maxWidth: `calc(var(${(0, (0, parcelRequire("2xIx0")).varColumnsNum)}) * ${(0, (0, parcelRequire("2xIx0")).defaultGridColumnWidth)}px)`
        }),
        fluid: {
            name: "qhxz92",
            styles: "max-width:100%"
        }
    };
    const $674dfadcfd40015c$var$nestedGridStyles = (0, (0, parcelRequire("f8Sb3")).css)({
        margin: `0 calc(-1 * var(${(0, (0, parcelRequire("2xIx0")).varGridSpacing)}))`
    });
    const $674dfadcfd40015c$export$ef2184bd89960b14 = ({ layout: layout = (0, (0, parcelRequire("2xIx0")).defaultLayout), testId: testId, children: children })=>{
        const { isNested: isNested, columns: columns, spacing: spacing } = (0, $5uXOq.useContext)((0, (0, parcelRequire("6MCgd")).GridContext));
        return (0, (0, parcelRequire("f8Sb3")).jsx)("div", {
            css: [
                $674dfadcfd40015c$var$gridStyles,
                $674dfadcfd40015c$var$gridLayoutStyles[layout],
                isNested && $674dfadcfd40015c$var$nestedGridStyles
            ],
            style: {
                [(0, (0, parcelRequire("2xIx0")).varColumnsNum)]: columns,
                [(0, (0, parcelRequire("2xIx0")).varGridSpacing)]: `${(0, (0, parcelRequire("2xIx0")).spacingMapping)[spacing]}px`
            },
            "data-testid": testId
        }, children);
    };
});
parcelRegister("6MCgd", function(module, exports) {
    $parcel$export(module.exports, "GridContext", ()=>$d3f7b1d05770bd6c$export$11cae3e04ab99fae);
    var $5uXOq = parcelRequire("5uXOq");
    var $2xIx0;
    const $d3f7b1d05770bd6c$export$11cae3e04ab99fae = (0, $5uXOq.createContext)({
        isRoot: true,
        isNested: false,
        spacing: (0, (0, parcelRequire("2xIx0")).defaultSpacing),
        columns: (0, (0, parcelRequire("2xIx0")).defaultGridColumns)
    });
});
parcelRegister("PhrmH", function(module, exports) {
    $parcel$export(module.exports, "GridColumnContext", ()=>$505f9b94cbbad1b8$export$1229ad7112b989f5);
    $parcel$export(module.exports, "default", ()=>$505f9b94cbbad1b8$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $f8Sb3;
    var $2xIx0;
    var $6MCgd;
    var $505f9b94cbbad1b8$var$ColumnVariant;
    (function(ColumnVariant) {
        ColumnVariant["Auto"] = "auto";
        ColumnVariant["Bounded"] = "bounded";
        ColumnVariant["FullWidth"] = "fullWidth";
    })($505f9b94cbbad1b8$var$ColumnVariant || ($505f9b94cbbad1b8$var$ColumnVariant = {}));
    const $505f9b94cbbad1b8$var$getVariant = ({ medium: medium, columns: columns })=>{
        if (medium === (0, (0, parcelRequire("2xIx0")).defaultMedium)) return "auto";
        else if (medium < columns) return "bounded";
        return "fullWidth";
    };
    const $505f9b94cbbad1b8$var$availableWidth = '99.9999%';
    const $505f9b94cbbad1b8$var$singleColumnWidth = `(${$505f9b94cbbad1b8$var$availableWidth} / var(${(0, (0, parcelRequire("2xIx0")).varColumnsNum)}))`;
    const $505f9b94cbbad1b8$var$gridColumnStyles = (0, (0, parcelRequire("f8Sb3")).css)({
        minWidth: `calc(${$505f9b94cbbad1b8$var$singleColumnWidth} - var(${(0, (0, parcelRequire("2xIx0")).varGridSpacing)}))`,
        margin: `0 calc(var(${(0, (0, parcelRequire("2xIx0")).varGridSpacing)}) / 2)`,
        flexGrow: 1,
        flexShrink: 0,
        wordWrap: 'break-word'
    });
    const $505f9b94cbbad1b8$var$gridColumnWidthStyles = {
        ["auto"]: (0, (0, parcelRequire("f8Sb3")).css)({
            maxWidth: `calc(100% - var(${(0, (0, parcelRequire("2xIx0")).varGridSpacing)}))`,
            flexBasis: `auto`
        }),
        ["bounded"]: (0, (0, parcelRequire("f8Sb3")).css)({
            maxWidth: `calc(${$505f9b94cbbad1b8$var$singleColumnWidth} *  var(${(0, (0, parcelRequire("2xIx0")).varColumnSpan)}) - var(${(0, (0, parcelRequire("2xIx0")).varGridSpacing)}))`,
            flexBasis: `100%`
        }),
        ["fullWidth"]: (0, (0, parcelRequire("f8Sb3")).css)({
            maxWidth: `calc(100% - var(${(0, (0, parcelRequire("2xIx0")).varGridSpacing)}))`,
            flexBasis: `100%`
        })
    };
    const $505f9b94cbbad1b8$export$1229ad7112b989f5 = (0, $5uXOq.createContext)({
        medium: (0, (0, parcelRequire("2xIx0")).defaultMedium)
    });
    const $505f9b94cbbad1b8$var$GridColumn = ({ medium: medium = (0, (0, parcelRequire("2xIx0")).defaultMedium), children: children, testId: testId })=>{
        const { columns: columns } = (0, $5uXOq.useContext)((0, (0, parcelRequire("6MCgd")).GridContext));
        const contextValue = (0, $5uXOq.useMemo)(()=>({
                medium: medium
            }), [
            medium
        ]);
        const colSpan = Math.max(1, Math.min(medium, columns));
        const variant = $505f9b94cbbad1b8$var$getVariant({
            medium: medium,
            columns: columns
        });
        return (0, (0, parcelRequire("f8Sb3")).jsx)($505f9b94cbbad1b8$export$1229ad7112b989f5.Provider, {
            value: contextValue
        }, (0, (0, parcelRequire("f8Sb3")).jsx)("div", {
            css: [
                $505f9b94cbbad1b8$var$gridColumnStyles,
                $505f9b94cbbad1b8$var$gridColumnWidthStyles[variant]
            ],
            style: {
                [(0, (0, parcelRequire("2xIx0")).varColumnSpan)]: variant === "auto" ? 'auto' : colSpan
            },
            "data-testid": testId
        }, children));
    };
    var $505f9b94cbbad1b8$export$2e2bcd8739ae039 = $505f9b94cbbad1b8$var$GridColumn;
});
parcelRegister("cz40O", function(module, exports) {
    $parcel$export(module.exports, "SpaPageWrapper", ()=>$2099b56eb86565d0$export$577514961fbf4842);
    var $5uXOq = parcelRequire("5uXOq");
    var $kb4zh;
    var $dJl1T;
    var $9sGI6;
    var $9dbF6;
    var $9NiTW;
    var $cYaqS;
    var $8pMQX;
    const $2099b56eb86565d0$export$91f88695e0d311a5 = (props)=>{
        const { projectContext: projectContext, isLoading: isLoading, error: error, children: children, AccessCheck: AccessCheck, AuthenticationCheck: AuthenticationCheck, ProjectNotFound: ProjectNotFound, GenericError: GenericError, SubProductUpdater: SubProductUpdater } = props;
        if (isLoading) return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("kb4zh")).default), null);
        if (error) {
            (0, (0, parcelRequire("dJl1T")).default).safeErrorWithoutCustomerData('jsdspa-page-wrapper', 'rendering-error-page', error);
            return (0, ($parcel$interopDefault($5uXOq))).createElement(AuthenticationCheck, null, error.statusCode === 404 ? (0, ($parcel$interopDefault($5uXOq))).createElement(ProjectNotFound, null) : (0, ($parcel$interopDefault($5uXOq))).createElement(GenericError, null));
        }
        if (projectContext) return (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, (0, ($parcel$interopDefault($5uXOq))).createElement(SubProductUpdater, {
            subProduct: "serviceDesk"
        }), (0, ($parcel$interopDefault($5uXOq))).createElement(AuthenticationCheck, null, (0, ($parcel$interopDefault($5uXOq))).createElement(AccessCheck, null, children)));
        return null;
    };
    const $2099b56eb86565d0$export$577514961fbf4842 = (0, (0, parcelRequire("9sGI6")).default)($2099b56eb86565d0$export$91f88695e0d311a5, {
        AccessCheck: (0, (0, parcelRequire("cYaqS")).default),
        GenericError: (0, (0, parcelRequire("8pMQX")).GenericError),
        ProjectNotFound: (0, (0, parcelRequire("8pMQX")).ProjectNotFound),
        AuthenticationCheck: (0, (0, parcelRequire("9NiTW")).AuthenticationCheck),
        SubProductUpdater: (0, (0, parcelRequire("9dbF6")).SubProductUpdater)
    });
    var $2099b56eb86565d0$export$2e2bcd8739ae039 = $2099b56eb86565d0$export$577514961fbf4842;
});
parcelRegister("9dbF6", function(module, exports) {
    $parcel$export(module.exports, "SubProductUpdater", ()=>$5979c081afa32bfa$export$eb40d3df56aa5c53);
    var $5uXOq = parcelRequire("5uXOq");
    var $bNvU3;
    var $3iTiR;
    var $ero6m;
    var $54I24;
    var $8OHH4;
    const $5979c081afa32bfa$export$eb40d3df56aa5c53 = ({ allowMonolithDeferral: allowMonolithDeferral = false, ...props })=>{
        const subProduct = (0, (0, parcelRequire("8OHH4")).isSubProductProps)(props) ? props.subProduct : (0, (0, parcelRequire("ero6m")).getSubProductFromProjectType)(props.projectType);
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("bNvU3")).default), {
            op: (0, (0, parcelRequire("54I24")).default),
            args: [
                subProduct,
                allowMonolithDeferral
            ]
        }), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("3iTiR")).default), {
            subProduct: subProduct
        }));
    };
});
parcelRegister("3iTiR", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$1214b0731559b377$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $1u3Jv;
    var $hFChZ;
    var $1214b0731559b377$export$2e2bcd8739ae039 = ({ subProduct: subProduct })=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("1u3Jv")).default), {
            op: (0, (0, parcelRequire("hFChZ")).default),
            args: [
                subProduct
            ]
        });
});
parcelRegister("hFChZ", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$0e606430ead76cd8$export$2e2bcd8739ae039);
    var $dJl1T;
    var $eusud;
    var $0e606430ead76cd8$export$2e2bcd8739ae039 = (subProduct)=>{
        (0, (0, parcelRequire("eusud")).performGetRequest)(`/rest/internal/2/mauTag/${subProduct}`).catch((err)=>{
            (0, (0, parcelRequire("dJl1T")).default).safeErrorWithoutCustomerData('common.tag-mau.tag-mau-event', 'Error connecting to monolith mau tag endpoint', err);
        });
    };
});
parcelRegister("ero6m", function(module, exports) {
    $parcel$export(module.exports, "getSubProductFromProjectType", ()=>$0997694844c8a9e7$export$b1fe420ed15dff7b);
    var $16v4H;
    const $0997694844c8a9e7$export$b1fe420ed15dff7b = (projectType)=>{
        if (projectType === 'product_discovery') return 'polaris';
        return (0, (0, parcelRequire("16v4H")).subProductFromProjectType)(projectType);
    };
});
parcelRegister("54I24", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$bcbbcd48ca398ed4$export$2e2bcd8739ae039);
    var $7T84i;
    var $9B86Q;
    var $cQZXC;
    var $dJl1T;
    var $fjcgS;
    const $bcbbcd48ca398ed4$var$maybeDelayAndRace = (maybeWaitPromise, getDefaultPromise, getRacePromise)=>maybeWaitPromise ? Promise.race([
            maybeWaitPromise.then(getDefaultPromise),
            getRacePromise()
        ]) : getDefaultPromise();
    var $bcbbcd48ca398ed4$export$2e2bcd8739ae039 = async (subProduct, allowMonolithDeferral)=>{
        (0, (0, parcelRequire("fjcgS")).getAnalyticsWebClientPromise)().then((client)=>{
            client.setSubProduct(subProduct);
            if (subProduct === 'serviceDesk') client.setUIViewedAttributes({
                solutions: [
                    (0, $86344d58e71e925a$export$c8b406ad8ee0dab9)
                ]
            });
            else client.removeUIViewedAttribute('solutions');
        });
        $bcbbcd48ca398ed4$var$maybeDelayAndRace(allowMonolithDeferral ? (0, (0, parcelRequire("cQZXC")).waitForHeritage)() : null, ()=>(0, (0, parcelRequire("7T84i")).loadBridgeStrict)({
                name: 'jira/analytics/sub-product-resolver',
                wrmKeys: [
                    'wrc!com.atlassian.jira.jira-client-analytics-plugin:analytics-web-client'
                ]
            }), ()=>(0, (0, parcelRequire("9B86Q")).loadBridgeWeak)({
                name: 'jira/analytics/sub-product-resolver'
            })).then((subProductResolver)=>{
            subProductResolver.setSubProduct(subProduct);
        }).catch((e)=>(0, (0, parcelRequire("dJl1T")).default).safeErrorWithoutCustomerData('common.analytics-sub-product.sub-product-updater', 'Error connecting to monolith sub product resolver', e));
    };
});
const $86344d58e71e925a$export$c8b406ad8ee0dab9 = 'jiraServiceManagement';
parcelRegister("8OHH4", function(module, exports) {
    $parcel$export(module.exports, "isSubProductProps", ()=>$701d07b56c3e3574$export$c3063d6d7a8c075f);
    const $701d07b56c3e3574$export$c3063d6d7a8c075f = (props)=>'subProduct' in props && typeof props.subProduct === 'string';
    const $701d07b56c3e3574$export$81da4a7e1ba1dcee = (props)=>'projectType' in props && typeof props.projectType === 'string';
});
parcelRegister("cYaqS", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$f72fff5a1e4c8937$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $6jY6G;
    var $4UFLs;
    var $g3A84;
    const $f72fff5a1e4c8937$var$AccessCheck = ({ children: children })=>{
        const isSettingsRoute = (0, (0, parcelRequire("6jY6G")).useCurrentRoute)().path.includes(`${(0, $7c914880cb332728$export$967ba7bfb5ce30bd)}/:projectKey/settings/`);
        const Gate = isSettingsRoute ? (0, (0, parcelRequire("g3A84")).default) : (0, (0, parcelRequire("4UFLs")).default);
        return (0, ($parcel$interopDefault($5uXOq))).createElement(Gate, null, children);
    };
    var $f72fff5a1e4c8937$export$2e2bcd8739ae039 = $f72fff5a1e4c8937$var$AccessCheck;
});
const $7c914880cb332728$export$967ba7bfb5ce30bd = '/jira/servicedesk/projects';
parcelRegister("4UFLs", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$9befbeaff9f5385d$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $daoB1;
    var $7tQej;
    var $bmKPg;
    var $iDvG9;
    const $9befbeaff9f5385d$var$ProductAccessCheck = ({ children: children })=>{
        const { hasServiceDeskAccess: hasServiceDeskAccess } = (0, (0, parcelRequire("daoB1")).useApplicationPermissions)();
        const [projectKey = ''] = (0, (0, parcelRequire("bmKPg")).usePathParam)('projectKey');
        if (projectKey) return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("iDvG9")).default), null, children);
        return hasServiceDeskAccess ? (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, children) : (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("7tQej")).Redirect), {
            to: "/jira"
        });
    };
    var $9befbeaff9f5385d$export$2e2bcd8739ae039 = $9befbeaff9f5385d$var$ProductAccessCheck;
});
parcelRegister("iDvG9", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$34dd3dc578b1a167$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $7tQej;
    var $bmKPg;
    var $dFOAR;
    var $fhAnU;
    const $34dd3dc578b1a167$var$AgentCheck = ({ children: children })=>{
        const [projectKey = ''] = (0, (0, parcelRequire("bmKPg")).usePathParam)('projectKey');
        const [{ data: data, error: error }] = (0, (0, parcelRequire("dFOAR")).useServiceDeskContext)();
        if (data || error) {
            if (!(0, (0, parcelRequire("fhAnU")).isAccessError)(error)) {
                const { userRole: userRole = '' } = data || {};
                if (userRole === 'agent' || userRole === 'agent-project-admin') return (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, children);
                if (error) throw error;
            }
            return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("7tQej")).Redirect), {
                to: `${(0, $7c914880cb332728$export$967ba7bfb5ce30bd)}/${projectKey}/issues`
            });
        }
        return null;
    };
    var $34dd3dc578b1a167$export$2e2bcd8739ae039 = $34dd3dc578b1a167$var$AgentCheck;
});
parcelRegister("fhAnU", function(module, exports) {
    $parcel$export(module.exports, "isAccessError", ()=>$1a790f4bb1355504$export$ddaebe4928e793cb);
    const $1a790f4bb1355504$var$RESTRICTED_ACCESS_CODES = [
        (0, $3cd8a0ece36fbae5$export$a3269a3914b007e3),
        (0, $3cd8a0ece36fbae5$export$8bca792d963eb0ef),
        (0, $3cd8a0ece36fbae5$export$67d19e9a991baa07)
    ];
    const $1a790f4bb1355504$export$ddaebe4928e793cb = (error)=>error?.statusCode != null ? $1a790f4bb1355504$var$RESTRICTED_ACCESS_CODES.includes(error.statusCode) : false;
});
const $3cd8a0ece36fbae5$export$ff39ebd4bb12b718 = 201;
const $3cd8a0ece36fbae5$export$3288b14b6745c572 = 204;
const $3cd8a0ece36fbae5$export$9de493bcd9b1d977 = 400;
const $3cd8a0ece36fbae5$export$67d19e9a991baa07 = 401;
const $3cd8a0ece36fbae5$export$a3269a3914b007e3 = 403;
const $3cd8a0ece36fbae5$export$8bca792d963eb0ef = 404;
const $3cd8a0ece36fbae5$export$4a3cb39801694eee = 407;
const $3cd8a0ece36fbae5$export$fa405bbf47d510e2 = 408;
const $3cd8a0ece36fbae5$export$c09e7ea0fc79f34f = 409;
const $3cd8a0ece36fbae5$export$5244030134e99 = 412;
const $3cd8a0ece36fbae5$export$f90ac1df0b60853d = 413;
const $3cd8a0ece36fbae5$export$a447d0a965e16776 = 422;
const $3cd8a0ece36fbae5$export$3b48aba8957000cd = 426;
const $3cd8a0ece36fbae5$export$6763168a631449a2 = 429;
const $3cd8a0ece36fbae5$export$e813cd7045fcc98d = 500;
const $3cd8a0ece36fbae5$export$2ce38d41a306034e = 502;
const $3cd8a0ece36fbae5$export$974c37534b0191b1 = 503;
const $3cd8a0ece36fbae5$export$5400e8dddac3fcf3 = 504;
parcelRegister("g3A84", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$60e7d6646168c089$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $8pMQX;
    var $dFOAR;
    var $fhAnU;
    const $60e7d6646168c089$var$SettingsAccessCheck = ({ children: children })=>{
        const [{ data: serviceDeskContext, error: serviceDeskContextError }] = (0, (0, parcelRequire("dFOAR")).useServiceDeskContext)();
        const userRole = serviceDeskContext?.userRole;
        const hasAccessError = (0, (0, parcelRequire("fhAnU")).isAccessError)(serviceDeskContextError);
        if (userRole === 'agent-project-admin' && !hasAccessError) return (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, children);
        if (userRole !== undefined || hasAccessError) return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("8pMQX")).ProjectNotFound), null);
        if (serviceDeskContextError) return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("8pMQX")).GenericError), null);
        return null;
    };
    var $60e7d6646168c089$export$2e2bcd8739ae039 = $60e7d6646168c089$var$SettingsAccessCheck;
});
parcelRegister("fP2yI", function(module, exports) {
    $parcel$export(module.exports, "Header", ()=>$514ba5774a77a46a$export$8b251419efc915eb);
    var $5uXOq = parcelRequire("5uXOq");
    var $doZTA;
    var $l8dz7;
    var $2r4US;
    var $cZ1Pf;
    var $6Ll2T;
    var $fm763;
    var $k0Jvh;
    var $99gde;
    const $514ba5774a77a46a$var$headerContainerStyles = (0, (0, parcelRequire("99gde")).xcss)({
        marginTop: 'space.200',
        marginBottom: 'space.200',
        marginLeft: 'space.300',
        marginRight: 'space.300',
        gap: 'space.050'
    });
    const $514ba5774a77a46a$var$headerBorder = (0, (0, parcelRequire("99gde")).xcss)({
        borderBottom: `1px solid ${"var(--ds-border, #091E4224)"}`
    });
    const $514ba5774a77a46a$var$headerElementsSpace = (0, (0, parcelRequire("99gde")).xcss)({
        justifyContent: 'space-between',
        alignItems: 'end'
    });
    const $514ba5774a77a46a$export$8b251419efc915eb = ({ title: title, breadcrumbs: breadcrumbs, actions: actions })=>{
        const [, { push: push }] = (0, (0, parcelRequire("doZTA")).useRouter)();
        const onClick = (link)=>{
            push(link);
        };
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("k0Jvh")).default), {
            xcss: $514ba5774a77a46a$var$headerBorder
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("k0Jvh")).default), {
            xcss: $514ba5774a77a46a$var$headerContainerStyles
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("k0Jvh")).default), null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("2r4US")).default), null, breadcrumbs.map((crumb)=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("l8dz7")).default), {
                onClick: ()=>onClick(crumb.href),
                text: crumb.text
            })))), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("k0Jvh")).default), null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("fm763")).default), {
            xcss: $514ba5774a77a46a$var$headerElementsSpace
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("cZ1Pf")).default), {
            size: "large"
        }, title), actions && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("6Ll2T")).default), null, actions)))));
    };
});
parcelRegister("1BIUA", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$73c84489faf50721$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $e0Brz;
    var $jS4lj;
    var $c2D8L;
    var $gEFwt;
    var $koVbs;
    var $kwX4O;
    const $73c84489faf50721$var$ProjectSettingsBreadcrumb = ({ baseUrl: baseUrl, projectKey: projectKey, projectName: projectName })=>{
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("e0Brz")).BreadcrumbManager), null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("jS4lj")).default), null), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("gEFwt")).default), {
            baseUrl: baseUrl,
            projectKey: projectKey,
            projectName: projectName
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("c2D8L")).default), {
            breadcrumb: {
                href: `${baseUrl}/jira/servicedesk/projects/${projectKey}/reports`,
                text: formatMessage((0, (0, parcelRequire("kwX4O")).default).reportsBreadcrumbTitle),
                type: 'projectSettings'
            }
        })));
    };
    var $73c84489faf50721$export$2e2bcd8739ae039 = $73c84489faf50721$var$ProjectSettingsBreadcrumb;
});
parcelRegister("kwX4O", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$0683f400a1ea0c3e$export$2e2bcd8739ae039);
    var $7VHMR;
    var $0683f400a1ea0c3e$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        reportsBreadcrumbTitle: {
            "id": "spa-apps-servicedesk-reports-base.breadcrumb.reports-breadcrumb-title",
            "defaultMessage": "Reports"
        }
    });
});
parcelRegister("cHb7s", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$595a97230cddb61d$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $cZ1Pf;
    var $6Ll2T;
    var $99gde;
    var $cS37j;
    var $az4zD;
    const $595a97230cddb61d$var$Header = ({ title: title, breadcrumbs: breadcrumbs, intl: { formatMessage: formatMessage }, actions: actions })=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("cS37j")).default), {
            truncateTitle: true,
            breadcrumbs: breadcrumbs
        }), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("6Ll2T")).default), {
            xcss: $595a97230cddb61d$var$titleContainer
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("6Ll2T")).default), null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("cZ1Pf")).default), {
            size: "large",
            as: "h1"
        }, title && formatMessage(title))), actions && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("6Ll2T")).default), null, actions)));
    var $595a97230cddb61d$export$2e2bcd8739ae039 = (0, (0, parcelRequire("az4zD")).injectIntlV2)($595a97230cddb61d$var$Header);
    const $595a97230cddb61d$var$titleContainer = (0, (0, parcelRequire("99gde")).xcss)({
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'space-between',
        alignItems: 'flex-end'
    });
});
parcelRegister("cS37j", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$2a15efb09f101ecb$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $bwpsq;
    var $95hAT;
    const $2a15efb09f101ecb$var$PageHeader = ({ actions: actions, ...props })=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("95hAT")).default), {
            ...props,
            actions: actions ? (0, ($parcel$interopDefault($5uXOq))).createElement($2a15efb09f101ecb$var$ActionsWrapper, null, actions) : null
        });
    var $2a15efb09f101ecb$export$2e2bcd8739ae039 = $2a15efb09f101ecb$var$PageHeader;
    const $2a15efb09f101ecb$var$ActionsWrapper = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_y3gn1e5h",
                __cmplp.className
            ])
        });
    });
});
parcelRegister("95hAT", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$034db3cc90f9772f$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $6fW4E;
    const $034db3cc90f9772f$var$PageHeader = ({ innerRef: innerRef, breadcrumbs: breadcrumbs, actions: actions, bottomBar: bottomBar, children: children, id: id, disableTitleStyles: disableTitleStyles = false, truncateTitle: truncateTitle = false })=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("6fW4E")).OuterWrapper), null, breadcrumbs, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("6fW4E")).TitleWrapper), {
            truncateTitle: truncateTitle
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("6fW4E")).TitleContainer), {
            truncateTitle: truncateTitle
        }, disableTitleStyles ? children : (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("6fW4E")).StyledTitleWrapper), {
            ref: innerRef,
            truncateTitle: truncateTitle,
            id: id
        }, children)), actions && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("6fW4E")).ActionsWrapper), null, actions)), bottomBar && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("6fW4E")).BottomBarWrapper), null, " ", bottomBar, " "));
    };
    var $034db3cc90f9772f$export$2e2bcd8739ae039 = $034db3cc90f9772f$var$PageHeader;
});
parcelRegister("6fW4E", function(module, exports) {
    $parcel$export(module.exports, "OuterWrapper", ()=>$3eb2c0b3fddef147$export$edaaad985a878983);
    $parcel$export(module.exports, "StyledTitleWrapper", ()=>$3eb2c0b3fddef147$export$284be1ee64a3465c);
    $parcel$export(module.exports, "TitleWrapper", ()=>$3eb2c0b3fddef147$export$585a3b23e887288b);
    $parcel$export(module.exports, "TitleContainer", ()=>$3eb2c0b3fddef147$export$35e09ba17cc51c69);
    $parcel$export(module.exports, "ActionsWrapper", ()=>$3eb2c0b3fddef147$export$c8223871eecc8f3a);
    $parcel$export(module.exports, "BottomBarWrapper", ()=>$3eb2c0b3fddef147$export$6330225854c30dc);
    var $5uXOq = parcelRequire("5uXOq");
    var $f8Sb3;
    var $6Ll2T;
    var $99gde;
    function $3eb2c0b3fddef147$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
        return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
    }
    const $3eb2c0b3fddef147$var$truncateStyles = {
        name: "13oenf9",
        styles: "overflow-x:hidden;overflow-y:hidden;text-overflow:ellipsis;white-space:nowrap"
    };
    const $3eb2c0b3fddef147$var$outerStyles = (0, (0, parcelRequire("f8Sb3")).css)({
        margin: `${"var(--ds-space-300, 24px)"} 0 ${"var(--ds-space-200, 16px)"} 0`
    });
    const $3eb2c0b3fddef147$var$titleStyles = {
        name: "1o56te0",
        styles: "color:var(--ds-text, #172B4D);font:var(--ds-font-heading-large, normal 500 24px/28px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif);letter-spacing:normal;margin-block-start:0;outline:none"
    };
    const $3eb2c0b3fddef147$var$titleWrapperStyles = {
        name: "1wb76vg",
        styles: "display:flex;align-items:flex-start;flex-wrap:wrap"
    };
    const $3eb2c0b3fddef147$var$titleWrapperTruncateStyles = {
        name: "14gl6v0",
        styles: "flex-wrap:nowrap"
    };
    const $3eb2c0b3fddef147$var$titleContainerStyles = (0, (0, parcelRequire("f8Sb3")).css)({
        minWidth: 0,
        maxWidth: '100%',
        flex: '1 0 auto',
        flexShrink: undefined,
        marginBlockEnd: "var(--ds-space-100, 8px)"
    });
    const $3eb2c0b3fddef147$var$actionStyles = {
        name: "1ianfu6",
        styles: "max-width:100%;flex:0 0 auto;margin-block-end:var(--ds-space-100, 8px);margin-inline-start:auto;padding-inline-start:var(--ds-space-400, 32px);white-space:nowrap;>{text-align:right;}"
    };
    const $3eb2c0b3fddef147$var$titleContainerTruncateStyles = {
        name: "s2a4s9",
        styles: "flex-shrink:1"
    };
    const $3eb2c0b3fddef147$var$bottomBarStyles = (0, (0, parcelRequire("99gde")).xcss)({
        marginBlockStart: 'space.200'
    });
    const $3eb2c0b3fddef147$export$edaaad985a878983 = ({ children: children })=>{
        return (0, (0, parcelRequire("f8Sb3")).jsx)("div", {
            css: $3eb2c0b3fddef147$var$outerStyles
        }, children);
    };
    const $3eb2c0b3fddef147$export$284be1ee64a3465c = (0, ($parcel$interopDefault($5uXOq))).forwardRef(({ children: children, id: id, truncateTitle: truncateTitle }, ref)=>{
        return (0, (0, parcelRequire("f8Sb3")).jsx)("h1", {
            css: [
                $3eb2c0b3fddef147$var$titleStyles,
                truncateTitle && $3eb2c0b3fddef147$var$truncateStyles
            ],
            ref: ref,
            tabIndex: -1,
            id: id
        }, children);
    });
    const $3eb2c0b3fddef147$export$585a3b23e887288b = ({ children: children, truncateTitle: truncateTitle })=>{
        return (0, (0, parcelRequire("f8Sb3")).jsx)("div", {
            css: [
                $3eb2c0b3fddef147$var$titleWrapperStyles,
                truncateTitle && $3eb2c0b3fddef147$var$titleWrapperTruncateStyles
            ]
        }, children);
    };
    const $3eb2c0b3fddef147$export$35e09ba17cc51c69 = ({ children: children, truncateTitle: truncateTitle })=>{
        return (0, (0, parcelRequire("f8Sb3")).jsx)("div", {
            css: [
                $3eb2c0b3fddef147$var$titleContainerStyles,
                truncateTitle && $3eb2c0b3fddef147$var$titleContainerTruncateStyles
            ]
        }, children);
    };
    const $3eb2c0b3fddef147$export$c8223871eecc8f3a = ({ children: children })=>{
        return (0, (0, parcelRequire("f8Sb3")).jsx)("div", {
            css: $3eb2c0b3fddef147$var$actionStyles
        }, children);
    };
    const $3eb2c0b3fddef147$export$6330225854c30dc = ({ children: children })=>{
        return (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("6Ll2T")).default), {
            xcss: $3eb2c0b3fddef147$var$bottomBarStyles
        }, children);
    };
});
parcelRegister("gMO5K", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$b6ceb509eee39709$export$2e2bcd8739ae039);
    var $7VHMR;
    var $b6ceb509eee39709$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        projectsBreadcrumb: {
            "id": "spa-apps-servicedesk-reports-base.projects-breadcrumb",
            "defaultMessage": "Projects"
        },
        reportsBreadcrumb: {
            "id": "spa-apps-servicedesk-reports-base.reports-breadcrumb",
            "defaultMessage": "Reports"
        }
    });
});
parcelRegister("4dRjY", function(module, exports) {
    $parcel$export(module.exports, "PRODUCT_START_MARK", ()=>$9953c23a4f71adac$export$8e54fca0a680fdfd);
    $parcel$export(module.exports, "MarkProductStart", ()=>$9953c23a4f71adac$export$2a999c5f84501025);
    var $x9xyg;
    const $9953c23a4f71adac$export$8e54fca0a680fdfd = 'PRODUCT_START';
    const $9953c23a4f71adac$export$2a999c5f84501025 = ()=>{
        if (!false) {
            performance.clearMarks($9953c23a4f71adac$export$8e54fca0a680fdfd);
            (0, (0, parcelRequire("x9xyg")).setMark)($9953c23a4f71adac$export$8e54fca0a680fdfd);
        }
        return null;
    };
});
parcelRegister("4orJd", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$9112a5390193bdd4$export$2e2bcd8739ae039);
    var $7VHMR;
    var $9112a5390193bdd4$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        homePageTitle: {
            "id": "spa-apps-servicedesk-reports-home-page.home-page-title",
            "defaultMessage": "Reports"
        },
        newReportButton: {
            "id": "spa-apps-servicedesk-reports-home-page.new-report-button",
            "defaultMessage": "Create new report"
        }
    });
});
parcelRegister("h7sEe", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$6ac59ebee0d86358$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $2oKQq;
    var $6Ll2T;
    var $99gde;
    var $113Tq;
    var $koVbs;
    var $y8WG5;
    var $es2NW = parcelRequire("es2NW");
    var $4LLj5;
    var $k0laR;
    var $6PXzk;
    const $6ac59ebee0d86358$var$HomePageSpa = ({ pageContext: pageContext })=>{
        const { projectKey: projectKey } = pageContext;
        const { reportsConfig: reportsConfig, loading: loading } = (0, (0, parcelRequire("k0laR")).useReportsHomePageController)(projectKey);
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        const { data: features } = (0, (0, parcelRequire("y8WG5")).useFeatures)();
        const isEmpty = reportsConfig.reduce((accumulator, currentValue)=>accumulator && !currentValue.access, true);
        if (isEmpty && reportsConfig.length > 0 || !features?.hasReports) return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("2oKQq")).default), {
            header: formatMessage((0, (0, parcelRequire("6PXzk")).default).emptyStateHeader),
            description: formatMessage((0, (0, parcelRequire("6PXzk")).default).emptyStateDescription),
            headingLevel: 3,
            imageUrl: (0, ($parcel$interopDefault($es2NW)))
        });
        if (loading) return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("6Ll2T")).default), {
            xcss: $6ac59ebee0d86358$var$spinnerContainer
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("113Tq")).default), {
            size: "large"
        }));
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("6Ll2T")).default), {
            xcss: $6ac59ebee0d86358$var$filtersAndViewContainer
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("4LLj5")).ReportsHomePage), {
            key: projectKey,
            reportsConfig: reportsConfig,
            extraFilters: []
        }));
    };
    var $6ac59ebee0d86358$export$2e2bcd8739ae039 = $6ac59ebee0d86358$var$HomePageSpa;
    const $6ac59ebee0d86358$var$filtersAndViewContainer = (0, (0, parcelRequire("99gde")).xcss)({
        display: 'flex',
        marginTop: 'space.600',
        flexDirection: 'row',
        justifyContent: 'space-between',
        marginBottom: 'space.200'
    });
    const $6ac59ebee0d86358$var$spinnerContainer = (0, (0, parcelRequire("99gde")).xcss)({
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        height: '100%',
        marginTop: 'space.500'
    });
});
parcelRegister("es2NW", function(module, exports) {
    module.exports = new URL("no-perms-empty-state.969408f9.svg", import.meta.url).toString();
});
parcelRegister("4LLj5", function(module, exports) {
    $parcel$export(module.exports, "ReportsHomePage", ()=>$b581bc94e461f2b1$export$1375e3d3ca1a8d02);
    var $5uXOq = parcelRequire("5uXOq");
    var $koVbs;
    var $3ghJx;
    var $42Si9;
    var $2oKQq;
    var $8jqdu;
    var $96EKe;
    var $fm763;
    var $k0Jvh;
    var $99gde;
    var $es2NW = parcelRequire("es2NW");
    var $75KuK = parcelRequire("75KuK");
    var $hWIYA;
    var $aJUlH;
    var $1d0Vr;
    var $1odkE;
    const $b581bc94e461f2b1$var$searchContainer = (0, (0, parcelRequire("99gde")).xcss)({
        marginLeft: 'space.negative.250'
    });
    const $b581bc94e461f2b1$var$filterStyles = (0, (0, parcelRequire("99gde")).xcss)({
        gap: 'space.050'
    });
    const $b581bc94e461f2b1$var$filtersAndViewContainer = (0, (0, parcelRequire("99gde")).xcss)({
        justifyContent: 'space-between'
    });
    const $b581bc94e461f2b1$var$extraFiltersContainer = (0, (0, parcelRequire("99gde")).xcss)({
        gap: 'space.150'
    });
    const $b581bc94e461f2b1$export$1375e3d3ca1a8d02 = ({ reportsConfig: reportsConfig, extraFilters: extraFilters })=>{
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        const { searchForReport: searchForReport, searchValue: searchValue, filteredReportsConfig: filteredReportsConfig } = (0, (0, parcelRequire("1d0Vr")).useReportsHomePageController)(reportsConfig);
        const [viewType, setViewType] = (0, $5uXOq.useState)((0, $4528e724d9f4e3c5$export$c5ccaba974d9b5b6));
        const switchViews = (0, $5uXOq.useCallback)(()=>{
            if (viewType === (0, $4528e724d9f4e3c5$export$9586318477fbfa73)) {
                setViewType((0, $4528e724d9f4e3c5$export$c5ccaba974d9b5b6));
                return;
            }
            setViewType((0, $4528e724d9f4e3c5$export$9586318477fbfa73));
        }, [
            setViewType,
            viewType
        ]);
        const noAccess = reportsConfig.reduce((accumulator, currentValue)=>accumulator && !currentValue.access, true);
        if (noAccess && reportsConfig.length > 0) return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("2oKQq")).default), {
            header: formatMessage((0, (0, parcelRequire("1odkE")).messages).noAccessEmptyStateHeader),
            description: formatMessage((0, (0, parcelRequire("1odkE")).messages).noAccessEmptyStateDescription),
            headingLevel: 3,
            imageUrl: (0, ($parcel$interopDefault($es2NW)))
        });
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("k0Jvh")).default), null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("fm763")).default), {
            xcss: $b581bc94e461f2b1$var$filtersAndViewContainer
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("fm763")).default), {
            xcss: $b581bc94e461f2b1$var$filterStyles
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("fm763")).default), {
            xcss: $b581bc94e461f2b1$var$searchContainer
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("3ghJx")).Search), {
            onClick: searchForReport,
            placeholder: formatMessage((0, (0, parcelRequire("1odkE")).messages).searchPlaceholder),
            tooltip: formatMessage((0, (0, parcelRequire("1odkE")).messages).searchPlaceholder),
            label: formatMessage((0, (0, parcelRequire("1odkE")).messages).searchPlaceholder),
            value: searchValue
        })), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("fm763")).default), {
            xcss: $b581bc94e461f2b1$var$extraFiltersContainer
        }, extraFilters.map((item)=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("fm763")).default), null, item)))), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("fm763")).default), null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("42Si9")).default), {
            onClick: switchViews,
            iconAfter: viewType === (0, $4528e724d9f4e3c5$export$c5ccaba974d9b5b6) ? (0, ($parcel$interopDefault((0, parcelRequire("8jqdu"))))) : (0, ($parcel$interopDefault((0, parcelRequire("96EKe")))))
        }, viewType === (0, $4528e724d9f4e3c5$export$c5ccaba974d9b5b6) ? formatMessage((0, (0, parcelRequire("1odkE")).messages).swithcToListViewButton) : formatMessage((0, (0, parcelRequire("1odkE")).messages).swithcToCardViewButton)))), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("k0Jvh")).default), null, filteredReportsConfig.length > 0 ? (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, viewType === (0, $4528e724d9f4e3c5$export$c5ccaba974d9b5b6) && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("aJUlH")).ThumbnailView), {
            reportsConfig: filteredReportsConfig
        }), viewType === (0, $4528e724d9f4e3c5$export$9586318477fbfa73) && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("hWIYA")).ListView), {
            reportsConfig: filteredReportsConfig
        })) : (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("2oKQq")).default), {
            header: formatMessage((0, (0, parcelRequire("1odkE")).messages).searchEmptyStateTitle),
            description: formatMessage((0, (0, parcelRequire("1odkE")).messages).searchEmptyStateDescription),
            headingLevel: 3,
            imageUrl: (0, ($parcel$interopDefault($75KuK)))
        })));
    };
});
parcelRegister("3ghJx", function(module, exports) {
    $parcel$export(module.exports, "Search", ()=>$f1d32696f77b2b47$export$4b85d3515bd863a5);
    var $5uXOq = parcelRequire("5uXOq");
    var $f8Sb3;
    var $b2wZT;
    var $3QKc0;
    var $cNpkz;
    var $btlEg;
    function $f1d32696f77b2b47$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
        return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
    }
    const $f1d32696f77b2b47$var$searchInputContainerStyles = (0, (0, parcelRequire("f8Sb3")).css)({
        position: 'relative',
        marginInlineEnd: "var(--ds-space-100, 8px)",
        marginInlineStart: "var(--ds-space-250, 20px)",
        [`@media (max-width: ${(0, $3e3f37cc19bd8d8c$export$24ec62cee78b7042) - 1}px)`]: {
            display: 'none !important'
        }
    });
    const $f1d32696f77b2b47$var$searchInputIconStyles = {
        name: "e25v3a",
        styles: "width:20px;height:20px;position:absolute;inset-block-start:5px;inset-inline-start:10px;pointer-events:none"
    };
    const $f1d32696f77b2b47$var$newSearchBorderStyles = (0, (0, parcelRequire("f8Sb3")).css)({
        border: `${"var(--ds-border-width, 1px)"} solid`,
        '&:focus': {
            boxShadow: `inset 0 0 0 ${"var(--ds-border-width, 1px)"} var(${(0, $3e3f37cc19bd8d8c$export$d8bde68ac946124f)})`
        }
    });
    const $f1d32696f77b2b47$var$searchInputStyles = (0, (0, parcelRequire("f8Sb3")).css)({
        boxSizing: 'border-box',
        width: '220px',
        height: "var(--ds-space-400, 32px)",
        padding: `0 ${"var(--ds-space-100, 8px)"} 0 ${"var(--ds-space-500, 40px)"}`,
        backgroundColor: `var(${(0, $3e3f37cc19bd8d8c$export$13f8aa8f663f4c99)})`,
        border: '2px solid',
        borderColor: `var(${(0, $3e3f37cc19bd8d8c$export$65f656ad520ea71)})`,
        borderRadius: "var(--ds-border-radius-200, 6px)",
        color: `var(${(0, $3e3f37cc19bd8d8c$export$d81606c1fc5119bc)})`,
        font: "var(--ds-font-body, normal 400 14px/20px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)",
        outline: 'none',
        '::placeholder': {
            color: 'inherit'
        },
        '&:focus': {
            borderColor: `var(${(0, $3e3f37cc19bd8d8c$export$d8bde68ac946124f)})`
        },
        '&:hover': {
            backgroundColor: `var(${(0, $3e3f37cc19bd8d8c$export$73e44f54603a0964)})`
        }
    });
    const $f1d32696f77b2b47$var$searchIconStyles = (0, (0, parcelRequire("f8Sb3")).css)({
        [`@media (min-width: ${0, $3e3f37cc19bd8d8c$export$24ec62cee78b7042}px)`]: {
            display: 'none !important'
        }
    });
    const $f1d32696f77b2b47$var$SearchComponent = (props)=>{
        const { onClick: onClick, placeholder: placeholder, label: label, value: value } = props;
        const theme = (0, (0, parcelRequire("3QKc0")).useTheme)();
        const search = theme.mode.search;
        const onChange = (...args)=>{
            onClick && onClick(...args);
        };
        const onInputClick = (...args)=>{
            onClick && onClick(...args);
        };
        const searchInputDynamicStyles = (0, (0, parcelRequire("cNpkz")).stripEmptyProperties)({
            [(0, $3e3f37cc19bd8d8c$export$13f8aa8f663f4c99)]: search.default.backgroundColor,
            [(0, $3e3f37cc19bd8d8c$export$d81606c1fc5119bc)]: search.default.color,
            [(0, $3e3f37cc19bd8d8c$export$65f656ad520ea71)]: search.default.borderColor,
            [(0, $3e3f37cc19bd8d8c$export$d8bde68ac946124f)]: search.focus.borderColor,
            [(0, $3e3f37cc19bd8d8c$export$73e44f54603a0964)]: search.hover.backgroundColor
        });
        return (0, (0, parcelRequire("f8Sb3")).jsx)("div", {
            css: $f1d32696f77b2b47$var$searchInputContainerStyles,
            role: "search"
        }, (0, (0, parcelRequire("f8Sb3")).jsx)("div", {
            css: $f1d32696f77b2b47$var$searchInputIconStyles
        }, (0, (0, parcelRequire("f8Sb3")).jsx)((0, ($parcel$interopDefault((0, parcelRequire("b2wZT"))))), {
            color: "currentColor",
            spacing: "spacious",
            label: ""
        })), (0, (0, parcelRequire("f8Sb3")).jsx)("input", {
            style: searchInputDynamicStyles,
            css: [
                $f1d32696f77b2b47$var$searchInputStyles,
                $f1d32696f77b2b47$var$newSearchBorderStyles
            ],
            "aria-label": label,
            placeholder: placeholder,
            onChange: onChange,
            onClick: onInputClick,
            value: value
        }));
    };
    const $f1d32696f77b2b47$export$4b85d3515bd863a5 = (props)=>{
        const { placeholder: placeholder, tooltip: tooltip, label: label, value: value, ...iconButtonProps } = props;
        return (0, (0, parcelRequire("f8Sb3")).jsx)((0, $5uXOq.Fragment), null, (0, (0, parcelRequire("f8Sb3")).jsx)($f1d32696f77b2b47$var$SearchComponent, {
            onClick: iconButtonProps.onClick,
            placeholder: placeholder,
            label: label,
            value: value || ''
        }), (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("btlEg")).IconButton), {
            css: $f1d32696f77b2b47$var$searchIconStyles,
            icon: (0, (0, parcelRequire("f8Sb3")).jsx)((0, ($parcel$interopDefault((0, parcelRequire("b2wZT"))))), {
                color: "currentColor",
                spacing: "spacious",
                label: label
            }),
            tooltip: tooltip,
            ...iconButtonProps
        }));
    };
    var $f1d32696f77b2b47$export$2e2bcd8739ae039 = $f1d32696f77b2b47$export$4b85d3515bd863a5;
});
const $3e3f37cc19bd8d8c$export$30fa7cc5f2690a43 = 56;
const $3e3f37cc19bd8d8c$export$4033a111ca79977d = 1280;
const $3e3f37cc19bd8d8c$export$24ec62cee78b7042 = 1130;
const $3e3f37cc19bd8d8c$export$d8bde68ac946124f = '--ds--ans--fbc';
const $3e3f37cc19bd8d8c$export$73e44f54603a0964 = '--ds--ans--hbgc';
const $3e3f37cc19bd8d8c$export$13f8aa8f663f4c99 = '--ds--ans--bgc';
const $3e3f37cc19bd8d8c$export$d81606c1fc5119bc = '--ds--ans--c';
const $3e3f37cc19bd8d8c$export$65f656ad520ea71 = '--ds--ans--bc';
parcelRegister("8jqdu", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $60d46f2a0a86502a$var$_react = $60d46f2a0a86502a$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $7p1ve;
    function $60d46f2a0a86502a$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $60d46f2a0a86502a$var$ListIcon = (props)=>$60d46f2a0a86502a$var$_react.default.createElement((0, parcelRequire("7p1ve")).IconFacade, Object.assign({
            dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" d="M3 18a1 1 0 0 0 .99 1H20a.99.99 0 0 0 1-1v-1H3zm0-7h18V9H3zm0-4h18V6c0-.55-.44-1-.99-1H3.99A.99.99 0 0 0 3 6zm0 8h18v-2H3z"/></svg>`
        }, props));
    $60d46f2a0a86502a$var$ListIcon.displayName = 'ListIcon';
    var $60d46f2a0a86502a$var$_default = module.exports.default = $60d46f2a0a86502a$var$ListIcon;
});
parcelRegister("96EKe", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $6a14479e66d363b0$var$_react = $6a14479e66d363b0$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $7p1ve;
    var $6a14479e66d363b0$var$_grid = $6a14479e66d363b0$var$_interopRequireDefault((parcelRequire("dOJ7U")));
    function $6a14479e66d363b0$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $6a14479e66d363b0$var$MediaServicesGridIcon = (props)=>$6a14479e66d363b0$var$_react.default.createElement((0, parcelRequire("7p1ve")).IconFacade, Object.assign({
            dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill="currentcolor" fill-rule="evenodd"><rect width="8" height="8" x="3" y="3" rx="1"/><rect width="8" height="8" x="3" y="13" rx="1"/><rect width="8" height="8" x="13" y="3" rx="1"/><rect width="8" height="8" x="13" y="13" rx="1"/></g></svg>`
        }, props, {
            newIcon: $6a14479e66d363b0$var$_grid.default
        }));
    $6a14479e66d363b0$var$MediaServicesGridIcon.displayName = 'MediaServicesGridIcon';
    var $6a14479e66d363b0$var$_default = module.exports.default = $6a14479e66d363b0$var$MediaServicesGridIcon;
});
parcelRegister("dOJ7U", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $a0f2f312006db602$var$_react = $a0f2f312006db602$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $a0f2f312006db602$var$_UNSAFE_baseNew = $a0f2f312006db602$var$_interopRequireDefault((parcelRequire("dTInF")));
    function $a0f2f312006db602$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $a0f2f312006db602$var$GridIcon = (props)=>$a0f2f312006db602$var$_react.default.createElement($a0f2f312006db602$var$_UNSAFE_baseNew.default, Object.assign({
            dangerouslySetGlyph: `<path stroke="currentcolor" stroke-linejoin="round" stroke-width="1.5" d="M8 1.75H3c-.69 0-1.25.56-1.25 1.25v5M8 1.75h5c.69 0 1.25.56 1.25 1.25v5M8 1.75v12.5m0 0h5c.69 0 1.25-.56 1.25-1.25V8M8 14.25H3c-.69 0-1.25-.56-1.25-1.25V8m0 0h12.5"/>`
        }, props));
    $a0f2f312006db602$var$GridIcon.displayName = 'GridIcon';
    var $a0f2f312006db602$var$_default = module.exports.default = $a0f2f312006db602$var$GridIcon;
});
parcelRegister("75KuK", function(module, exports) {
    module.exports = new URL("search-empty-state.bd1585ad.svg", import.meta.url).toString();
});
const $4528e724d9f4e3c5$export$c5ccaba974d9b5b6 = 'THUMBNAIL';
const $4528e724d9f4e3c5$export$9586318477fbfa73 = 'LIST';
parcelRegister("hWIYA", function(module, exports) {
    $parcel$export(module.exports, "ListView", ()=>$b94b74ce31152c1b$export$84d0dd190d551cd1);
    var $5uXOq = parcelRequire("5uXOq");
    var $koVbs;
    var $doZTA;
    var $k9ie1;
    var $jRBku;
    var $6Ll2T;
    var $99gde;
    var $1Wmg5;
    var $fXCGY;
    const $b94b74ce31152c1b$export$84d0dd190d551cd1 = ({ reportsConfig: reportsConfig })=>{
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        const [, { push: push }] = (0, (0, parcelRequire("doZTA")).useRouter)();
        const [rows, setRows] = (0, $5uXOq.useState)([]);
        const head = {
            cells: [
                {
                    key: 'report',
                    content: formatMessage((0, (0, parcelRequire("fXCGY")).default).reportTableHeading)
                },
                reportsConfig.length > 0 && reportsConfig.every((config)=>config.id === 'assets-reports-home-page') ? {
                    key: 'actions',
                    content: formatMessage((0, (0, parcelRequire("fXCGY")).default).actionsTableHeading)
                } : {
                    key: 'category',
                    content: formatMessage((0, (0, parcelRequire("fXCGY")).default).categoruTableHeading)
                }
            ]
        };
        (0, $5uXOq.useEffect)(()=>{
            const tableRow = [];
            reportsConfig.forEach((config)=>{
                config.reports.forEach((report, i)=>{
                    tableRow.push({
                        key: `${config.id}-${i}`,
                        cells: [
                            {
                                key: `report-${config.id}-${i}`,
                                content: (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("jRBku")).default), {
                                    href: report.link,
                                    appearance: "subtle"
                                }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("6Ll2T")).default), {
                                    xcss: $b94b74ce31152c1b$var$cell
                                }, report.title))
                            },
                            config.sectionName === '' ? {
                                key: `actions-${config.id}-${i}`,
                                content: (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("6Ll2T")).default), {
                                    xcss: $b94b74ce31152c1b$var$cell
                                }, report.actions && report.actions?.length > 0 && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("1Wmg5")).ActionsDropdownComponent), {
                                    actions: report?.actions
                                }))
                            } : {
                                key: `category-${config.id}-${i}`,
                                content: (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("6Ll2T")).default), {
                                    xcss: $b94b74ce31152c1b$var$cell
                                }, config.sectionName)
                            }
                        ],
                        onClick: ()=>{
                            push(report.link);
                        }
                    });
                });
            });
            setRows(tableRow);
        }, [
            push,
            reportsConfig
        ]);
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("6Ll2T")).default), {
            xcss: $b94b74ce31152c1b$var$tableContainer
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("k9ie1")).default), {
            head: head,
            rows: rows,
            isFixedSize: true
        }));
    };
    const $b94b74ce31152c1b$var$tableContainer = (0, (0, parcelRequire("99gde")).xcss)({
        marginTop: 'space.200'
    });
    const $b94b74ce31152c1b$var$cell = (0, (0, parcelRequire("99gde")).xcss)({
        paddingTop: 'space.050',
        paddingBottom: 'space.050',
        cursor: 'pointer'
    });
});
parcelRegister("k9ie1", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$0e61c507a6596da6$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $gCBvJ;
    var $aGjCX;
    var $7IZ99;
    class $0e61c507a6596da6$export$2e2bcd8739ae039 extends (0, ($parcel$interopDefault($5uXOq))).Component {
        static{
            this.defaultProps = {
                defaultPage: 1,
                isLoading: false,
                isFixedSize: false,
                isRankable: false,
                onSetPage: (0, (0, parcelRequire("gCBvJ")).default),
                onSort: (0, (0, parcelRequire("gCBvJ")).default),
                rowsPerPage: Infinity
            };
        }
        UNSAFE_componentWillReceiveProps(newProps) {
            const sortKey = newProps.sortKey || this.state.sortKey;
            const sortOrder = newProps.sortOrder || this.state.sortOrder;
            const page = newProps.page || this.state.page;
            this.setState({
                page: page,
                sortKey: sortKey,
                sortOrder: sortOrder,
                rows: newProps.rows
            });
        }
        render() {
            const { page: page, sortKey: sortKey, sortOrder: sortOrder, rows: rows } = this.state;
            const { caption: caption, emptyView: emptyView, head: head, highlightedRowIndex: highlightedRowIndex, loadingSpinnerSize: loadingSpinnerSize, isLoading: isLoading, loadingLabel: loadingLabel, isFixedSize: isFixedSize, isRankable: isRankable, isRankingDisabled: isRankingDisabled, rowsPerPage: rowsPerPage, paginationi18n: paginationi18n, onRankStart: onRankStart, onPageRowsUpdate: onPageRowsUpdate, testId: testId, label: label } = this.props;
            return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("7IZ99")).default), {
                paginationi18n: paginationi18n,
                caption: caption,
                emptyView: emptyView,
                head: head,
                highlightedRowIndex: highlightedRowIndex,
                loadingSpinnerSize: loadingSpinnerSize,
                isLoading: isLoading,
                loadingLabel: loadingLabel,
                isFixedSize: isFixedSize,
                onSetPage: this.onSetPageHandler,
                onSort: this.onSortHandler,
                page: page,
                rows: rows,
                rowsPerPage: rowsPerPage,
                sortKey: sortKey,
                sortOrder: sortOrder,
                isRankable: isRankable,
                isRankingDisabled: isRankingDisabled,
                onRankEnd: this.onRankEndHandler,
                onRankStart: onRankStart,
                onPageRowsUpdate: onPageRowsUpdate,
                testId: testId,
                label: label
            });
        }
        constructor(...args){
            super(...args);
            this.state = {
                page: this.props.defaultPage,
                sortKey: this.props.defaultSortKey,
                sortOrder: this.props.defaultSortOrder,
                rows: this.props.rows
            };
            this.onSetPageHandler = (page, analyticsEvent)=>{
                const { onSetPage: onSetPage } = this.props;
                if (onSetPage) {
                    onSetPage(page, analyticsEvent);
                    this.setState({
                        page: page
                    });
                }
            };
            this.onSortHandler = ({ key: key, item: item, sortOrder: sortOrder }, analyticsEvent)=>{
                const { onSort: onSort } = this.props;
                if (onSort) {
                    onSort({
                        key: key,
                        item: item,
                        sortOrder: sortOrder
                    }, analyticsEvent);
                    this.setState({
                        sortKey: key,
                        sortOrder: sortOrder
                    });
                }
            };
            this.onRankEndIfExistsHandler = (params)=>{
                if (this.props.onRankEnd) this.props.onRankEnd(params);
            };
            this.onRankEndHandler = (params)=>{
                const { destination: destination } = params;
                const { rows: rows, page: page } = this.state;
                const { rowsPerPage: rowsPerPage } = this.props;
                if (!destination || !rows) {
                    this.onRankEndIfExistsHandler(params);
                    return;
                }
                const reordered = (0, (0, parcelRequire("aGjCX")).reorderRows)(params, rows, page, rowsPerPage);
                this.setState({
                    rows: reordered
                });
                this.onRankEndIfExistsHandler(params);
            };
        }
    }
});
parcelRegister("aGjCX", function(module, exports) {
    $parcel$export(module.exports, "getPageRows", ()=>$c2de66b2a3576b49$export$3987dc24b734dcab);
    $parcel$export(module.exports, "assertIsSortable", ()=>$c2de66b2a3576b49$export$5eb35a4771ec4090);
    $parcel$export(module.exports, "validateSortKey", ()=>$c2de66b2a3576b49$export$9133f5a8bfe8a200);
    $parcel$export(module.exports, "inlineStylesIfRanking", ()=>$c2de66b2a3576b49$export$a601f1775e10043f);
    $parcel$export(module.exports, "reorderRows", ()=>$c2de66b2a3576b49$export$c476bbe5da59992d);
    const $c2de66b2a3576b49$export$3987dc24b734dcab = (allRows, pageNumber, rowsPerPage)=>{
        if (!pageNumber || !rowsPerPage || !allRows.length) return [];
        return allRows.slice((pageNumber - 1) * rowsPerPage, pageNumber * rowsPerPage);
    };
    const $c2de66b2a3576b49$export$5eb35a4771ec4090 = (head)=>{
        if (!head || !head.cells) return;
        head.cells.forEach((cell)=>{
            if (cell.isSortable && !cell.key) try {
                throw Error("isSortable can't be set to true, if the 'key' prop is missing.");
            } catch (e) {
                console.error(e);
            }
        });
    };
    const $c2de66b2a3576b49$export$9133f5a8bfe8a200 = (sortKey, head)=>{
        if (!sortKey) return;
        const headHasKey = head && head.cells.map((cell)=>cell.key).includes(sortKey);
        if (!headHasKey) try {
            throw Error(`Cell with ${sortKey} key not found in head.`);
        } catch (e) {
            console.error(e);
        }
    };
    const $c2de66b2a3576b49$export$a601f1775e10043f = (isRanking, width, height)=>{
        if (!isRanking) return {};
        if (height) return {
            width: width,
            height: height
        };
        return {
            width: width
        };
    };
    const $c2de66b2a3576b49$export$92bcb1ed38b134a1 = (index, page, rowsPerPage)=>{
        const itemOnPreviousPages = rowsPerPage && isFinite(rowsPerPage) ? (page - 1) * rowsPerPage : 0;
        return index + itemOnPreviousPages;
    };
    const $c2de66b2a3576b49$export$c476bbe5da59992d = (rankEnd, rows, page = 1, rowsPerPage)=>{
        const { destination: destination, sourceIndex: sourceIndex } = rankEnd;
        if (!destination) return rows;
        const fromIndex = $c2de66b2a3576b49$export$92bcb1ed38b134a1(sourceIndex, page, rowsPerPage);
        const toIndex = $c2de66b2a3576b49$export$92bcb1ed38b134a1(destination.index, page, rowsPerPage);
        const reordered = rows.slice();
        const [removed] = reordered.splice(fromIndex, 1);
        reordered.splice(toIndex, 0, removed);
        return reordered;
    };
});
parcelRegister("7IZ99", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$2ddd52e269d929fa$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $2cjvv;
    var $gCBvJ;
    var $aGjCX;
    var $7senc;
    var $4cBIq;
    var $bjhuu;
    var $1xf56;
    var $67yNd;
    var $i2gva;
    var $20pg6;
    var $e29Bd;
    function $2ddd52e269d929fa$var$toggleSortOrder(currentSortOrder) {
        switch(currentSortOrder){
            case 0, $a96aa7f4f3ce56d4$export$b6abcf7fa1d94f65:
                return 0, $a96aa7f4f3ce56d4$export$1dee026a19752d6b;
            case 0, $a96aa7f4f3ce56d4$export$1dee026a19752d6b:
                return 0, $a96aa7f4f3ce56d4$export$b6abcf7fa1d94f65;
            default:
                return currentSortOrder;
        }
    }
    const $2ddd52e269d929fa$var$DynamicTable = ({ caption: caption, head: head, highlightedRowIndex: highlightedRowIndex, rows: rows, sortKey: sortKey, sortOrder: sortOrder, loadingLabel: loadingLabel, onPageRowsUpdate: onPageRowsUpdate, testId: testId, totalRows: passedDownTotalRows, label: label, isLoading: isLoading = false, isFixedSize: isFixedSize = false, rowsPerPage: rowsPerPage = Infinity, onSetPage: onSetPage = (0, (0, parcelRequire("gCBvJ")).default), onSort: providedOnSort = (0, (0, parcelRequire("gCBvJ")).default), page: page = 1, emptyView: emptyView, isRankable: isRankable = false, isRankingDisabled: isRankingDisabled = false, onRankStart: onRankStart = (0, (0, parcelRequire("gCBvJ")).default), onRankEnd: providedOnRankEnd = (0, (0, parcelRequire("gCBvJ")).default), loadingSpinnerSize: loadingSpinnerSize, paginationi18n: paginationi18n = {
        prev: 'Previous',
        next: 'Next',
        label: 'Pagination',
        pageLabel: 'Page'
    } })=>{
        const [isRanking, setIsRanking] = (0, $5uXOq.useState)(false);
        const tableBodyRef = (0, $5uXOq.useRef)(null);
        const onSort = (0, (0, parcelRequire("2cjvv")).usePlatformLeafEventHandler)({
            fn: providedOnSort,
            action: 'sorted',
            componentName: 'dynamicTable',
            packageName: "platform-pkg",
            packageVersion: "0.0.0-use.local"
        });
        const onRankEnd = (0, (0, parcelRequire("2cjvv")).usePlatformLeafEventHandler)({
            fn: providedOnRankEnd,
            action: 'ranked',
            componentName: 'dynamicTable',
            packageName: "platform-pkg",
            packageVersion: "0.0.0-use.local"
        });
        (0, $5uXOq.useEffect)(()=>{
            (0, (0, parcelRequire("aGjCX")).validateSortKey)(sortKey, head);
            (0, (0, parcelRequire("aGjCX")).assertIsSortable)(head);
        }, [
            sortKey,
            head
        ]);
        const onSortHandler = (item)=>()=>{
                const { key: key } = item;
                if (!key) return;
                if (onSort && isRankable && key === sortKey && sortOrder === (0, $a96aa7f4f3ce56d4$export$b6abcf7fa1d94f65)) {
                    onSort({
                        key: null,
                        sortOrder: null,
                        item: item
                    });
                    return;
                }
                const sortOrderFormatted = key !== sortKey ? (0, $a96aa7f4f3ce56d4$export$1dee026a19752d6b) : $2ddd52e269d929fa$var$toggleSortOrder(sortOrder);
                if (onSort) onSort({
                    key: key,
                    item: item,
                    sortOrder: sortOrderFormatted
                });
            };
        const onSetPageHandler = (page, event)=>{
            onSetPage(page, event);
        };
        const onRankStartHandler = (params)=>{
            setIsRanking(true);
            onRankStart(params);
        };
        const onRankEndHandler = (params)=>{
            setIsRanking(false);
            onRankEnd(params);
        };
        const getSpinnerSize = ()=>{
            if (loadingSpinnerSize) return loadingSpinnerSize;
            return (0, (0, parcelRequire("aGjCX")).getPageRows)(rows || [], page, rowsPerPage).length > 2 ? (0, $a96aa7f4f3ce56d4$export$7b93a10c0fefe3e3) : (0, $a96aa7f4f3ce56d4$export$71dd4c8ecd45e95f);
        };
        const renderEmptyBody = ()=>{
            if (isLoading) return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("4cBIq")).EmptyViewWithFixedHeight), {
                testId: testId
            });
            return emptyView && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("4cBIq")).EmptyViewContainer), {
                testId: testId
            }, emptyView);
        };
        const rowsLength = rows && rows.length;
        let totalPages;
        let isTotalPagesControlledExternally = false;
        if (passedDownTotalRows && Number.isInteger(passedDownTotalRows) && rowsPerPage && rowsLength && rowsLength <= passedDownTotalRows) {
            totalPages = Math.ceil(passedDownTotalRows / rowsPerPage);
            isTotalPagesControlledExternally = true;
        } else totalPages = rowsLength && rowsPerPage ? Math.ceil(rowsLength / rowsPerPage) : 0;
        totalPages = totalPages < 1 ? 1 : totalPages;
        const getPageNumber = page > totalPages ? totalPages : page;
        const rowsExist = !!rowsLength;
        const spinnerSize = getSpinnerSize();
        const emptyBody = renderEmptyBody();
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("i2gva")).default), {
            isLoading: isLoading && rowsExist,
            spinnerSize: spinnerSize,
            targetRef: ()=>tableBodyRef.current,
            testId: testId,
            loadingLabel: loadingLabel
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("7senc")).Table), {
            isFixedSize: isFixedSize,
            "aria-label": label,
            hasDataRow: rowsExist,
            testId: testId,
            isLoading: isLoading
        }, !!caption && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("7senc")).Caption), null, caption), head && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("e29Bd")).default), {
            head: head,
            onSort: onSortHandler,
            sortKey: sortKey,
            sortOrder: sortOrder,
            isRanking: isRanking,
            isRankable: isRankable,
            testId: testId
        }), rowsExist && (0, ($parcel$interopDefault($5uXOq))).createElement($2ddd52e269d929fa$var$TableBody, {
            ref: tableBodyRef,
            highlightedRowIndex: highlightedRowIndex,
            rows: rows,
            head: head,
            sortKey: sortKey,
            sortOrder: sortOrder,
            rowsPerPage: rowsPerPage,
            page: getPageNumber,
            isFixedSize: isFixedSize || false,
            onPageRowsUpdate: onPageRowsUpdate,
            isTotalPagesControlledExternally: isTotalPagesControlledExternally,
            testId: testId,
            isRankable: isRankable,
            isRanking: isRanking,
            onRankStart: onRankStartHandler,
            onRankEnd: onRankEndHandler,
            isRankingDisabled: isRankingDisabled || isLoading || false
        }))), totalPages <= 1 ? null : (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("7senc")).PaginationWrapper), {
            testId: testId
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("20pg6")).default), {
            value: getPageNumber,
            onChange: onSetPageHandler,
            total: totalPages,
            i18n: paginationi18n,
            isDisabled: isLoading,
            testId: testId
        })), !rowsExist && emptyBody && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("67yNd")).default), {
            isLoading: isLoading,
            spinnerSize: (0, $a96aa7f4f3ce56d4$export$7b93a10c0fefe3e3),
            testId: testId,
            loadingLabel: loadingLabel
        }, emptyBody));
    };
    const $2ddd52e269d929fa$var$RankableTableBody = (0, $5uXOq.lazy)(()=>(parcelRequire("1G9i6")));
    const $2ddd52e269d929fa$var$TableBody = (0, $5uXOq.forwardRef)(function TableBody({ isRankable: isRankable = false, isRanking: isRanking, onRankStart: onRankStart, onRankEnd: onRankEnd, isRankingDisabled: isRankingDisabled, ...bodyProps }, ref) {
        const canRank = isRankable && !bodyProps.sortKey;
        const [canRenderRankable, setCanRenderRankable] = (0, $5uXOq.useState)(false);
        (0, $5uXOq.useEffect)(()=>{
            if (canRank) setCanRenderRankable(true);
        }, [
            canRank
        ]);
        const nonRankableBody = (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("bjhuu")).default), {
            ref: ref,
            ...bodyProps
        });
        return canRank && canRenderRankable ? (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("1xf56")).ErrorBoundary), {
            fallback: nonRankableBody
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, $5uXOq.Suspense), {
            fallback: nonRankableBody
        }, (0, ($parcel$interopDefault($5uXOq))).createElement($2ddd52e269d929fa$var$RankableTableBody, {
            ref: ref,
            ...bodyProps,
            isRanking: isRanking,
            onRankStart: onRankStart,
            onRankEnd: onRankEnd,
            isRankingDisabled: isRankingDisabled
        }))) : nonRankableBody;
    });
    var $2ddd52e269d929fa$export$2e2bcd8739ae039 = $2ddd52e269d929fa$var$DynamicTable;
});
const $a96aa7f4f3ce56d4$export$1dee026a19752d6b = 'ASC';
const $a96aa7f4f3ce56d4$export$b6abcf7fa1d94f65 = 'DESC';
const $a96aa7f4f3ce56d4$export$71dd4c8ecd45e95f = 'small';
const $a96aa7f4f3ce56d4$export$7b93a10c0fefe3e3 = 'large';
const $a96aa7f4f3ce56d4$export$3843c586a90b9cbf = 0.22;
parcelRegister("7senc", function(module, exports) {
    $parcel$export(module.exports, "tableRowCSSVars", ()=>$1f853547f6ce5190$export$3b9ea2c10c245fdb);
    $parcel$export(module.exports, "Table", ()=>$1f853547f6ce5190$export$54ec01a60f47d33d);
    $parcel$export(module.exports, "Caption", ()=>$1f853547f6ce5190$export$32fbfacc5d962e0c);
    $parcel$export(module.exports, "PaginationWrapper", ()=>$1f853547f6ce5190$export$3e5e12dc01f20a43);
    var $5uXOq = parcelRequire("5uXOq");
    var $f8Sb3;
    var $v0afU;
    function $1f853547f6ce5190$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
        return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
    }
    const $1f853547f6ce5190$export$3b9ea2c10c245fdb = {
        CSS_VAR_HOVER_BACKGROUND: '--local-dynamic-table-hover-bg',
        CSS_VAR_HIGHLIGHTED_BACKGROUND: '--local-dynamic-table-highlighted-bg',
        CSS_VAR_HOVER_HIGHLIGHTED_BACKGROUND: '--local-dynamic-table-hover-highlighted-bg',
        CSS_VAR_ROW_FOCUS_OUTLINE: '--local-dynamic-table-row-focus-outline'
    };
    const $1f853547f6ce5190$var$fixedSizeTableStyles = {
        name: "wgb42e",
        styles: "table-layout:fixed"
    };
    const $1f853547f6ce5190$var$tableStyles = {
        name: "mul4pg",
        styles: "width:100%;border-collapse:separate;border-spacing:0px"
    };
    const $1f853547f6ce5190$var$bodyBorder = (0, (0, parcelRequire("f8Sb3")).css)({
        borderBlockEnd: `2px solid ${(0, (0, parcelRequire("v0afU")).tableBorder).borderColor}`
    });
    const $1f853547f6ce5190$export$54ec01a60f47d33d = (0, $5uXOq.forwardRef)(({ isFixedSize: isFixedSize, hasDataRow: hasDataRow, children: children, testId: testId, isLoading: isLoading, ...rest }, ref)=>{
        return (0, (0, parcelRequire("f8Sb3")).jsx)("table", {
            inert: isLoading ? '' : undefined,
            style: {
                [$1f853547f6ce5190$export$3b9ea2c10c245fdb.CSS_VAR_HOVER_BACKGROUND]: (0, (0, parcelRequire("v0afU")).row).hoverBackground,
                [$1f853547f6ce5190$export$3b9ea2c10c245fdb.CSS_VAR_HIGHLIGHTED_BACKGROUND]: (0, (0, parcelRequire("v0afU")).row).highlightedBackground,
                [$1f853547f6ce5190$export$3b9ea2c10c245fdb.CSS_VAR_HOVER_HIGHLIGHTED_BACKGROUND]: (0, (0, parcelRequire("v0afU")).row).hoverHighlightedBackground,
                [$1f853547f6ce5190$export$3b9ea2c10c245fdb.CSS_VAR_ROW_FOCUS_OUTLINE]: (0, (0, parcelRequire("v0afU")).row).focusOutline
            },
            css: [
                $1f853547f6ce5190$var$tableStyles,
                isFixedSize && $1f853547f6ce5190$var$fixedSizeTableStyles,
                hasDataRow && $1f853547f6ce5190$var$bodyBorder
            ],
            ref: ref,
            ...rest,
            "data-testid": testId && `${testId}--table`
        }, children);
    });
    const $1f853547f6ce5190$var$captionStyles = {
        name: "h9a27i",
        styles: "font:var(--ds-font-heading-medium, normal 500 20px/24px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif);margin-block-end:var(--ds-space-100, 8px);margin-block-start:var(--ds-space-300, 24px);will-change:transform"
    };
    const $1f853547f6ce5190$export$32fbfacc5d962e0c = ({ children: children })=>(0, (0, parcelRequire("f8Sb3")).jsx)("caption", {
            css: $1f853547f6ce5190$var$captionStyles
        }, children);
    const $1f853547f6ce5190$var$paginationWrapperStyles = {
        name: "zl1inp",
        styles: "display:flex;justify-content:center"
    };
    const $1f853547f6ce5190$export$3e5e12dc01f20a43 = ({ children: children, testId: testId })=>(0, (0, parcelRequire("f8Sb3")).jsx)("div", {
            css: $1f853547f6ce5190$var$paginationWrapperStyles,
            "data-testid": testId && `${testId}--pagination--container`
        }, children);
});
parcelRegister("v0afU", function(module, exports) {
    $parcel$export(module.exports, "MSThemeColors", ()=>$7375941814b05804$export$34af08ce45c78352);
    $parcel$export(module.exports, "arrow", ()=>$7375941814b05804$export$f2120bbfa5450bd2);
    $parcel$export(module.exports, "row", ()=>$7375941814b05804$export$120ff0929b202a6d);
    $parcel$export(module.exports, "head", ()=>$7375941814b05804$export$5fd5031fecdacec3);
    $parcel$export(module.exports, "tableBorder", ()=>$7375941814b05804$export$38d703b73e2cf64d);
    const $7375941814b05804$export$34af08ce45c78352 = {
        Background: 'Canvas',
        Text: 'CanvasText',
        SelectedBackground: 'Highlight',
        SelectedText: 'HighlightText'
    };
    const $7375941814b05804$export$f2120bbfa5450bd2 = {
        defaultColor: `var(--ds-icon-disabled, ${$72ba03e317f3d228$export$1ce2d1575d444ceb})`,
        selectedColor: `var(--ds-icon-subtle, ${$72ba03e317f3d228$export$e2ef2124cf4024b1})`
    };
    const $7375941814b05804$export$120ff0929b202a6d = {
        focusOutline: `var(--ds-border-focused, ${$72ba03e317f3d228$export$ecfc1dff386a3e7a})`,
        highlightedBackground: `var(--ds-background-selected, ${$72ba03e317f3d228$export$226de0355ed012f8})`,
        hoverBackground: `var(--ds-background-neutral-subtle-hovered, ${$72ba03e317f3d228$export$e655ef011c4aa1a2})`,
        hoverHighlightedBackground: `var(--ds-background-selected-hovered, ${$72ba03e317f3d228$export$8c13c2ee36917869})`
    };
    const $7375941814b05804$export$5fd5031fecdacec3 = {
        textColor: `var(--ds-text-subtlest, ${$72ba03e317f3d228$export$e2ef2124cf4024b1})`
    };
    const $7375941814b05804$export$38d703b73e2cf64d = {
        borderColor: `var(--ds-border, ${$72ba03e317f3d228$export$1ce2d1575d444ceb})`
    };
});
parcelRegister("4cBIq", function(module, exports) {
    $parcel$export(module.exports, "EmptyViewWithFixedHeight", ()=>$7b50cb98d7ed065a$export$8f45b9407d4090d7);
    $parcel$export(module.exports, "EmptyViewContainer", ()=>$7b50cb98d7ed065a$export$381ea436de119582);
    var $f8Sb3;
    function $7b50cb98d7ed065a$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
        return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
    }
    const $7b50cb98d7ed065a$var$fixedHeightStyles = {
        name: "50gc26",
        styles: "height:9rem"
    };
    const $7b50cb98d7ed065a$export$8f45b9407d4090d7 = ({ children: children, testId: testId })=>(0, (0, parcelRequire("f8Sb3")).jsx)("div", {
            css: $7b50cb98d7ed065a$var$fixedHeightStyles,
            "data-testid": testId && `${testId}--empty-view-with-fixed-height`
        }, children);
    const $7b50cb98d7ed065a$var$emptyViewContainerStyles = {
        name: "1yld51o",
        styles: "width:50%;margin:auto;padding:10px;text-align:center"
    };
    const $7b50cb98d7ed065a$export$381ea436de119582 = (props)=>{
        const { children: children, testId: testId } = props;
        return (0, (0, parcelRequire("f8Sb3")).jsx)("div", {
            css: $7b50cb98d7ed065a$var$emptyViewContainerStyles,
            "data-testid": testId && `${testId}--empty-view-container`
        }, children);
    };
});
parcelRegister("bjhuu", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$1340edfe31e64882$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $1KUVl;
    var $alATQ;
    class $1340edfe31e64882$var$BodyComponent extends (0, ($parcel$interopDefault($5uXOq))).Component {
        render() {
            const { pageRows: pageRows, head: head, isFixedSize: isFixedSize, highlightedRowIndex: highlightedRowIndex, testId: testId, forwardedRef: forwardedRef } = this.props;
            return (0, ($parcel$interopDefault($5uXOq))).createElement("tbody", {
                "data-testid": testId && `${testId}--body`,
                ref: forwardedRef
            }, pageRows.map((row, rowIndex)=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("alATQ")).default), {
                    head: head,
                    isFixedSize: isFixedSize,
                    key: row.key || rowIndex,
                    row: row,
                    isHighlighted: row.isHighlighted || !!highlightedRowIndex && (typeof highlightedRowIndex === 'number' ? highlightedRowIndex === rowIndex : highlightedRowIndex.indexOf(rowIndex) > -1),
                    testId: testId
                })));
        }
    }
    const $1340edfe31e64882$var$Body = (0, (0, parcelRequire("1KUVl")).default)((0, ($parcel$interopDefault($5uXOq))).forwardRef((props, ref)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement($1340edfe31e64882$var$BodyComponent, {
            ...props,
            forwardedRef: ref
        });
    }));
    var $1340edfe31e64882$export$2e2bcd8739ae039 = $1340edfe31e64882$var$Body;
});
parcelRegister("1KUVl", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$863593a48fd0f0c1$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $aGjCX;
    const $863593a48fd0f0c1$var$getSortingCellValue = (cells, head, sortKey)=>{
        for(let i = 0; i < cells.length; i++){
            if (head.cells[i] && head.cells[i]?.key === sortKey) return cells[i]?.key;
        }
        return undefined;
    };
    const $863593a48fd0f0c1$var$getSortedRows = (head, rows, sortKey, sortOrder)=>{
        if (!sortKey || !head) return rows;
        if (!rows) return [];
        const modifier = sortOrder === (0, $a96aa7f4f3ce56d4$export$1dee026a19752d6b) ? 1 : -1;
        const collator = new Intl.Collator(undefined, {
            numeric: true,
            sensitivity: 'accent'
        });
        const sortableRows = Array.from(rows);
        return sortableRows.sort((a, b)=>{
            const valA = $863593a48fd0f0c1$var$getSortingCellValue(a.cells, head, sortKey);
            const valB = $863593a48fd0f0c1$var$getSortingCellValue(b.cells, head, sortKey);
            if (valA === undefined || valB === undefined) return modifier;
            if (typeof valA !== typeof valB) {
                if (typeof valA === 'number') return -1;
                if (typeof valB === 'number') return 1;
                if (typeof valA === 'string') return -1;
                if (typeof valB === 'string') return 1;
            }
            if (typeof valA === 'string' && typeof valB === 'string') return modifier * collator.compare(valA, valB);
            if (!valA && valA !== 0 || valA < valB) return -modifier;
            if (!valB && valB !== 0 || valA > valB) return modifier;
            if (valA === valB) return 0;
            return 1;
        });
    };
    function $863593a48fd0f0c1$export$2e2bcd8739ae039(WrappedComponent) {
        class WithSortedPageRows extends (0, ($parcel$interopDefault($5uXOq))).Component {
            static getDerivedStateFromProps(props, state) {
                const { rows: rows, head: head, sortKey: sortKey, sortOrder: sortOrder, page: page, rowsPerPage: rowsPerPage, isTotalPagesControlledExternally: isTotalPagesControlledExternally } = props;
                (0, (0, parcelRequire("aGjCX")).validateSortKey)(sortKey, head);
                let sortedRows;
                let pageRows;
                if (isTotalPagesControlledExternally) {
                    sortedRows = rows;
                    pageRows = rows;
                } else {
                    sortedRows = $863593a48fd0f0c1$var$getSortedRows(head, rows, sortKey, sortOrder) || [];
                    pageRows = (0, (0, parcelRequire("aGjCX")).getPageRows)(sortedRows, page, rowsPerPage);
                }
                return {
                    ...state,
                    pageRows: pageRows
                };
            }
            componentDidMount() {
                this.props.onPageRowsUpdate && this.props.onPageRowsUpdate(this.state.pageRows);
            }
            componentDidUpdate(_prevProps, prevState) {
                if (this.props.onPageRowsUpdate && this.state.pageRows !== prevState.pageRows) this.props.onPageRowsUpdate(this.state.pageRows);
            }
            render() {
                const { rows: rows, head: head, sortKey: sortKey, sortOrder: sortOrder, rowsPerPage: rowsPerPage, page: page, forwardedRef: forwardedRef, ...restProps } = this.props;
                return (0, ($parcel$interopDefault($5uXOq))).createElement(WrappedComponent, {
                    pageRows: this.state.pageRows,
                    head: head,
                    ...restProps,
                    ref: forwardedRef
                });
            }
            constructor(...args){
                super(...args);
                this.state = {
                    pageRows: []
                };
            }
        }
        return (0, ($parcel$interopDefault($5uXOq))).forwardRef((props, ref)=>{
            return (0, ($parcel$interopDefault($5uXOq))).createElement(WithSortedPageRows, {
                ...props,
                forwardedRef: ref
            });
        });
    }
});
parcelRegister("alATQ", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$0c6796f853f83aaa$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $jnWKh;
    var $agbGh;
    const $0c6796f853f83aaa$var$Row = ({ row: row, head: head, testId: testId, isFixedSize: isFixedSize, isHighlighted: isHighlighted })=>{
        const { cells: cells, ...restRowProps } = row;
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("agbGh")).TableBodyRow), {
            ...restRowProps,
            isHighlighted: isHighlighted,
            ...isHighlighted ? {
                'data-ts--dynamic-table--table-row--highlighted': true
            } : null,
            testId: row.testId || testId && `${testId}--row-${restRowProps.key}`
        }, cells.map((cell, cellIndex)=>{
            const { content: content, testId: cellTestId, ...restCellProps } = cell;
            const { shouldTruncate: shouldTruncate, width: width } = (head || {
                cells: []
            }).cells[cellIndex] || {};
            return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("jnWKh")).TableBodyCell), {
                "data-testid": cellTestId || testId && `${testId}--cell-${cellIndex}`,
                ...restCellProps,
                isFixedSize: isFixedSize,
                key: cellIndex,
                shouldTruncate: shouldTruncate,
                width: width
            }, content);
        }));
    };
    var $0c6796f853f83aaa$export$2e2bcd8739ae039 = $0c6796f853f83aaa$var$Row;
});
parcelRegister("jnWKh", function(module, exports) {
    $parcel$export(module.exports, "TableBodyCell", ()=>$8784660980bab086$export$948e91fcef170792);
    var $f8Sb3;
    var $iqCjf;
    const $8784660980bab086$export$948e91fcef170792 = ({ width: width, isFixedSize: isFixedSize, shouldTruncate: shouldTruncate, innerRef: innerRef, ...props })=>(0, (0, parcelRequire("f8Sb3")).jsx)("td", {
            style: (0, (0, parcelRequire("iqCjf")).getTruncationStyleVars)({
                width: width
            }),
            css: [
                (0, (0, parcelRequire("iqCjf")).truncationWidthStyles),
                isFixedSize && shouldTruncate && (0, (0, parcelRequire("iqCjf")).fixedSizeTruncateStyles),
                isFixedSize && (0, (0, parcelRequire("iqCjf")).overflowTruncateStyles),
                (0, (0, parcelRequire("iqCjf")).cellStyles)
            ],
            ref: innerRef,
            ...props
        });
});
parcelRegister("iqCjf", function(module, exports) {
    $parcel$export(module.exports, "truncationWidthStyles", ()=>$b041d0e7b1d3197b$export$708a733455f59a29);
    $parcel$export(module.exports, "fixedSizeTruncateStyles", ()=>$b041d0e7b1d3197b$export$616c93ee022c8812);
    $parcel$export(module.exports, "overflowTruncateStyles", ()=>$b041d0e7b1d3197b$export$7f2cd17defa265d8);
    $parcel$export(module.exports, "getTruncationStyleVars", ()=>$b041d0e7b1d3197b$export$5e6497a652ae30b5);
    $parcel$export(module.exports, "cellStyles", ()=>$b041d0e7b1d3197b$export$f7913df521f684e2);
    var $f8Sb3;
    function $b041d0e7b1d3197b$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
        return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
    }
    const $b041d0e7b1d3197b$var$CSS_VAR_WIDTH = '--local-dynamic-table-width';
    const $b041d0e7b1d3197b$export$708a733455f59a29 = (0, (0, parcelRequire("f8Sb3")).css)({
        width: `var(${$b041d0e7b1d3197b$var$CSS_VAR_WIDTH})`
    });
    const $b041d0e7b1d3197b$export$616c93ee022c8812 = {
        name: "1s7jr4j",
        styles: "text-overflow:ellipsis;white-space:nowrap"
    };
    const $b041d0e7b1d3197b$export$7f2cd17defa265d8 = {
        name: "d3v9zr",
        styles: "overflow:hidden"
    };
    const $b041d0e7b1d3197b$export$5e6497a652ae30b5 = ({ width: width })=>typeof width !== 'undefined' ? {
            [$b041d0e7b1d3197b$var$CSS_VAR_WIDTH]: `${width}%`
        } : undefined;
    const $b041d0e7b1d3197b$export$f7913df521f684e2 = (0, (0, parcelRequire("f8Sb3")).css)({
        padding: `${"var(--ds-space-050, 4px)"} ${"var(--ds-space-100, 8px)"}`,
        border: 'none',
        textAlign: 'left',
        '&:first-of-type': {
            paddingInlineStart: "var(--ds-space-0, 0px)"
        },
        '&:last-child': {
            paddingInlineEnd: "var(--ds-space-0, 0px)"
        }
    });
});
parcelRegister("agbGh", function(module, exports) {
    $parcel$export(module.exports, "TableBodyRow", ()=>$47789b31b0b1d18e$export$45f39d9c38b886d5);
    var $5uXOq = parcelRequire("5uXOq");
    var $f8Sb3;
    var $7senc;
    const $47789b31b0b1d18e$var$rowStyles = (0, (0, parcelRequire("f8Sb3")).css)({
        backgroundColor: "var(--ds-background-neutral-subtle, transparent)",
        '&:focus-visible': {
            outline: `2px solid ${`var(--ds-border-focused, ${`var(${(0, (0, parcelRequire("7senc")).tableRowCSSVars).CSS_VAR_HOVER_BACKGROUND})`})`}`,
            outlineOffset: `-2px`
        }
    });
    const $47789b31b0b1d18e$var$rowBackgroundStyles = (0, (0, parcelRequire("f8Sb3")).css)({
        '&:hover': {
            backgroundColor: `var(--ds-background-neutral-subtle-hovered, ${`var(${(0, (0, parcelRequire("7senc")).tableRowCSSVars).CSS_VAR_HOVER_BACKGROUND})`})`
        }
    });
    const $47789b31b0b1d18e$var$rowHighlightedBackgroundStyles = (0, (0, parcelRequire("f8Sb3")).css)({
        backgroundColor: `var(--ds-background-selected, ${`var(${(0, (0, parcelRequire("7senc")).tableRowCSSVars).CSS_VAR_HIGHLIGHTED_BACKGROUND})`})`,
        '&:hover': {
            backgroundColor: `var(--ds-background-selected-hovered, ${`var(${(0, (0, parcelRequire("7senc")).tableRowCSSVars).CSS_VAR_HOVER_HIGHLIGHTED_BACKGROUND})`})`
        }
    });
    const $47789b31b0b1d18e$export$45f39d9c38b886d5 = (0, $5uXOq.forwardRef)(({ isHighlighted: isHighlighted, children: children, style: style, testId: testId, ...rest }, ref)=>{
        return (0, (0, parcelRequire("f8Sb3")).jsx)("tr", {
            style: style,
            css: [
                $47789b31b0b1d18e$var$rowStyles,
                isHighlighted ? $47789b31b0b1d18e$var$rowHighlightedBackgroundStyles : $47789b31b0b1d18e$var$rowBackgroundStyles
            ],
            ...rest,
            ref: ref,
            "data-testid": testId
        }, children);
    });
});
parcelRegister("1xf56", function(module, exports) {
    $parcel$export(module.exports, "ErrorBoundary", ()=>$d4e8a37cf2024d58$export$e926676385687eaf);
    var $5uXOq = parcelRequire("5uXOq");
    class $d4e8a37cf2024d58$export$e926676385687eaf extends (0, ($parcel$interopDefault($5uXOq))).Component {
        constructor(props){
            super(props);
            this.state = {
                hasError: false
            };
        }
        static getDerivedStateFromError() {
            return {
                hasError: true
            };
        }
        render() {
            if (this.state.hasError) return this.props.fallback;
            return this.props.children;
        }
    }
});
parcelRegister("67yNd", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$ad4d33547315ba00$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $113Tq;
    var $9RFqC;
    class $ad4d33547315ba00$export$2e2bcd8739ae039 extends (0, ($parcel$interopDefault($5uXOq))).Component {
        static{
            this.defaultProps = {
                isLoading: true,
                spinnerSize: (0, $a96aa7f4f3ce56d4$export$7b93a10c0fefe3e3),
                contentsOpacity: (0, $a96aa7f4f3ce56d4$export$3843c586a90b9cbf),
                loadingLabel: 'Loading table'
            };
        }
        render() {
            const { children: children, isLoading: isLoading, spinnerSize: spinnerSize, contentsOpacity: contentsOpacity, testId: testId, loadingLabel: loadingLabel } = this.props;
            return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("9RFqC")).Container), {
                testId: testId
            }, !isLoading ? children : (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("9RFqC")).ContentsContainer), {
                contentsOpacity: contentsOpacity,
                testId: testId
            }, children), isLoading && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("9RFqC")).SpinnerContainer), {
                testId: testId
            }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("113Tq")).default), {
                size: spinnerSize,
                testId: testId && `${testId}--loadingSpinner`,
                label: loadingLabel
            })));
        }
    }
});
parcelRegister("9RFqC", function(module, exports) {
    $parcel$export(module.exports, "Container", ()=>$9b63de7d07ea3f20$export$42a852a2b6b56249);
    $parcel$export(module.exports, "ContentsContainer", ()=>$9b63de7d07ea3f20$export$67c29eae8ae2137a);
    $parcel$export(module.exports, "SpinnerContainer", ()=>$9b63de7d07ea3f20$export$a5e06607a5ac6158);
    var $f8Sb3;
    function $9b63de7d07ea3f20$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
        return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
    }
    const $9b63de7d07ea3f20$export$c335a80381ec61f5 = '--contents-opacity';
    const $9b63de7d07ea3f20$var$containerStyles = {
        name: "bjn8wh",
        styles: "position:relative"
    };
    const $9b63de7d07ea3f20$export$42a852a2b6b56249 = ({ children: children, testId: testId })=>(0, (0, parcelRequire("f8Sb3")).jsx)("div", {
            css: $9b63de7d07ea3f20$var$containerStyles,
            "data-testid": testId && `${testId}--container`
        }, children);
    const $9b63de7d07ea3f20$var$contentsContainerStyles = (0, (0, parcelRequire("f8Sb3")).css)({
        opacity: `var(${$9b63de7d07ea3f20$export$c335a80381ec61f5})`,
        pointerEvents: 'none'
    });
    const $9b63de7d07ea3f20$export$67c29eae8ae2137a = ({ children: children, contentsOpacity: contentsOpacity, testId: testId })=>(0, (0, parcelRequire("f8Sb3")).jsx)("div", {
            style: {
                [$9b63de7d07ea3f20$export$c335a80381ec61f5]: contentsOpacity
            },
            css: [
                $9b63de7d07ea3f20$var$contentsContainerStyles
            ],
            "data-testid": testId && `${testId}--contents--container`
        }, children);
    const $9b63de7d07ea3f20$var$spinnerContainerStyles = {
        name: "su4u96",
        styles: "display:flex;position:absolute;inset:0;align-items:center;justify-content:center"
    };
    const $9b63de7d07ea3f20$export$a5e06607a5ac6158 = ({ children: children, testId: testId })=>(0, (0, parcelRequire("f8Sb3")).jsx)("div", {
            css: $9b63de7d07ea3f20$var$spinnerContainerStyles,
            "data-testid": testId && `${testId}--spinner--container`
        }, children);
});
parcelRegister("i2gva", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$68d4d803da2924e8$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $113Tq;
    var $9cqRz;
    class $68d4d803da2924e8$export$2e2bcd8739ae039 extends (0, ($parcel$interopDefault($5uXOq))).Component {
        static{
            this.defaultProps = {
                isLoading: true,
                spinnerSize: (0, $a96aa7f4f3ce56d4$export$7b93a10c0fefe3e3),
                contentsOpacity: `var(--ds-opacity-loading, ${`${0, $a96aa7f4f3ce56d4$export$3843c586a90b9cbf}`})`,
                loadingLabel: 'Loading table'
            };
        }
        attachListeners() {
            window.addEventListener('scroll', this.handleScroll);
            window.addEventListener('resize', this.handleResize);
        }
        detachListeners() {
            window.removeEventListener('scroll', this.handleScroll);
            window.removeEventListener('resize', this.handleResize);
        }
        updateSpinnerPosition() {
            const viewportHeight = window.innerHeight;
            const targetNode = this.getTargetNode();
            const spinnerNode = this.spinnerRef?.current;
            if (!targetNode || typeof targetNode.getBoundingClientRect !== 'function' || !spinnerNode) return;
            const targetRect = targetNode.getBoundingClientRect();
            const spinnerRect = spinnerNode.getBoundingClientRect();
            const spinnerHeight = spinnerRect.height;
            const isInViewport = this.isVerticallyVisible(targetRect, viewportHeight);
            const { top: top, bottom: bottom, height: height } = targetRect;
            if (isInViewport) {
                const canFollow = height >= spinnerHeight * 3;
                if (canFollow && !this.isFullyVerticallyVisible(targetRect, viewportHeight)) {
                    if (top >= 0) {
                        const viewportSpaceTakenByElement = viewportHeight - top;
                        const diff = viewportSpaceTakenByElement / 2 + top - spinnerHeight / 2;
                        const y = viewportSpaceTakenByElement < spinnerHeight * 3 ? top + spinnerHeight : diff;
                        this.translateSpinner(spinnerNode, y, true);
                    } else if (top < 0 && bottom > viewportHeight) {
                        const y = viewportHeight / 2 - spinnerHeight / 2;
                        this.translateSpinner(spinnerNode, y, true);
                    } else {
                        const diff = bottom / 2 - spinnerHeight / 2;
                        const y = diff < spinnerHeight ? diff - (spinnerHeight - diff) : diff;
                        this.translateSpinner(spinnerNode, y, true);
                    }
                    return;
                }
            } else {
                if (!this.isVerticallyVisible(spinnerRect, viewportHeight)) return;
            }
            const containerNode = this.containerRef?.current;
            if (containerNode && typeof containerNode.getBoundingClientRect === 'function') {
                const thisTop = containerNode.getBoundingClientRect().top;
                const y = (top - thisTop) / 2;
                this.translateSpinner(spinnerNode, y, false);
            }
        }
        render() {
            const { children: children, isLoading: isLoading, spinnerSize: spinnerSize, testId: testId, loadingLabel: loadingLabel } = this.props;
            return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("9cqRz")).Container), {
                testId: testId && `${testId}--loading--container--advanced`,
                ref: this.containerRef
            }, children, isLoading && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("9cqRz")).SpinnerBackdrop), {
                testId: testId
            }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("9cqRz")).SpinnerContainer), {
                ref: this.spinnerRef
            }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("113Tq")).default), {
                size: spinnerSize,
                testId: testId && `${testId}--loadingSpinner`,
                label: loadingLabel
            }))));
        }
        constructor(...args){
            super(...args);
            this.spinnerRef = (0, ($parcel$interopDefault($5uXOq))).createRef();
            this.containerRef = (0, ($parcel$interopDefault($5uXOq))).createRef();
            this.componentDidMount = ()=>{
                if (this.props.isLoading && this.hasTargetNode()) {
                    this.attachListeners();
                    this.updateTargetAppearance();
                    this.updateSpinnerPosition();
                }
            };
            this.UNSAFE_componentWillReceiveProps = (nextProps)=>{
                if (!nextProps.isLoading || !this.hasTargetNode(nextProps)) this.detachListeners();
                else if (!this.props.isLoading) this.attachListeners();
            };
            this.componentDidUpdate = ()=>{
                if (this.hasTargetNode()) {
                    this.updateTargetAppearance();
                    if (this.props.isLoading) this.updateSpinnerPosition();
                }
            };
            this.componentWillUnmount = ()=>{
                this.detachListeners();
            };
            this.getTargetNode = (nextProps = this.props)=>{
                const { targetRef: targetRef } = nextProps;
                const target = targetRef?.();
                return target || this.containerRef.current;
            };
            this.hasTargetNode = (nextProps)=>!!this.getTargetNode(nextProps);
            this.isVerticallyVisible = (elementRect, viewportHeight)=>{
                const { top: top, bottom: bottom } = elementRect;
                if (bottom <= 0) return false;
                return top < viewportHeight;
            };
            this.isFullyVerticallyVisible = (elementRect, viewportHeight)=>{
                const { top: top, bottom: bottom } = elementRect;
                return top >= 0 && bottom <= viewportHeight;
            };
            this.handleResize = ()=>{
                this.updateSpinnerPosition();
            };
            this.handleScroll = ()=>{
                this.updateSpinnerPosition();
            };
            this.translateSpinner = (spinnerNode, transformY, isFixed)=>{
                spinnerNode.style.position = isFixed ? 'fixed' : '';
                spinnerNode.style.transform = transformY !== 0 ? `translate3d(0, ${transformY}px, 0)` : '';
            };
            this.updateTargetAppearance = ()=>{
                const targetNode = this.getTargetNode();
                const { isLoading: isLoading, contentsOpacity: contentsOpacity } = this.props;
                if (targetNode && targetNode.style && typeof targetNode.style === 'object') {
                    targetNode.style.pointerEvents = isLoading ? 'none' : '';
                    targetNode.style.opacity = isLoading ? contentsOpacity.toString() : '';
                }
            };
        }
    }
});
parcelRegister("9cqRz", function(module, exports) {
    $parcel$export(module.exports, "Container", ()=>$aa972554a9f731ee$export$42a852a2b6b56249);
    $parcel$export(module.exports, "SpinnerBackdrop", ()=>$aa972554a9f731ee$export$aa207050321b0c53);
    $parcel$export(module.exports, "SpinnerContainer", ()=>$aa972554a9f731ee$export$a5e06607a5ac6158);
    var $5uXOq = parcelRequire("5uXOq");
    var $f8Sb3;
    function $aa972554a9f731ee$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
        return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
    }
    const $aa972554a9f731ee$var$containerStyles = {
        name: "17fhw1k",
        styles: "position:relative;margin-block-end:var(--ds-space-300, 24px)"
    };
    const $aa972554a9f731ee$export$42a852a2b6b56249 = (0, $5uXOq.forwardRef)((props, ref)=>{
        const { children: children, testId: testId, ...rest } = props;
        return ((0, (0, parcelRequire("f8Sb3")).jsx)("div", {
            css: $aa972554a9f731ee$var$containerStyles,
            ...rest,
            "data-testid": testId,
            ref: ref
        }, children));
    });
    const $aa972554a9f731ee$var$spinnerBackdropStyles = {
        name: "1yy6mjk",
        styles: "display:flex;position:absolute;inset:0;align-items:center;justify-content:center;pointer-events:none"
    };
    const $aa972554a9f731ee$export$aa207050321b0c53 = ({ children: children, testId: testId })=>(0, (0, parcelRequire("f8Sb3")).jsx)("div", {
            css: $aa972554a9f731ee$var$spinnerBackdropStyles,
            "data-testid": testId && `${testId}--spinner-backdrop`
        }, children);
    const $aa972554a9f731ee$var$spinnerContainerStyles = {
        name: "vi3nlf",
        styles: "position:relative;inset-block-start:0"
    };
    const $aa972554a9f731ee$export$a5e06607a5ac6158 = (0, $5uXOq.forwardRef)(({ children: children }, ref)=>(0, (0, parcelRequire("f8Sb3")).jsx)("div", {
            css: $aa972554a9f731ee$var$spinnerContainerStyles,
            ref: ref
        }, children));
});
parcelRegister("20pg6", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$719ae0e388181bba$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $8ZV9b;
    class $719ae0e388181bba$export$2e2bcd8739ae039 extends (0, ($parcel$interopDefault($5uXOq))).Component {
        render() {
            const { total: total, value: value = 1, i18n: i18n, testId: testId, isDisabled: isDisabled } = this.props;
            const pages = [
                ...Array(total)
            ].map((_, index)=>index + 1);
            const selectedIndex = value - 1;
            return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("8ZV9b")).default), {
                selectedIndex: selectedIndex,
                isDisabled: isDisabled,
                label: i18n?.label,
                nextLabel: i18n?.next,
                previousLabel: i18n?.prev,
                pageLabel: i18n?.pageLabel,
                onChange: this.onChange,
                pages: pages,
                testId: testId && `${testId}--pagination`
            });
        }
        constructor(...args){
            super(...args);
            this.onChange = (_event, newValue, analyticsEvent)=>{
                this.props.onChange(newValue, analyticsEvent);
            };
        }
    }
});
parcelRegister("8ZV9b", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$bffd94785d620cef$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $2cjvv;
    var $gCBvJ;
    var $cI4Vd;
    var $asmPY;
    var $80QIn;
    var $6Ll2T;
    var $fm763;
    var $99gde;
    var $aYK2t;
    var $eqjqY;
    var $ashNT;
    var $cRtpB;
    var $55OLU;
    const $bffd94785d620cef$var$analyticsAttributes = {
        componentName: 'pagination',
        packageName: "platform-pkg",
        packageVersion: "0.0.0-use.local"
    };
    const $bffd94785d620cef$var$paginationMenuStyles = (0, (0, parcelRequire("99gde")).xcss)({
        padding: 'space.0',
        margin: 'space.0'
    });
    const $bffd94785d620cef$var$paginationMenuItemStyles = (0, (0, parcelRequire("99gde")).xcss)({
        marginBlockStart: 'space.0'
    });
    const $bffd94785d620cef$var$navigatorIconWrapperStyles = (0, (0, parcelRequire("99gde")).xcss)({
        paddingInline: 'space.075'
    });
    function $bffd94785d620cef$var$NavigatorIcon({ chevronDirection: chevronDirection }) {
        const Chevron = chevronDirection === 'left' ? (0, ($parcel$interopDefault((0, parcelRequire("asmPY"))))) : (0, ($parcel$interopDefault((0, parcelRequire("80QIn")))));
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("6Ll2T")).default), {
            as: "span",
            xcss: $bffd94785d620cef$var$navigatorIconWrapperStyles
        }, (0, ($parcel$interopDefault($5uXOq))).createElement(Chevron, {
            label: "",
            LEGACY_margin: `0 ${"var(--ds-space-negative-075, -6px)"}`,
            color: "currentColor"
        }));
    }
    function $bffd94785d620cef$var$InnerPagination({ components: components = (0, (0, parcelRequire("cRtpB")).emptyObject), defaultSelectedIndex: defaultSelectedIndex = 0, selectedIndex: selectedIndex, label: label = 'pagination', pageLabel: pageLabel = 'page', previousLabel: previousLabel = 'previous', nextLabel: nextLabel = 'next', style: style = (0, (0, parcelRequire("cRtpB")).emptyObject), max: max = 7, onChange: onChange = (0, (0, parcelRequire("gCBvJ")).default), pages: pages, getPageLabel: getPageLabel, renderEllipsis: renderEllipsis = (0, (0, parcelRequire("ashNT")).default), analyticsContext: analyticsContext, testId: testId, isDisabled: isDisabled }, ref) {
        const [selectedIndexValue, setSelectedIndexValue] = (0, (0, parcelRequire("cI4Vd")).default)(selectedIndex, ()=>defaultSelectedIndex || 0);
        const onChangeWithAnalytics = (0, (0, parcelRequire("2cjvv")).usePlatformLeafEventHandler)({
            fn: (value, analyticsEvent)=>{
                const { event: event, selectedPageIndex: selectedPageIndex } = value;
                if (selectedIndex === undefined) setSelectedIndexValue(selectedPageIndex);
                if (onChange) onChange(event, pages[selectedPageIndex], analyticsEvent);
            },
            action: 'changed',
            actionSubject: 'pageNumber',
            analyticsData: analyticsContext,
            ...$bffd94785d620cef$var$analyticsAttributes
        });
        const transform = (page, currPageIndex, testId)=>{
            const selectedPage = pages[selectedIndexValue];
            const pageIndexLabel = `${pageLabel} ${getPageLabel ? getPageLabel(page, currPageIndex) : page}`;
            const isCurrentPage = page === selectedPage;
            return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("fm763")).default), {
                as: "li",
                xcss: $bffd94785d620cef$var$paginationMenuItemStyles,
                key: `page-${getPageLabel ? getPageLabel(page, currPageIndex) : currPageIndex}`
            }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("eqjqY")).default), {
                component: components.Page,
                onClick: (event)=>onChangeWithAnalytics({
                        event: event,
                        selectedPageIndex: currPageIndex
                    }),
                "aria-current": isCurrentPage ? 'page' : undefined,
                "aria-label": pageIndexLabel,
                isSelected: isCurrentPage,
                isDisabled: isDisabled,
                page: page,
                testId: testId && `${testId}--${isCurrentPage ? 'current-' : ''}page-${currPageIndex}`
            }, getPageLabel ? getPageLabel(page, currPageIndex) : page));
        };
        return ((0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("6Ll2T")).default), {
            testId: testId,
            style: style,
            ref: ref,
            "aria-label": label,
            as: "nav"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("fm763")).default), {
            space: "space.0",
            alignBlock: "center"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("aYK2t")).default), {
            key: "left-navigator",
            component: components.Previous,
            onClick: (event)=>onChangeWithAnalytics({
                    event: event,
                    selectedPageIndex: selectedIndexValue - 1
                }),
            isDisabled: isDisabled || selectedIndexValue === 0,
            iconBefore: (0, ($parcel$interopDefault($5uXOq))).createElement($bffd94785d620cef$var$NavigatorIcon, {
                chevronDirection: "left"
            }),
            "aria-label": previousLabel,
            testId: testId && `${testId}--left-navigator`
        }), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("fm763")).default), {
            space: "space.0",
            alignBlock: "baseline",
            as: "ul",
            xcss: $bffd94785d620cef$var$paginationMenuStyles
        }, (0, (0, parcelRequire("55OLU")).default)(pages, selectedIndexValue, {
            max: max,
            ellipsis: renderEllipsis,
            transform: transform
        }, testId)), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("aYK2t")).default), {
            key: "right-navigator",
            component: components.Next,
            onClick: (event)=>onChangeWithAnalytics({
                    event: event,
                    selectedPageIndex: selectedIndexValue + 1
                }),
            isDisabled: isDisabled || selectedIndexValue === pages.length - 1,
            iconBefore: (0, ($parcel$interopDefault($5uXOq))).createElement($bffd94785d620cef$var$NavigatorIcon, {
                chevronDirection: "right"
            }),
            "aria-label": nextLabel,
            testId: testId && `${testId}--right-navigator`
        }))));
    }
    const $bffd94785d620cef$var$Pagination = (0, $5uXOq.memo)((0, $5uXOq.forwardRef)($bffd94785d620cef$var$InnerPagination));
    var $bffd94785d620cef$export$2e2bcd8739ae039 = $bffd94785d620cef$var$Pagination;
});
parcelRegister("asmPY", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $79ce3be6fdbee77d$var$_react = $79ce3be6fdbee77d$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $79ce3be6fdbee77d$var$_chevronLeft = $79ce3be6fdbee77d$var$_interopRequireDefault((parcelRequire("fY25f")));
    var $79ce3be6fdbee77d$var$_chevronLeftLarge = $79ce3be6fdbee77d$var$_interopRequireDefault((parcelRequire("f7JN7")));
    function $79ce3be6fdbee77d$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $79ce3be6fdbee77d$var$ChevronLeftIcon = (props)=>$79ce3be6fdbee77d$var$_react.default.createElement($79ce3be6fdbee77d$var$_chevronLeft.default, Object.assign({
            LEGACY_fallbackIcon: $79ce3be6fdbee77d$var$_chevronLeftLarge.default
        }, props));
    $79ce3be6fdbee77d$var$ChevronLeftIcon.Name = 'ChevronLeftIconMigration';
    var $79ce3be6fdbee77d$var$_default = module.exports.default = $79ce3be6fdbee77d$var$ChevronLeftIcon;
});
parcelRegister("fY25f", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $b9fe135dcc94eb49$var$_react = $b9fe135dcc94eb49$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $b9fe135dcc94eb49$var$_UNSAFE_baseNew = $b9fe135dcc94eb49$var$_interopRequireDefault((parcelRequire("dTInF")));
    function $b9fe135dcc94eb49$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $b9fe135dcc94eb49$var$ChevronLeftIcon = (props)=>$b9fe135dcc94eb49$var$_react.default.createElement($b9fe135dcc94eb49$var$_UNSAFE_baseNew.default, Object.assign({
            dangerouslySetGlyph: `<path stroke="currentcolor" stroke-linejoin="round" stroke-width="1.5" d="M7.5 10.5 3 6l4.5-4.5"/>`,
            type: 'utility'
        }, props));
    $b9fe135dcc94eb49$var$ChevronLeftIcon.displayName = 'ChevronLeftIcon';
    var $b9fe135dcc94eb49$var$_default = module.exports.default = $b9fe135dcc94eb49$var$ChevronLeftIcon;
});
parcelRegister("f7JN7", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $b02b07a3c9f0c0ab$var$_react = $b02b07a3c9f0c0ab$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $7p1ve;
    var $b02b07a3c9f0c0ab$var$_chevronLeft = $b02b07a3c9f0c0ab$var$_interopRequireDefault((parcelRequire("fY25f")));
    function $b02b07a3c9f0c0ab$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $b02b07a3c9f0c0ab$var$ChevronLeftLargeIcon = (props)=>$b02b07a3c9f0c0ab$var$_react.default.createElement((0, parcelRequire("7p1ve")).IconFacade, Object.assign({
            dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="m9.005 10.995 4.593-4.593a.99.99 0 1 1 1.4 1.4l-3.9 3.9 3.9 3.9a.99.99 0 0 1-1.4 1.4L9.005 12.41a1 1 0 0 1 0-1.414"/></svg>`
        }, props, {
            newIcon: $b02b07a3c9f0c0ab$var$_chevronLeft.default,
            iconType: "utility"
        }));
    $b02b07a3c9f0c0ab$var$ChevronLeftLargeIcon.displayName = 'ChevronLeftLargeIcon';
    var $b02b07a3c9f0c0ab$var$_default = module.exports.default = $b02b07a3c9f0c0ab$var$ChevronLeftLargeIcon;
});
parcelRegister("80QIn", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $5d5736e094bab377$var$_react = $5d5736e094bab377$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $5d5736e094bab377$var$_chevronRight = $5d5736e094bab377$var$_interopRequireDefault((parcelRequire("jkePi")));
    var $5d5736e094bab377$var$_chevronRightLarge = $5d5736e094bab377$var$_interopRequireDefault((parcelRequire("4T92P")));
    function $5d5736e094bab377$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $5d5736e094bab377$var$ChevronRightIcon = (props)=>$5d5736e094bab377$var$_react.default.createElement($5d5736e094bab377$var$_chevronRight.default, Object.assign({
            LEGACY_fallbackIcon: $5d5736e094bab377$var$_chevronRightLarge.default
        }, props));
    $5d5736e094bab377$var$ChevronRightIcon.Name = 'ChevronRightIconMigration';
    var $5d5736e094bab377$var$_default = module.exports.default = $5d5736e094bab377$var$ChevronRightIcon;
});
parcelRegister("4T92P", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $38f3508bf8b7f617$var$_react = $38f3508bf8b7f617$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $7p1ve;
    var $38f3508bf8b7f617$var$_chevronRight = $38f3508bf8b7f617$var$_interopRequireDefault((parcelRequire("jkePi")));
    function $38f3508bf8b7f617$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $38f3508bf8b7f617$var$ChevronRightLargeIcon = (props)=>$38f3508bf8b7f617$var$_react.default.createElement((0, parcelRequire("7p1ve")).IconFacade, Object.assign({
            dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="M14.995 10.995a1 1 0 0 1 0 1.414l-4.593 4.593a.99.99 0 0 1-1.4-1.4l3.9-3.9-3.9-3.9a.99.99 0 0 1 1.4-1.4z"/></svg>`
        }, props, {
            newIcon: $38f3508bf8b7f617$var$_chevronRight.default,
            iconType: "utility"
        }));
    $38f3508bf8b7f617$var$ChevronRightLargeIcon.displayName = 'ChevronRightLargeIcon';
    var $38f3508bf8b7f617$var$_default = module.exports.default = $38f3508bf8b7f617$var$ChevronRightLargeIcon;
});
parcelRegister("aYK2t", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$5a32ad5907d466ce$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $2APCZ;
    function $5a32ad5907d466ce$export$2e2bcd8739ae039(props) {
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("2APCZ")).default), {
            "aria-label": props['aria-label'],
            isDisabled: props.isDisabled,
            iconBefore: props.iconBefore,
            testId: props.testId,
            onClick: props.onClick,
            component: props.component,
            appearance: "subtle"
        });
    }
});
parcelRegister("eqjqY", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$b6c146866dbb414e$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $2APCZ;
    function $b6c146866dbb414e$export$2e2bcd8739ae039(props) {
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("2APCZ")).default), {
            ...props,
            appearance: "subtle"
        });
    }
});
parcelRegister("ashNT", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$bff36923574c1b9a$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $6Ll2T;
    var $ZuPvl;
    var $99gde;
    var $AHUyh;
    const $bff36923574c1b9a$var$containerStyles = (0, (0, parcelRequire("99gde")).xcss)({
        display: 'flex',
        position: 'relative'
    });
    function $bff36923574c1b9a$export$2e2bcd8739ae039({ key: key, testId: testId, from: from, to: to }) {
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("6Ll2T")).default), {
            as: "li",
            testId: testId,
            key: key,
            xcss: $bff36923574c1b9a$var$containerStyles,
            paddingInline: "space.100"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("ZuPvl")).default), {
            testId: testId && `${testId}-text`
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("AHUyh")).default), null, "Skipped pages from ", from, " to ", to), "\u2026"));
    }
});
parcelRegister("cRtpB", function(module, exports) {
    $parcel$export(module.exports, "emptyObject", ()=>$3caf0da65b4820eb$export$3f860eba1218f8d3);
    const $3caf0da65b4820eb$export$3f860eba1218f8d3 = {};
});
parcelRegister("55OLU", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$605acaae51a91016$export$2e2bcd8739ae039);
    var $8QpSo;
    const $605acaae51a91016$var$collapseRange = (pages, current, { max: max, ellipsis: ellipsis, transform: transform }, testId)=>{
        const total = pages.length;
        const needEllipsis = total > max;
        const hasStartEllipsis = needEllipsis && max - 4 < current;
        const hasEndEllipsis = needEllipsis && current < total - max + 3;
        const getPageComponents = (0, (0, parcelRequire("8QpSo")).default)((startIndex = 0, lastIndex = total)=>{
            return pages.slice(startIndex, lastIndex).map((page, index)=>transform(page, startIndex + index, testId));
        });
        if (!needEllipsis) return getPageComponents(0, total);
        if (hasStartEllipsis && !hasEndEllipsis) {
            const pageCount = max - 2;
            return [
                ...getPageComponents(0, 1),
                ellipsis({
                    key: 'ellipsis-1',
                    testId: testId && `${testId}-ellipsis`,
                    from: 2,
                    to: total - pageCount
                }),
                ...getPageComponents(total - pageCount)
            ];
        }
        if (!hasStartEllipsis && hasEndEllipsis) {
            const pageCount = max - 2;
            return [
                ...getPageComponents(0, pageCount),
                ellipsis({
                    key: 'ellipsis-1',
                    testId: testId && `${testId}-ellipsis`,
                    from: pageCount + 1,
                    to: total - 1
                }),
                ...getPageComponents(total - 1)
            ];
        }
        const pageCount = max - 4;
        return [
            ...getPageComponents(0, 1),
            ellipsis({
                key: 'ellipsis-1',
                testId: testId && `${testId}-ellipsis`,
                from: 2,
                to: current - Math.floor(pageCount / 2)
            }),
            ...getPageComponents(current - Math.floor(pageCount / 2), current + pageCount - 1),
            ellipsis({
                key: 'ellipsis-2',
                testId: testId && `${testId}-ellipsis`,
                from: current + 3,
                to: total - 1
            }),
            ...getPageComponents(total - 1)
        ];
    };
    var $605acaae51a91016$export$2e2bcd8739ae039 = $605acaae51a91016$var$collapseRange;
});
parcelRegister("e29Bd", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$256ac7e407d97c05$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $aGjCX;
    var $cp6ND;
    var $2dlI8;
    var $kLXOj;
    class $256ac7e407d97c05$var$TableHead extends (0, ($parcel$interopDefault($5uXOq))).Component {
        UNSAFE_componentWillMount() {
            (0, (0, parcelRequire("aGjCX")).validateSortKey)(this.props.sortKey, this.props.head);
        }
        UNSAFE_componentWillReceiveProps(nextProps) {
            if (this.props.sortKey !== nextProps.sortKey || this.props.head !== nextProps.head) (0, (0, parcelRequire("aGjCX")).validateSortKey)(nextProps.sortKey, nextProps.head);
        }
        render() {
            const { head: head, sortKey: sortKey, sortOrder: sortOrder, isFixedSize: isFixedSize, onSort: onSort, isRanking: isRanking, isRankable: isRankable, testId: testId } = this.props;
            if (!head) return null;
            const HeadCellComponent = isRankable ? (0, (0, parcelRequire("2dlI8")).default) : (0, (0, parcelRequire("kLXOj")).default);
            const { cells: cells, ...rest } = head;
            return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("cp6ND")).Head), {
                ...rest,
                isRanking: isRanking,
                testId: testId && `${testId}--head`
            }, (0, ($parcel$interopDefault($5uXOq))).createElement("tr", null, cells.map((cell, index)=>{
                const { colSpan: colSpan, content: content, isSortable: isSortable, key: key, shouldTruncate: shouldTruncate, testId: cellTestId, width: width, ...restCellProps } = cell;
                return (0, ($parcel$interopDefault($5uXOq))).createElement(HeadCellComponent, {
                    colSpan: colSpan,
                    content: content,
                    isFixedSize: isFixedSize,
                    isSortable: !!isSortable,
                    isRanking: isRanking,
                    key: key || index,
                    onClick: isSortable ? onSort(cell) : undefined,
                    testId: cellTestId || testId,
                    shouldTruncate: shouldTruncate,
                    sortOrder: key === sortKey ? sortOrder : undefined,
                    width: width,
                    ...restCellProps
                });
            })));
        }
    }
    var $256ac7e407d97c05$export$2e2bcd8739ae039 = $256ac7e407d97c05$var$TableHead;
});
parcelRegister("cp6ND", function(module, exports) {
    $parcel$export(module.exports, "Head", ()=>$7a324f86902d232b$export$e93312b7773dfcac);
    $parcel$export(module.exports, "HeadCell", ()=>$7a324f86902d232b$export$4e8024263ace498b);
    var $5uXOq = parcelRequire("5uXOq");
    var $f8Sb3;
    var $v0afU;
    var $iqCjf;
    function $7a324f86902d232b$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
        return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
    }
    const $7a324f86902d232b$var$CSS_VAR_TEXT_COLOR = '--local-dynamic-table-text-color';
    const $7a324f86902d232b$var$rankingStyles = {
        name: "4zleql",
        styles: "display:block"
    };
    const $7a324f86902d232b$var$headStyles = (0, (0, parcelRequire("f8Sb3")).css)({
        borderBlockEnd: `none`
    });
    const $7a324f86902d232b$export$e93312b7773dfcac = ({ isRanking: isRanking, testId: testId, ...props })=>{
        return (0, (0, parcelRequire("f8Sb3")).jsx)("thead", {
            css: [
                $7a324f86902d232b$var$headStyles,
                isRanking && $7a324f86902d232b$var$rankingStyles
            ],
            "data-testid": testId,
            ...props
        });
    };
    const $7a324f86902d232b$var$headCellBaseStyles = (0, (0, parcelRequire("f8Sb3")).css)({
        boxSizing: 'border-box',
        position: 'relative',
        border: 'none',
        borderBlockEnd: `2px solid ${(0, (0, parcelRequire("v0afU")).tableBorder).borderColor}`,
        color: `var(--ds-text-subtle, ${`var(${$7a324f86902d232b$var$CSS_VAR_TEXT_COLOR})`})`,
        font: "var(--ds-font-body-UNSAFE_small, normal 400 12px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)",
        fontWeight: "var(--ds-font-weight-bold, 700)",
        textAlign: 'left',
        verticalAlign: 'top',
        '&:focus-visible': {
            outline: `solid 2px ${`var(--ds-border-focused, ${(0, $72ba03e317f3d228$export$ecfc1dff386a3e7a)})`}`
        }
    });
    const $7a324f86902d232b$var$onClickStyles = (0, (0, parcelRequire("f8Sb3")).css)({
        '&:hover': {
            backgroundColor: `var(--ds-background-neutral-hovered, ${(0, $72ba03e317f3d228$export$920c0d5c49070351)})`,
            cursor: 'pointer'
        }
    });
    const $7a324f86902d232b$var$baseStyles = (0, (0, parcelRequire("f8Sb3")).css)({
        '& > button': {
            padding: "var(--ds-space-0, 0)",
            position: 'relative',
            appearance: 'none',
            background: 'none',
            border: 'none',
            color: 'inherit',
            cursor: 'inherit',
            fontSize: 'inherit',
            fontWeight: 'inherit',
            '&::before, &::after': {
                display: 'block',
                width: 0,
                height: 0,
                position: 'absolute',
                border: '3px solid transparent',
                content: '""',
                insetInlineEnd: "var(--ds-space-negative-100, -8px)"
            },
            '&::before': {
                borderBlockEnd: `3px solid ${(0, (0, parcelRequire("v0afU")).arrow).defaultColor}`,
                insetBlockEnd: "var(--ds-space-100, 8px)"
            },
            '&::after': {
                borderBlockStart: `3px solid ${(0, (0, parcelRequire("v0afU")).arrow).defaultColor}`,
                insetBlockEnd: 0
            }
        },
        '@media (forced-colors: active)': {
            '& > button': {
                '&::before, &::after': {
                    border: `3px solid ${(0, (0, parcelRequire("v0afU")).MSThemeColors).Background}`
                },
                '&::before': {
                    borderBlockEnd: `3px solid ${(0, (0, parcelRequire("v0afU")).MSThemeColors).Text}`
                },
                '&::after': {
                    borderBlockStart: `3px solid ${(0, (0, parcelRequire("v0afU")).MSThemeColors).Text}`
                }
            }
        }
    });
    const $7a324f86902d232b$var$ascendingStyles = (0, (0, parcelRequire("f8Sb3")).css)({
        '& > button': {
            '&::before': {
                borderBlockEnd: `3px solid ${(0, (0, parcelRequire("v0afU")).arrow).selectedColor}`
            }
        },
        '@media (forced-colors: active)': {
            '& > button': {
                '&::before': {
                    borderBlockEnd: `3px solid ${(0, (0, parcelRequire("v0afU")).MSThemeColors).SelectedBackground}`
                }
            }
        }
    });
    const $7a324f86902d232b$var$descendingStyles = (0, (0, parcelRequire("f8Sb3")).css)({
        '& > button': {
            '&::after': {
                borderBlockStart: `3px solid ${(0, (0, parcelRequire("v0afU")).arrow).selectedColor}`
            }
        },
        '@media (forced-colors: active)': {
            '& > button': {
                '&::after': {
                    borderBlockStart: `3px solid ${(0, (0, parcelRequire("v0afU")).MSThemeColors).SelectedBackground}`
                }
            }
        }
    });
    const $7a324f86902d232b$export$4e8024263ace498b = (0, $5uXOq.forwardRef)(({ width: width, children: children, isSortable: isSortable, sortOrder: sortOrder, isFixedSize: isFixedSize, shouldTruncate: shouldTruncate, onClick: onClick, style: style, testId: testId, ...rest }, ref)=>{
        const mergedStyles = {
            ...style,
            ...width && (0, (0, parcelRequire("iqCjf")).getTruncationStyleVars)({
                width: width
            }),
            [$7a324f86902d232b$var$CSS_VAR_TEXT_COLOR]: (0, (0, parcelRequire("v0afU")).head).textColor
        };
        const isASC = sortOrder === (0, $a96aa7f4f3ce56d4$export$1dee026a19752d6b);
        const isDESC = sortOrder === (0, $a96aa7f4f3ce56d4$export$b6abcf7fa1d94f65);
        const getFormattedSortOrder = ()=>{
            if (isASC) return 'ascending';
            else if (isDESC) return 'descending';
        };
        const Component = children ? 'th' : 'td';
        return (0, (0, parcelRequire("f8Sb3")).jsx)(Component, {
            "aria-sort": getFormattedSortOrder(),
            style: mergedStyles,
            css: [
                (0, (0, parcelRequire("iqCjf")).cellStyles),
                $7a324f86902d232b$var$headCellBaseStyles,
                onClick && $7a324f86902d232b$var$onClickStyles,
                (0, (0, parcelRequire("iqCjf")).truncationWidthStyles),
                isFixedSize && shouldTruncate && (0, (0, parcelRequire("iqCjf")).fixedSizeTruncateStyles),
                isFixedSize && (0, (0, parcelRequire("iqCjf")).overflowTruncateStyles),
                isSortable && $7a324f86902d232b$var$baseStyles,
                isASC && $7a324f86902d232b$var$ascendingStyles,
                isDESC && $7a324f86902d232b$var$descendingStyles
            ],
            onClick: onClick,
            ref: ref,
            "data-testid": testId,
            ...rest
        }, children);
    });
});
parcelRegister("2dlI8", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$c5a1089e3027a848$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $epIxA;
    var $aGjCX;
    var $kLXOj;
    class $c5a1089e3027a848$var$RankableTableHeadCellComponent extends (0, ($parcel$interopDefault($5uXOq))).Component {
        render() {
            const { isRanking: isRanking, refHeight: refHeight, refWidth: refWidth, ...restProps } = this.props;
            const inlineStyles = (0, (0, parcelRequire("aGjCX")).inlineStylesIfRanking)(isRanking, refWidth);
            return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("kLXOj")).default), {
                inlineStyles: inlineStyles,
                ...restProps
            });
        }
    }
    const $c5a1089e3027a848$var$RankableTableHeadCell = (0, (0, parcelRequire("epIxA")).default)($c5a1089e3027a848$var$RankableTableHeadCellComponent);
    var $c5a1089e3027a848$export$2e2bcd8739ae039 = $c5a1089e3027a848$var$RankableTableHeadCell;
});
parcelRegister("epIxA", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$8dda015132e24d01$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    function $8dda015132e24d01$export$2e2bcd8739ae039(WrappedComponent) {
        return class WithDimensions extends (0, ($parcel$interopDefault($5uXOq))).Component {
            UNSAFE_componentWillReceiveProps(nextProps) {
                const wasRanking = this.props.isRanking;
                const willRanking = nextProps.isRanking;
                if (willRanking && !wasRanking) this.updateDimensions();
            }
            render() {
                const { refWidth: refWidth, refHeight: refHeight } = this.state;
                return (0, ($parcel$interopDefault($5uXOq))).createElement(WrappedComponent, {
                    refWidth: refWidth,
                    refHeight: refHeight,
                    innerRef: this.innerRef,
                    ...this.props
                });
            }
            constructor(...args){
                super(...args);
                this.state = {
                    refWidth: 0,
                    refHeight: 0
                };
                this.innerRef = (ref)=>{
                    if (ref && !this.props.isRanking) this.ref = ref;
                };
                this.updateDimensions = ()=>{
                    if (!this.ref) return;
                    const clientRect = this.ref.getBoundingClientRect();
                    const { width: width } = clientRect;
                    const { height: height } = clientRect;
                    if (width !== this.state.refWidth || height !== this.state.refHeight) this.setState({
                        refWidth: width,
                        refHeight: height
                    });
                };
            }
        };
    }
});
parcelRegister("kLXOj", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$77b969a5244946d0$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $cp6ND;
    const $77b969a5244946d0$var$TableHeadCell = ({ content: content, inlineStyles: inlineStyles, testId: testId, isRanking: isRanking, innerRef: innerRef, isSortable: isSortable, onClick: onClick, ...rest })=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("cp6ND")).HeadCell), {
            style: inlineStyles,
            testId: testId && `${testId}--head--cell`,
            ref: typeof innerRef !== 'string' ? innerRef : null,
            ...rest,
            onClick: onClick,
            isSortable: isSortable
        }, isSortable ? (0, ($parcel$interopDefault($5uXOq))).createElement("button", {
            type: "button",
            "aria-roledescription": "Sort button"
        }, content) : content);
    };
    var $77b969a5244946d0$export$2e2bcd8739ae039 = $77b969a5244946d0$var$TableHeadCell;
});
parcelRegister("1G9i6", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("cM9em"),
        $6fhBS("fr9NE"),
        $6fhBS("dcsW0")
    ]).then(()=>parcelRequire('l5pwz'));
});
parcelRegister("1Wmg5", function(module, exports) {
    $parcel$export(module.exports, "ActionsDropdownComponent", ()=>$6b730499ec95cc8f$export$74d7a11ad6f814bb);
    var $5uXOq = parcelRequire("5uXOq");
    var $9jNMw;
    var $iriM5;
    var $lUP1Q;
    var $6ESxT;
    var $hxbUj;
    const $6b730499ec95cc8f$export$74d7a11ad6f814bb = ({ actions: actions })=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("iriM5")).default), {
            trigger: ({ triggerRef: triggerRef, ...props })=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("9jNMw")).default), {
                    ...props,
                    onClick: (event)=>{
                        event.stopPropagation();
                        event.preventDefault();
                        if (props.onClick) props.onClick(event);
                    },
                    appearance: "subtle",
                    icon: (0, ($parcel$interopDefault((0, parcelRequire("hxbUj"))))),
                    label: "Actions",
                    ref: triggerRef,
                    spacing: "compact"
                }),
            shouldRenderToParent: true,
            spacing: "compact"
        }, actions && actions.map((actionItem)=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("6ESxT")).default), null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("lUP1Q")).default), {
                onClick: (event)=>{
                    event.stopPropagation();
                    event.preventDefault();
                    actionItem.action();
                }
            }, actionItem.name))));
    };
});
parcelRegister("lUP1Q", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$f4df1eec061f00ce$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $jXXts;
    var $3IisA;
    var $6iX1e;
    var $2uy6c;
    var $2oS3b;
    var $dIGjU;
    const $f4df1eec061f00ce$var$DropdownMenuItem = (0, $5uXOq.forwardRef)(({ children: children, component: component, description: description, elemAfter: elemAfter, elemBefore: elemBefore, href: href, isDisabled: isDisabled, isSelected: isSelected, onClick: onClick, rel: rel, shouldDescriptionWrap: shouldDescriptionWrap = true, shouldTitleWrap: shouldTitleWrap = true, target: target, testId: testId, UNSAFE_shouldDisableRouterLink: UNSAFE_shouldDisableRouterLink, returnFocusRef: returnFocusRef, interactionName: interactionName, ...rest }, ref)=>{
        const itemRef = (0, (0, parcelRequire("dIGjU")).default)();
        const handleItemClick = (0, $5uXOq.useCallback)((event)=>{
            if (returnFocusRef?.current) returnFocusRef.current.focus();
            if (onClick) onClick(event);
        }, [
            onClick,
            returnFocusRef
        ]);
        if (component) return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("6iX1e")).default), {
            component: component,
            description: description,
            iconAfter: elemAfter,
            iconBefore: elemBefore,
            isDisabled: isDisabled,
            isSelected: isSelected,
            onClick: handleItemClick,
            ref: (0, (0, parcelRequire("jXXts")).default)([
                ref,
                itemRef
            ]),
            shouldDescriptionWrap: shouldDescriptionWrap,
            shouldTitleWrap: shouldTitleWrap,
            testId: testId,
            href: href,
            target: target,
            rel: rel,
            ...(0, (0, parcelRequire("2oS3b")).fg)('platform_button_item-add-ufo-metrics') && {
                interactionName: interactionName
            },
            ...rest
        }, children);
        else if (href) return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("2uy6c")).default), {
            description: description,
            href: href,
            iconAfter: elemAfter,
            iconBefore: elemBefore,
            isDisabled: isDisabled,
            isSelected: isSelected,
            onClick: handleItemClick,
            ref: (0, (0, parcelRequire("jXXts")).default)([
                ref,
                itemRef
            ]),
            rel: rel,
            role: "menuitem",
            shouldDescriptionWrap: shouldDescriptionWrap,
            shouldTitleWrap: shouldTitleWrap,
            target: target,
            testId: testId,
            UNSAFE_shouldDisableRouterLink: UNSAFE_shouldDisableRouterLink,
            ...(0, (0, parcelRequire("2oS3b")).fg)('platform_button_item-add-ufo-metrics') && {
                interactionName: interactionName
            },
            ...rest
        }, children);
        else return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("3IisA")).default), {
            description: description,
            iconAfter: elemAfter,
            iconBefore: elemBefore,
            isDisabled: isDisabled,
            isSelected: isSelected,
            onClick: handleItemClick,
            ref: (0, (0, parcelRequire("jXXts")).default)([
                ref,
                itemRef
            ]),
            role: "menuitem",
            shouldDescriptionWrap: shouldDescriptionWrap,
            shouldTitleWrap: shouldTitleWrap,
            testId: testId,
            target: target,
            rel: rel,
            ...(0, (0, parcelRequire("2oS3b")).fg)('platform_button_item-add-ufo-metrics') && {
                interactionName: interactionName
            },
            ...rest
        }, children);
    });
    var $f4df1eec061f00ce$export$2e2bcd8739ae039 = $f4df1eec061f00ce$var$DropdownMenuItem;
});
parcelRegister("6ESxT", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$e37f61b5921ce569$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $bkJDg;
    var $pbV7V;
    var $3c7E2;
    const $e37f61b5921ce569$var$DropdownMenuItemGroup = (0, $5uXOq.forwardRef)(({ children: children, id: id, isList: isList, isScrollable: isScrollable, title: title, testId: testId, hasSeparator: hasSeparator, overrides: overrides, ...rest }, ref)=>{
        const uid = (0, (0, parcelRequire("bkJDg")).useId)();
        const titleId = `dropdown-menu-item-group-title-${uid}`;
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("pbV7V")).default), {
            id: id,
            ref: ref,
            isList: isList,
            isScrollable: isScrollable,
            hasSeparator: hasSeparator,
            testId: testId,
            titleId: title ? titleId : undefined,
            overrides: overrides,
            ...rest
        }, title && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("3c7E2")).default), {
            id: titleId,
            title: title
        }), children);
    });
    var $e37f61b5921ce569$export$2e2bcd8739ae039 = $e37f61b5921ce569$var$DropdownMenuItemGroup;
});
parcelRegister("fXCGY", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$d5628dfd60d96e3f$export$2e2bcd8739ae039);
    var $7VHMR;
    var $d5628dfd60d96e3f$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        reportTableHeading: {
            id: 'spa-apps-servicedesk-reports-home-page.list-view.report-table-heading',
            defaultMessage: 'Title',
            description: 'Table column 1 heading'
        },
        categoruTableHeading: {
            id: 'spa-apps-servicedesk-reports-home-page.list-view.categoru-table-heading',
            defaultMessage: 'Type',
            description: 'Table column 2 heading'
        },
        actionsTableHeading: {
            id: 'spa-apps-servicedesk-reports-home-page.list-view.actions-table-heading',
            defaultMessage: 'Actions',
            description: 'Table column 3 heading'
        }
    });
});
parcelRegister("aJUlH", function(module, exports) {
    $parcel$export(module.exports, "ThumbnailView", ()=>$5edfd2e461c855c1$export$f06e14e146c0b896);
    var $5uXOq = parcelRequire("5uXOq");
    var $koVbs;
    var $2oKQq;
    var $cZ1Pf;
    var $6Ll2T;
    var $99gde;
    var $ir3H0 = parcelRequire("ir3H0");
    var $dRAh1;
    var $69Hc7;
    const $5edfd2e461c855c1$var$RenderSection = ({ sectionName: sectionName, reports: reports, id: id, emptyState: emptyState })=>{
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("6Ll2T")).default), {
            xcss: $5edfd2e461c855c1$var$sectionContainer
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("cZ1Pf")).default), {
            size: "small"
        }, sectionName), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("6Ll2T")).default), {
            xcss: $5edfd2e461c855c1$var$cardsContainer
        }, reports.length === 0 ? (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("2oKQq")).default), {
            header: emptyState?.heading ? emptyState.heading : formatMessage((0, (0, parcelRequire("69Hc7")).default).defaultReportsEmptyStateTitle),
            description: emptyState?.description ? emptyState.description : formatMessage((0, (0, parcelRequire("69Hc7")).default).defaultReportsEmptyStateDescription),
            headingLevel: 4,
            imageUrl: emptyState?.imageUrl ? emptyState.imageUrl : (0, ($parcel$interopDefault($ir3H0)))
        }) : (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, reports.map((report, i)=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dRAh1")).ThumbnailCard), {
                key: i,
                ...report
            })))));
    };
    const $5edfd2e461c855c1$export$f06e14e146c0b896 = ({ reportsConfig: reportsConfig })=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, reportsConfig.map((section)=>(0, ($parcel$interopDefault($5uXOq))).createElement($5edfd2e461c855c1$var$RenderSection, {
                key: section.id,
                ...section
            })));
    const $5edfd2e461c855c1$var$sectionContainer = (0, (0, parcelRequire("99gde")).xcss)({
        marginTop: "var(--ds-space-300, 24px)",
        display: 'flex',
        flexDirection: 'column',
        gap: "var(--ds-space-200, 16px)"
    });
    const $5edfd2e461c855c1$var$cardsContainer = (0, (0, parcelRequire("99gde")).xcss)({
        display: 'flex',
        flexDirection: 'row',
        gap: "var(--ds-space-200, 16px)",
        alignItems: 'flex-start',
        flexWrap: 'wrap'
    });
});
parcelRegister("ir3H0", function(module, exports) {
    module.exports = new URL("no-reports.a067b4c9.svg", import.meta.url).toString();
});
parcelRegister("dRAh1", function(module, exports) {
    $parcel$export(module.exports, "ThumbnailCard", ()=>$6ca3395e3f03d286$export$c48469f77510fecd);
    var $5uXOq = parcelRequire("5uXOq");
    var $euzYv;
    var $jRBku;
    var $6Ll2T;
    var $fm763;
    var $ZuPvl;
    var $99gde;
    var $loZC0;
    var $1Wmg5;
    const $6ca3395e3f03d286$export$c48469f77510fecd = ({ id: id, thumbnail: thumbnail, title: title, link: link, actions: actions })=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("jRBku")).default), {
            href: link,
            appearance: "subtle"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("6Ll2T")).default), {
            xcss: $6ca3395e3f03d286$var$container
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("6Ll2T")).default), {
            xcss: $6ca3395e3f03d286$var$imageContainer
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("euzYv")).default), {
            src: thumbnail,
            alt: title
        })), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("6Ll2T")).default), {
            xcss: $6ca3395e3f03d286$var$contentContainer
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("fm763")).default), {
            grow: "fill",
            xcss: $6ca3395e3f03d286$var$thumbnailNameAndActionStyles
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("6Ll2T")).default), null, title.length > 25 ? (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("loZC0")).default), {
            content: title,
            position: "bottom"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("ZuPvl")).default), {
            maxLines: 1,
            size: "medium",
            weight: "bold"
        }, title)) : (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("ZuPvl")).default), {
            maxLines: 1,
            size: "medium",
            weight: "bold"
        }, title)), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("6Ll2T")).default), {
            xcss: $6ca3395e3f03d286$var$actionsDropdownWrapper
        }, actions && actions?.length > 0 && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("1Wmg5")).ActionsDropdownComponent), {
            actions: actions
        }))))));
    };
    const $6ca3395e3f03d286$var$container = (0, (0, parcelRequire("99gde")).xcss)({
        display: 'flex',
        width: '244px',
        minWidth: '244px',
        flexDirection: 'column',
        justifyContent: 'flex-start',
        borderRadius: "var(--ds-space-050, 4px)",
        cursor: 'pointer',
        outline: `1px solid ${"var(--ds-background-accent-gray-subtler, #DCDFE4)"}`,
        ':hover': {
            outline: `2px solid ${"var(--ds-link, #0C66E4)"}`
        }
    });
    const $6ca3395e3f03d286$var$imageContainer = (0, (0, parcelRequire("99gde")).xcss)({
        width: '100%',
        height: '127px',
        background: "var(--ds-background-accent-gray-subtler, #DCDFE4)"
    });
    const $6ca3395e3f03d286$var$contentContainer = (0, (0, parcelRequire("99gde")).xcss)({
        borderTop: `1px solid ${"var(--ds-border, #091E4224)"}`,
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'flex-start',
        padding: 'space.200'
    });
    const $6ca3395e3f03d286$var$thumbnailNameAndActionStyles = (0, (0, parcelRequire("99gde")).xcss)({
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center'
    });
    const $6ca3395e3f03d286$var$actionsDropdownWrapper = (0, (0, parcelRequire("99gde")).xcss)({
        display: 'flex',
        alignItems: 'center',
        height: '20px',
        maxHeight: '20px'
    });
});
parcelRegister("69Hc7", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$796cfa847fda1989$export$2e2bcd8739ae039);
    var $7VHMR;
    var $796cfa847fda1989$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        customReportsEmptyStateDescription: {
            id: 'spa-apps-servicedesk-reports-home-page.thumbnail-view.custom-reports-empty-state-description',
            defaultMessage: "It looks like you\u2019ve not gained permission to custom reports yet. When your account admin adds you, we\u2019ll list them here.",
            description: 'Empty State description'
        },
        defaultReportsEmptyStateDescription: {
            id: 'spa-apps-servicedesk-reports-home-page.thumbnail-view.default-reports-empty-state-description',
            defaultMessage: "It looks like you\u2019ve not gained permission to default reports yet. When your account admin adds you, we\u2019ll list them here.",
            description: 'Empty State description'
        },
        customReportsEmptyStateTitle: {
            id: 'spa-apps-servicedesk-reports-home-page.thumbnail-view.custom-reports-empty-state-title',
            defaultMessage: 'Start creating custom reports',
            description: 'Empty State description'
        },
        defaultReportsEmptyStateTitle: {
            id: 'spa-apps-servicedesk-reports-home-page.thumbnail-view.default-reports-empty-state-title',
            defaultMessage: "Default reports aren\u2019t available",
            description: 'Empty State description'
        }
    });
});
parcelRegister("1d0Vr", function(module, exports) {
    $parcel$export(module.exports, "useReportsHomePageController", ()=>$52151005a61006f0$export$3e3935874a94a79b);
    var $5uXOq = parcelRequire("5uXOq");
    const $52151005a61006f0$export$3e3935874a94a79b = (reportsConfig)=>{
        const [searchValue, setSearchValue] = (0, $5uXOq.useState)('');
        const [filteredReportsConfig, setFilteredReportsConfig] = (0, $5uXOq.useState)(reportsConfig);
        (0, $5uXOq.useEffect)(()=>{
            setFilteredReportsConfig(reportsConfig);
        }, [
            reportsConfig,
            setFilteredReportsConfig
        ]);
        const searchForReport = (0, $5uXOq.useCallback)((event)=>{
            if (event.type !== 'change') return;
            const value = event.target.value;
            setSearchValue(value);
            let filteredResult = reportsConfig.map((config)=>{
                const searchResults = {
                    ...config
                };
                searchResults.reports = config.reports.filter((report)=>report.title.toLowerCase().includes(value.toLowerCase()));
                return searchResults;
            });
            filteredResult = filteredResult.filter((config)=>config.reports.length > 0);
            setFilteredReportsConfig(filteredResult);
        }, [
            reportsConfig,
            setSearchValue,
            setFilteredReportsConfig
        ]);
        return {
            searchForReport: searchForReport,
            searchValue: searchValue,
            filteredReportsConfig: filteredReportsConfig
        };
    };
});
parcelRegister("1odkE", function(module, exports) {
    $parcel$export(module.exports, "messages", ()=>$269de92b662479c6$export$defe85febe8b728c);
    var $7VHMR;
    const $269de92b662479c6$export$defe85febe8b728c = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        reportsTitle: {
            id: 'jsm.jsm-reports-common.reports-home-page.reports-title',
            defaultMessage: 'Reports',
            description: 'Title for the page'
        },
        searchPlaceholder: {
            id: 'jsm.jsm-reports-common.reports-home-page.search-placeholder',
            defaultMessage: 'Search for reports',
            description: 'Placeholder for searchbox'
        },
        dropdownTrigger: {
            id: 'jsm.jsm-reports-common.reports-home-page.dropdown-trigger',
            defaultMessage: 'Select a team',
            description: 'Dropdown trigger'
        },
        swithcToListViewButton: {
            id: 'jsm.jsm-reports-common.reports-home-page.switch-to-list-view-button',
            defaultMessage: 'Switch to list view',
            description: 'Button to switch to list view'
        },
        swithcToCardViewButton: {
            id: 'jsm.jsm-reports-common.reports-home-page.swithc-to-card-view-button',
            defaultMessage: 'Switch to card view',
            description: 'Button to switch to card view'
        },
        noAccessEmptyStateHeader: {
            id: 'jsm.jsm-reports-common.reports-home-page.no-access-empty-state-header',
            defaultMessage: "Reports aren\u2019t available",
            description: 'Empty State header'
        },
        noAccessEmptyStateDescription: {
            id: 'jsm.jsm-reports-common.reports-home-page.no-access-empty-state-description',
            defaultMessage: "It looks like you\u2019ve not gained permission to reports yet. When your account admin adds you to reports, we\u2019ll list them here.",
            description: 'Empty State description'
        },
        searchEmptyStateTitle: {
            id: 'jsm.jsm-reports-common.reports-home-page.search-empty-state-title',
            defaultMessage: "We couldn\u2019t find anything matching your search",
            description: 'Empty State title'
        },
        searchEmptyStateDescription: {
            id: 'jsm.jsm-reports-common.reports-home-page.search-empty-state-description',
            defaultMessage: 'Try again with a different term',
            description: 'Empty State title'
        }
    });
});
parcelRegister("k0laR", function(module, exports) {
    $parcel$export(module.exports, "useReportsHomePageController", ()=>$9c15ba9493e825bd$export$3e3935874a94a79b);
    var $5uXOq = parcelRequire("5uXOq");
    var $4Pf62;
    var $koVbs;
    var $c2JIK;
    var $eYYbM;
    var $y8WG5;
    var $jaWUd;
    var $hqBSi;
    var $bqdsR = parcelRequire("bqdsR");
    var $2VXpL = parcelRequire("2VXpL");
    var $76jxc = parcelRequire("76jxc");
    var $jyoiO = parcelRequire("jyoiO");
    var $9f96G = parcelRequire("9f96G");
    var $3dINR;
    var $jSYl6;
    const $9c15ba9493e825bd$export$3e3935874a94a79b = (projectKey)=>{
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        const [loading, setLoading] = (0, $5uXOq.useState)(true);
        const [reportsConfig, setReportsConfig] = (0, $5uXOq.useState)([]);
        const { data: defaultReports, loading: defaultReportsLoading } = (0, (0, parcelRequire("y8WG5")).useReportFeatures)({
            route: (0, (0, parcelRequire("jaWUd")).servicedeskReports1Route),
            matchParams: {
                projectKey: projectKey
            }
        });
        const licensedProducts = (0, (0, parcelRequire("hqBSi")).useLicensedProducts)();
        const shouldShowAtlassianAnalytics = licensedProducts[(0, (0, parcelRequire("4Pf62")).LICENSED_PRODUCTS).ATLASSIAN_ANALYTICS];
        const { data: initialCustomReportsFromSidebarConfig, loading: customReportsLoading } = (0, (0, parcelRequire("eYYbM")).useCustomReports)();
        const getDefaultReports = (0, $5uXOq.useCallback)((features)=>{
            const reports = [];
            let defaultReportsAccess = false;
            if (features.hasWorkload) {
                defaultReportsAccess = true;
                reports.push({
                    link: (0, (0, parcelRequire("c2JIK")).createReportUrl)(projectKey, '/workload'),
                    thumbnail: (0, ($parcel$interopDefault($9f96G))),
                    title: formatMessage((0, (0, parcelRequire("jSYl6")).default).workload)
                });
            }
            if (features.hasSatisfaction) {
                defaultReportsAccess = true;
                reports.push({
                    link: (0, (0, parcelRequire("c2JIK")).createReportUrl)(projectKey, '/all-rating'),
                    thumbnail: (0, ($parcel$interopDefault($jyoiO))),
                    title: formatMessage((0, (0, parcelRequire("jSYl6")).default).satisfaction)
                });
            }
            if (features.hasRequestsDeflected) {
                defaultReportsAccess = true;
                reports.push({
                    link: (0, (0, parcelRequire("c2JIK")).createReportUrl)(projectKey, '/kb-requests-deflected'),
                    thumbnail: (0, ($parcel$interopDefault($2VXpL))),
                    title: formatMessage((0, (0, parcelRequire("jSYl6")).default).requestsDeflected)
                });
            }
            if (features.hasRequestsDeflected) {
                defaultReportsAccess = true;
                reports.push({
                    link: (0, (0, parcelRequire("c2JIK")).createReportUrl)(projectKey, '/kb-requests-resolved'),
                    thumbnail: (0, ($parcel$interopDefault($76jxc))),
                    title: formatMessage((0, (0, parcelRequire("jSYl6")).default).requestsResolved)
                });
            }
            if (shouldShowAtlassianAnalytics) {
                defaultReportsAccess = true;
                reports.push({
                    link: (0, (0, parcelRequire("c2JIK")).createReportUrl)(projectKey, '/atlassian-analytics'),
                    thumbnail: (0, ($parcel$interopDefault($bqdsR))),
                    title: formatMessage((0, (0, parcelRequire("jSYl6")).default).analytics)
                });
            }
            return {
                id: (0, (0, parcelRequire("3dINR")).REPORT_TYPE).DEFAULT,
                sectionName: formatMessage((0, (0, parcelRequire("jSYl6")).default).defaultReportsTitle),
                reports: reports,
                access: defaultReportsAccess
            };
        }, [
            formatMessage,
            projectKey,
            shouldShowAtlassianAnalytics
        ]);
        const getCustomReportsConfig = (0, $5uXOq.useCallback)((config)=>{
            const reports = config.map((report)=>({
                    link: __SPA__ ? report.url.replace(/^\/projects/, '/jira/servicedesk/projects') : report.url,
                    thumbnail: (0, ($parcel$interopDefault($bqdsR))),
                    title: report.name
                }));
            return {
                id: (0, (0, parcelRequire("3dINR")).REPORT_TYPE).CUSTOM,
                sectionName: formatMessage((0, (0, parcelRequire("jSYl6")).default).customReportsTitle),
                reports: reports,
                access: reports.length > 0
            };
        }, [
            formatMessage
        ]);
        (0, $5uXOq.useEffect)(()=>{
            if (customReportsLoading || defaultReportsLoading) return;
            const config = [];
            if (defaultReports) config.push(getDefaultReports(defaultReports));
            if (initialCustomReportsFromSidebarConfig) config.push(getCustomReportsConfig(initialCustomReportsFromSidebarConfig));
            setReportsConfig(config);
        }, [
            customReportsLoading,
            defaultReportsLoading,
            defaultReports,
            initialCustomReportsFromSidebarConfig,
            getDefaultReports,
            setReportsConfig,
            getCustomReportsConfig
        ]);
        (0, $5uXOq.useEffect)(()=>{
            setLoading(customReportsLoading || defaultReportsLoading);
        }, [
            customReportsLoading,
            defaultReportsLoading,
            setLoading
        ]);
        return {
            reportsConfig: reportsConfig,
            loading: loading
        };
    };
});
parcelRegister("eYYbM", function(module, exports) {
    $parcel$export(module.exports, "useCustomReports", ()=>$fe826eecf5ba2b29$export$40ce6c46d343d75f);
    var $5uXOq = parcelRequire("5uXOq");
    var $aQGK8;
    var $01b4Y;
    const $fe826eecf5ba2b29$export$40ce6c46d343d75f = ()=>{
        const { data: data, loading: loading } = (0, (0, parcelRequire("aQGK8")).useJiraServiceManagementReportsNavigation)();
        const extractedData = (0, $5uXOq.useMemo)(()=>data && (0, (0, parcelRequire("01b4Y")).getCustomReports)(data), [
            data
        ]);
        return {
            data: extractedData,
            loading: loading
        };
    };
});
parcelRegister("01b4Y", function(module, exports) {
    $parcel$export(module.exports, "getCustomReports", ()=>$834e3ba61dbfadb5$export$a8c10e0a09026b31);
    const $834e3ba61dbfadb5$export$a8c10e0a09026b31 = (data)=>{
        const customReports = data.customReports?.map((report)=>({
                id: `com.atlassian.servicedesk:reports-nav-${report.id}`,
                name: report.name,
                url: report.url
            }));
        return customReports || [];
    };
});
parcelRegister("bqdsR", function(module, exports) {
    module.exports = new URL("custom-reports.800596fa.svg", import.meta.url).toString();
});
parcelRegister("2VXpL", function(module, exports) {
    module.exports = new URL("requests-deflected.5f7b3322.svg", import.meta.url).toString();
});
parcelRegister("76jxc", function(module, exports) {
    module.exports = new URL("requests-resolved.11ae9621.svg", import.meta.url).toString();
});
parcelRegister("jyoiO", function(module, exports) {
    module.exports = new URL("satisfaction.c6f70195.svg", import.meta.url).toString();
});
parcelRegister("9f96G", function(module, exports) {
    module.exports = new URL("workload.10f63c26.svg", import.meta.url).toString();
});
parcelRegister("3dINR", function(module, exports) {
    $parcel$export(module.exports, "REPORT_TYPE", ()=>$5400138f83202c8a$export$258957993bf2c8b);
    const $5400138f83202c8a$export$c5ccaba974d9b5b6 = 'THUMBNAIL';
    const $5400138f83202c8a$export$9586318477fbfa73 = 'LIST';
    const $5400138f83202c8a$export$a513ea61a7bee91c = {
        ALL_REPORTS: 'All Reports',
        DEFAULT: 'Default Reports',
        CUSTOM: 'Custom Reports'
    };
    const $5400138f83202c8a$export$258957993bf2c8b = {
        DEFAULT: 'DEFAULT',
        CUSTOM: 'CUSTOM'
    };
});
parcelRegister("jSYl6", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$2cf7dda823f3171e$export$2e2bcd8739ae039);
    var $7VHMR;
    var $2cf7dda823f3171e$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        defaultReportsTitle: {
            "id": "spa-apps-servicedesk-reports-home-page.controllers.home-page-controller.default-reports-title",
            "defaultMessage": "Default"
        },
        customReportsTitle: {
            "id": "spa-apps-servicedesk-reports-home-page.controllers.home-page-controller.custom-reports-title",
            "defaultMessage": "Custom"
        },
        workload: {
            "id": "spa-apps-servicedesk-reports-home-page.controllers.home-page-controller.workload",
            "defaultMessage": "Workload"
        },
        satisfaction: {
            "id": "spa-apps-servicedesk-reports-home-page.controllers.home-page-controller.satisfaction",
            "defaultMessage": "Satisfaction"
        },
        requestsDeflected: {
            "id": "spa-apps-servicedesk-reports-home-page.controllers.home-page-controller.requests-deflected",
            "defaultMessage": "Requests deflected"
        },
        requestsResolved: {
            "id": "spa-apps-servicedesk-reports-home-page.controllers.home-page-controller.requests-resolved",
            "defaultMessage": "Requests resolved"
        },
        analytics: {
            "id": "spa-apps-servicedesk-reports-home-page.controllers.home-page-controller.analytics",
            "defaultMessage": "Atlassian Analytics"
        }
    });
});
parcelRegister("6PXzk", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$a90c080e3af69139$export$2e2bcd8739ae039);
    var $7VHMR;
    var $a90c080e3af69139$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        searchPlaceholder: {
            "id": "spa-apps-servicedesk-reports-home-page.search-placeholder",
            "defaultMessage": "Search for reports"
        },
        swithcToListViewButton: {
            "id": "spa-apps-servicedesk-reports-home-page.swithc-to-list-view-button",
            "defaultMessage": "Switch to list view"
        },
        swithcToCardViewButton: {
            "id": "spa-apps-servicedesk-reports-home-page.swithc-to-card-view-button",
            "defaultMessage": "Switch to card view"
        },
        emptyStateHeader: {
            "id": "spa-apps-servicedesk-reports-home-page.empty-state-header",
            "defaultMessage": "Reports aren\u2019t available"
        },
        emptyStateDescription: {
            "id": "spa-apps-servicedesk-reports-home-page.empty-state-description",
            "defaultMessage": "It looks like you\u2019ve not gained permission to reports yet. When your account admin adds you to reports, we\u2019ll list them here."
        },
        searchEmptyStateTitle: {
            "id": "spa-apps-servicedesk-reports-home-page.search-empty-state-title",
            "defaultMessage": "We couldn\u2019t find anything matching your search"
        },
        searchEmptyStateDescription: {
            "id": "spa-apps-servicedesk-reports-home-page.search-empty-state-description",
            "defaultMessage": "Try again with a different term"
        }
    });
});
